var $ = 7.56;
var A = 8.09;
var B = 7.89;
var C = 8.59;
var D = 8.72;
var E = 7.16;
var F = 6.88;
var G = 8.97;
var H = 8.91;
var I = 3.22;
var J = 6.47;
var K = 7.91;
var L = 6.83;
var M = 10.5;
var N = 8.91;
var O = 9.27;
var P = 7.63;
var Q = 9.27;
var R = 7.84;
var S = 7.66;
var T = 7.61;
var U = 8.86;
var V = 8.09;
var W = 11.63;
var X = 8.16;
var Y = 7.88;
var Z = 7.95;
var _ = 7.02;
var a = 6.63;
var b = 7.38;
var c = 6.72;
var d = 7.38;
var e = 6.86;
var f = 4.34;
var g = 7.31;
var h = 7.06;
var i = 2.97;
var j = 2.97;
var k = 6.52;
var l = 3.05;
var m = 10.45;
var n = 7.02;
var o = 7.09;
var p = 7.33;
var q = 7.31;
var r = 4.58;
var s = 6.28;
var t = 4.36;
var u = 7.02;
var v = 6.52;
var w = 9.3;
var x = 6.3;
var y = 6.52;
var z = 6.47;
var characterWidths = {
	"0": 7.56,
	"1": 5.58,
	"2": 7.25,
	"3": 7.53,
	"4": 7.73,
	"5": 7.42,
	"6": 7.64,
	"7": 6.84,
	"8": 7.67,
	"9": 7.64,
	" ": 3.38,
	"...": 10.69,
	"…": 9.66,
	"": 0,
	"!": 3.73,
	"\"": 5.73,
	"#": 7.56,
	$: $,
	"%": 11.11,
	"&": 8.55,
	"(": 4.59,
	")": 4.59,
	"*": 5.67,
	",": 3.56,
	"-": 5.67,
	".": 3.56,
	"/": 3.66,
	":": 3.56,
	";": 3.56,
	"<": 7.56,
	">": 7.56,
	"?": 6.16,
	"@": 11.02,
	A: A,
	B: B,
	C: C,
	D: D,
	E: E,
	F: F,
	G: G,
	H: H,
	I: I,
	J: J,
	K: K,
	L: L,
	M: M,
	N: N,
	O: O,
	P: P,
	Q: Q,
	R: R,
	S: S,
	T: T,
	U: U,
	V: V,
	W: W,
	X: X,
	Y: Y,
	Z: Z,
	"[": 4.59,
	"\\": 3.66,
	"]": 4.59,
	"^": 7.56,
	_: _,
	"`": 6,
	a: a,
	b: b,
	c: c,
	d: d,
	e: e,
	f: f,
	g: g,
	h: h,
	i: i,
	j: j,
	k: k,
	l: l,
	m: m,
	n: n,
	o: o,
	p: p,
	q: q,
	r: r,
	s: s,
	t: t,
	u: u,
	v: v,
	w: w,
	x: x,
	y: y,
	z: z,
	"{": 4.59,
	"|": 3.11,
	"}": 4.59,
	"~": 7.56,
	"": 12.27,
	"€": 7.56,
	"�": 12.41,
	"‚": 3.56,
	"ƒ": 4.34,
	"„": 5.52,
	"†": 6.23,
	"‡": 6.23,
	"ˆ": 6,
	"‰": 15.63,
	"Š": 7.66,
	"‹": 5.34,
	"Œ": 13.63,
	"Ž": 7.95,
	"‘": 3.56,
	"’": 3.56,
	"“": 5.52,
	"”": 5.52,
	"•": 5.67,
	"–": 7.02,
	"—": 10.5,
	"˜": 6,
	"™": 10.02,
	"š": 6.28,
	"›": 5.34,
	"œ": 11.66,
	"ž": 6.47,
	"Ÿ": 7.88,
	"Ā": 8.09,
	"ā": 6.63,
	"Ă": 8.09,
	"ă": 6.63,
	"Ą": 8.09,
	"ą": 6.63,
	"Ć": 8.59,
	"ć": 6.72,
	"Ĉ": 8.59,
	"ĉ": 6.72,
	"Ċ": 8.59,
	"ċ": 6.72,
	"Č": 8.59,
	"č": 6.72,
	"Ď": 8.72,
	"ď": 8.44,
	"Đ": 9.08,
	"đ": 7.72,
	"Ē": 7.16,
	"ē": 6.86,
	"Ĕ": 7.16,
	"ĕ": 6.86,
	"Ė": 7.16,
	"ė": 6.86,
	"Ę": 7.16,
	"ę": 6.86,
	"Ě": 7.16,
	"ě": 6.86,
	"Ĝ": 8.97,
	"ĝ": 7.31,
	"Ğ": 8.97,
	"ğ": 7.31,
	"Ġ": 8.97,
	"ġ": 7.31,
	"Ģ": 8.97,
	"ģ": 7.31,
	"Ĥ": 8.91,
	"ĥ": 7.06,
	"Ħ": 9.63,
	"ħ": 7.41,
	"Ĩ": 3.22,
	"ĩ": 2.97,
	"Ī": 3.22,
	"ī": 2.97,
	"Ĭ": 3.22,
	"ĭ": 2.97,
	"Į": 3.22,
	"į": 2.97,
	"İ": 3.22,
	"ı": 2.97,
	"Ĳ": 9.67,
	"ĳ": 5.94,
	"Ĵ": 6.47,
	"ĵ": 2.97,
	"Ķ": 7.91,
	"ķ": 6.52,
	"ĸ": 6.53,
	"Ĺ": 6.83,
	"ĺ": 3.05,
	"Ļ": 6.83,
	"ļ": 3.05,
	"Ľ": 6.83,
	"ľ": 4.09,
	"Ŀ": 6.83,
	"ŀ": 4.41,
	"Ł": 6.78,
	"ł": 3.83,
	"Ń": 8.91,
	"ń": 7.02,
	"Ņ": 8.91,
	"ņ": 7.02,
	"Ň": 8.91,
	"ň": 7.02,
	"ŉ": 7.97,
	"Ŋ": 8.91,
	"ŋ": 7.02,
	"Ō": 9.27,
	"ō": 7.09,
	"Ŏ": 9.27,
	"ŏ": 7.09,
	"Ő": 9.27,
	"ő": 7.09,
	"Ŕ": 7.84,
	"ŕ": 4.58,
	"Ŗ": 7.84,
	"ŗ": 4.58,
	"Ř": 7.84,
	"ř": 4.58,
	"Ś": 7.66,
	"ś": 6.28,
	"Ŝ": 7.66,
	"ŝ": 6.28,
	"Ş": 7.66,
	"ş": 6.28,
	"Ţ": 7.61,
	"ţ": 4.36,
	"Ť": 7.61,
	"ť": 4.36,
	"Ŧ": 7.61,
	"ŧ": 4.67,
	"Ũ": 8.86,
	"ũ": 7.02,
	"Ū": 8.86,
	"ū": 7.02,
	"Ŭ": 8.86,
	"ŭ": 7.02,
	"Ů": 8.86,
	"ů": 7.02,
	"Ű": 8.86,
	"ű": 7.02,
	"Ų": 8.86,
	"ų": 7.02,
	"Ŵ": 11.63,
	"ŵ": 9.3,
	"Ŷ": 7.88,
	"ŷ": 6.52,
	"Ź": 7.95,
	"ź": 6.47,
	"Ż": 7.95,
	"ż": 6.47,
	"ſ": 4.34,
	"ƀ": 6.69,
	"Ɓ": 9.25,
	"Ƃ": 8.02,
	"ƃ": 6.69,
	"Ƅ": 8.17,
	"ƅ": 6.73,
	"Ɔ": 8.67,
	"Ƈ": 8.31,
	"ƈ": 6.45,
	"Ɖ": 8.67,
	"Ɗ": 10.08,
	"Ƌ": 8.02,
	"ƌ": 6.69,
	"ƍ": 6.81,
	"Ǝ": 7.16,
	"Ə": 8.83,
	"Ɛ": 6.42,
	"Ƒ": 6.88,
	"Ɠ": 8.44,
	"Ɣ": 7.11,
	"ƕ": 10.92,
	"Ɩ": 2.67,
	"Ɨ": 4.3,
	"Ƙ": 7.91,
	"ƙ": 6.52,
	"ƚ": 4.09,
	"ƛ": 6.66,
	"Ɯ": 12.8,
	"Ɲ": 8.67,
	"ƞ": 6.69,
	"Ɵ": 9.27,
	"Ơ": 9.27,
	"ơ": 7.09,
	"Ƣ": 9.64,
	"ƣ": 7.72,
	"Ƥ": 8.13,
	"ƥ": 7.56,
	"Ʀ": 7.66,
	"Ƨ": 8.02,
	"ƨ": 6,
	"Ʃ": 7.83,
	"ƪ": 6.33,
	"ƫ": 4.5,
	"Ƭ": 7.53,
	"ƭ": 4.5,
	"Ʈ": 7.34,
	"Ư": 8.86,
	"ư": 7.34,
	"Ʊ": 9.06,
	"Ʋ": 8.56,
	"Ƴ": 7.48,
	"ƴ": 8.06,
	"Ƶ": 7.34,
	"ƶ": 5.77,
	"Ʒ": 7.19,
	"Ƹ": 6.59,
	"ƹ": 6,
	"ƺ": 6.22,
	"ƻ": 6.8,
	"Ƽ": 7.59,
	"ƽ": 5.7,
	"ƾ": 5.5,
	"ƿ": 7.27,
	"ǀ": 2.97,
	"ǁ": 5.19,
	"ǂ": 5.58,
	"ǃ": 3.11,
	"Ǆ": 16.67,
	"ǅ": 15.19,
	"ǆ": 13.84,
	"Ǉ": 13.28,
	"ǈ": 9.78,
	"ǉ": 6,
	"Ǌ": 15.38,
	"ǋ": 11.88,
	"ǌ": 9.97,
	"Ǎ": 8.09,
	"ǎ": 6.63,
	"Ǐ": 3.22,
	"ǐ": 2.97,
	"Ǒ": 9.27,
	"ǒ": 7.09,
	"Ǔ": 8.86,
	"ǔ": 7.02,
	"Ǖ": 8.86,
	"ǖ": 7.02,
	"Ǘ": 8.86,
	"ǘ": 7.02,
	"Ǚ": 8.86,
	"ǚ": 7.02,
	"Ǜ": 8.86,
	"ǜ": 7.02,
	"ǝ": 6.98,
	"Ǟ": 8.09,
	"ǟ": 6.63,
	"Ǡ": 8.09,
	"ǡ": 6.63,
	"Ǣ": 11.53,
	"ǣ": 10.84,
	"Ǥ": 9.13,
	"ǥ": 7.63,
	"Ǧ": 8.97,
	"ǧ": 7.31,
	"Ǩ": 7.91,
	"ǩ": 6.52,
	"Ǫ": 9.27,
	"ǫ": 7.09,
	"Ǭ": 9.27,
	"ǭ": 7.09,
	"Ǯ": 6.45,
	"ǯ": 5.88,
	"ǰ": 2.97,
	"Ǳ": 16.67,
	"ǲ": 15.19,
	"ǳ": 13.84,
	"Ǵ": 8.97,
	"ǵ": 7.31,
	"Ƕ": 12.33,
	"Ƿ": 8.02,
	"Ǹ": 8.91,
	"ǹ": 7.02,
	"Ǻ": 8.09,
	"ǻ": 6.63,
	"Ǽ": 11.53,
	"ǽ": 10.84,
	"Ǿ": 9.23,
	"ǿ": 7.09,
	"Ȁ": 8.09,
	"ȁ": 6.63,
	"Ȃ": 8.09,
	"ȃ": 6.63,
	"Ȅ": 7.16,
	"ȅ": 6.86,
	"Ȇ": 7.16,
	"ȇ": 6.86,
	"Ȉ": 3.22,
	"ȉ": 2.97,
	"Ȋ": 3.22,
	"ȋ": 2.97,
	"Ȍ": 9.27,
	"ȍ": 7.09,
	"Ȏ": 9.27,
	"ȏ": 7.09,
	"Ȑ": 7.84,
	"ȑ": 4.58,
	"Ȓ": 7.84,
	"ȓ": 4.58,
	"Ȕ": 8.86,
	"ȕ": 7.02,
	"Ȗ": 8.86,
	"ȗ": 7.02,
	"Ș": 7.66,
	"ș": 6.28,
	"Ț": 7.61,
	"ț": 4.36,
	"Ȝ": 7.97,
	"ȝ": 7.97,
	"Ȟ": 8.91,
	"ȟ": 7.06,
	"Ȣ": 9.27,
	"ȣ": 7.38,
	"Ȥ": 7.27,
	"ȥ": 6.89,
	"Ȧ": 8.09,
	"ȧ": 6.63,
	"Ȩ": 7.16,
	"ȩ": 6.86,
	"Ȫ": 9.27,
	"ȫ": 7.09,
	"Ȭ": 9.27,
	"ȭ": 7.09,
	"Ȯ": 9.27,
	"ȯ": 7.09,
	"Ȱ": 9.27,
	"ȱ": 7.09,
	"Ȳ": 7.88,
	"ȳ": 6.52,
	"ɐ": 6.63,
	"ɑ": 7.38,
	"ɒ": 7.38,
	"ɓ": 7.38,
	"ɔ": 6.72,
	"ɕ": 6.72,
	"ɖ": 7.38,
	"ɗ": 7.38,
	"ɘ": 6.86,
	"ə": 6.98,
	"ɚ": 9.17,
	"ɛ": 6.2,
	"ɜ": 6.2,
	"ɝ": 8.34,
	"ɞ": 7.39,
	"ɟ": 4,
	"ɠ": 7.31,
	"ɡ": 7.31,
	"ɢ": 6.98,
	"ɣ": 6.52,
	"ɤ": 5.97,
	"ɥ": 7.06,
	"ɦ": 7.06,
	"ɧ": 7.06,
	"ɨ": 3.81,
	"ɩ": 3.61,
	"ɪ": 4.63,
	"ɫ": 4.48,
	"ɬ": 4.78,
	"ɭ": 3.05,
	"ɮ": 9.5,
	"ɯ": 10.45,
	"ɰ": 10.45,
	"ɱ": 10.45,
	"ɲ": 7.02,
	"ɳ": 7.02,
	"ɴ": 7.31,
	"ɵ": 7.09,
	"ɶ": 10.72,
	"ɷ": 9.31,
	"ɸ": 8.67,
	"ɹ": 4.58,
	"ɺ": 4.58,
	"ɻ": 4.58,
	"ɼ": 4.58,
	"ɽ": 4.58,
	"ɾ": 3.42,
	"ɿ": 3.42,
	"ʀ": 6.44,
	"ʁ": 6.44,
	"ʂ": 6.28,
	"ʃ": 4.92,
	"ʄ": 5.23,
	"ʅ": 4.92,
	"ʆ": 4.64,
	"ʇ": 4.36,
	"ʈ": 4.36,
	"ʉ": 7.83,
	"ʊ": 7.47,
	"ʋ": 6.78,
	"ʌ": 6.52,
	"ʍ": 9.3,
	"ʎ": 6.52,
	"ʏ": 6.5,
	"ʐ": 6.47,
	"ʑ": 6.64,
	"ʒ": 6.92,
	"ʓ": 6.8,
	"ʔ": 6.14,
	"ʕ": 6.14,
	"ʖ": 6.14,
	"ʗ": 6.72,
	"ʘ": 7.97,
	"ʙ": 6.94,
	"ʚ": 7.39,
	"ʛ": 7.5,
	"ʜ": 7.36,
	"ʝ": 4.61,
	"ʞ": 6.52,
	"ʟ": 5.63,
	"ʠ": 7.31,
	"ʡ": 5.42,
	"ʢ": 5.42,
	"ʣ": 13.34,
	"ʤ": 13.83,
	"ʥ": 13.5,
	"ʦ": 10.64,
	"ʧ": 9.28,
	"ʨ": 11.08,
	"ʩ": 11.34,
	"ʪ": 9.33,
	"ʫ": 9.05,
	"ʬ": 5.81,
	"ʭ": 6.64,
	"ʰ": 5,
	"ʱ": 5,
	"ʲ": 2.09,
	"ʳ": 2.02,
	"ʴ": 3.23,
	"ʵ": 2.66,
	"ʶ": 4.5,
	"ʷ": 6.58,
	"ʸ": 4.61,
	"ʹ": 2.47,
	"ʺ": 4.11,
	"ʻ": 3.13,
	"ʼ": 3.56,
	"ʽ": 2.67,
	"ʾ": 3.09,
	"ʿ": 3.09,
	"ˀ": 4.34,
	"ˁ": 3.34,
	"˂": 3.52,
	"˃": 3.52,
	"˄": 3.52,
	"˅": 3.52,
	"ˇ": 6,
	"ˈ": 2.16,
	"ˉ": 2.67,
	"ˊ": 4,
	"ˋ": 4,
	"ˌ": 2.16,
	"ˍ": 4,
	"ˎ": 4,
	"ˏ": 4,
	"ː": 3.05,
	"ˑ": 3.05,
	"˒": 2.5,
	"˓": 2.5,
	"˔": 3.52,
	"˕": 3.52,
	"˖": 3.52,
	"˗": 4,
	"˘": 6,
	"˙": 6,
	"˚": 6,
	"˛": 6,
	"˝": 0,
	"˞": 2.84,
	"˟": 3.52,
	"ˠ": 4.61,
	"ˡ": 1.34,
	"ˢ": 3,
	"ˣ": 3,
	"ˤ": 4.34,
	"˥": 4.95,
	"˦": 4.95,
	"˧": 4.95,
	"˨": 4.95,
	"˩": 4.95,
	"˪": 3.7,
	"˫": 3.7,
	"ˬ": 4,
	"˭": 4,
	"ˮ": 4,
	"̀": 1.75,
	"́": 0.52,
	"̂": 2.05,
	"̃": 2.05,
	"̄": 1.92,
	"̅": 5.41,
	"̆": 2.05,
	"̇": 0.7,
	"̈": 1.95,
	"̉": 1.22,
	"̊": 1.36,
	"̋": 1.66,
	"̌": 2.05,
	"̍": 3.64,
	"̎": 4.25,
	"̏": 3.03,
	"̐": 5.2,
	"̑": 2.05,
	"̒": 3.98,
	"̓": 1.09,
	"̔": 3.98,
	"̕": 0,
	"̖": 4.53,
	"̗": 4.53,
	"̘": 1.33,
	"̙": 1.33,
	"̚": 1.55,
	"̛": 0.59,
	"̜": 0.61,
	"̝": 1.55,
	"̞": 1.55,
	"̟": 1.55,
	"̠": 1.55,
	"̡": 3.86,
	"̢": 3.86,
	"̣": 0.7,
	"̤": 1.88,
	"̥": 1.2,
	"̦": 1.09,
	"̧": 1.11,
	"̨": 1.55,
	"̩": 0.39,
	"̪": 2.05,
	"̫": 6.81,
	"̬": 2.05,
	"̭": 2.05,
	"̮": 2.05,
	"̯": 2.05,
	"̰": 2.05,
	"̱": 1.92,
	"̲": 1.92,
	"̳": 5.41,
	"̴": 3.03,
	"̵": 2.59,
	"̶": 5.41,
	"̷": 1.67,
	"̸": 1.97,
	"̹": 0.61,
	"̺": 2.05,
	"̻": 2.05,
	"̼": 2.61,
	"̽": 1.39,
	"̾": 4.05,
	"̿": 5.41,
	"̀": 4.53,
	"́": 4.53,
	"͂": 5.2,
	"̓": 3.98,
	"̈́": 5.19,
	"ͅ": 4.36,
	"͆": 5.58,
	"͇": 5.23,
	"͈": 4.25,
	"͉": 4.22,
	"͊": 5.2,
	"͋": 5.2,
	"͌": 5.31,
	"͍": 8.44,
	"͎": 4.7,
	"͠": 10.31,
	"͡": 3.61,
	"͢": 11.42,
	"ʹ": 2.67,
	"͵": 2.67,
	"ͺ": 1.81,
	";": 3.56,
	"΄": 6,
	"΅": 6,
	"Ά": 8.09,
	"·": 3.56,
	"Έ": 8.72,
	"Ή": 10.48,
	"Ί": 4.78,
	"Ό": 10.03,
	"Ύ": 9.75,
	"Ώ": 10.52,
	"ΐ": 3.61,
	"Α": 8.09,
	"Β": 7.89,
	"Γ": 6.75,
	"Δ": 8.17,
	"Ε": 7.16,
	"Ζ": 7.95,
	"Η": 8.91,
	"Θ": 9.34,
	"Ι": 3.22,
	"Κ": 7.91,
	"Λ": 8.02,
	"Μ": 10.5,
	"Ν": 8.91,
	"Ξ": 7.88,
	"Ο": 9.27,
	"Π": 8.8,
	"Ρ": 7.63,
	"Σ": 7.83,
	"Τ": 7.61,
	"Υ": 7.88,
	"Φ": 10.06,
	"Χ": 8.16,
	"Ψ": 9.83,
	"Ω": 9.33,
	"Ϊ": 3.22,
	"Ϋ": 7.88,
	"ά": 7.45,
	"έ": 6.2,
	"ή": 7.38,
	"ί": 3.61,
	"ΰ": 6.66,
	"α": 7.45,
	"β": 7.27,
	"γ": 6.55,
	"δ": 6.89,
	"ε": 6.2,
	"ζ": 5.39,
	"η": 7.38,
	"θ": 7.08,
	"ι": 3.61,
	"κ": 6.89,
	"λ": 6.66,
	"μ": 7.38,
	"ν": 6.55,
	"ξ": 5.56,
	"ο": 7.09,
	"π": 8.05,
	"ρ": 7.14,
	"ς": 6.48,
	"σ": 7.61,
	"τ": 6.13,
	"υ": 6.66,
	"φ": 8.67,
	"χ": 6.42,
	"ψ": 8.14,
	"ω": 9.16,
	"ϊ": 3.61,
	"ϋ": 6.66,
	"ό": 7.09,
	"ύ": 6.66,
	"ώ": 9.16,
	"ϐ": 11.09,
	"ϑ": 11.09,
	"ϒ": 7.64,
	"ϓ": 10.48,
	"ϔ": 7.64,
	"ϕ": 11.09,
	"ϖ": 10.63,
	"ϗ": 6.69,
	"Ϛ": 7.92,
	"ϛ": 11.09,
	"Ϝ": 6.8,
	"ϝ": 5.58,
	"Ϟ": 6.55,
	"ϟ": 6.14,
	"Ϡ": 8,
	"ϡ": 9.58,
	"Ϣ": 10.69,
	"ϣ": 10,
	"Ϥ": 8.09,
	"ϥ": 6.69,
	"Ϧ": 8.09,
	"ϧ": 6,
	"Ϩ": 8.02,
	"ϩ": 8.02,
	"Ϫ": 7.31,
	"ϫ": 7.16,
	"Ϭ": 8.84,
	"ϭ": 6.66,
	"Ϯ": 5.58,
	"ϯ": 4.92,
	"ϰ": 6.69,
	"ϱ": 7.31,
	"ϲ": 6,
	"ϳ": 2.5,
	"Ѐ": 7.27,
	"Ё": 7.27,
	"Ђ": 10.08,
	"Ѓ": 6.8,
	"Є": 8.83,
	"Ѕ": 7.77,
	"І": 3.33,
	"Ї": 3.33,
	"Ј": 6.58,
	"Љ": 12.83,
	"Њ": 13.39,
	"Ћ": 10.72,
	"Ќ": 8.03,
	"Ѝ": 9.03,
	"Ў": 7.73,
	"Џ": 8.91,
	"А": 8.2,
	"Б": 7.63,
	"В": 8.02,
	"Г": 6.8,
	"Д": 8.91,
	"Е": 7.27,
	"Ж": 12.25,
	"З": 7.36,
	"И": 9.03,
	"Й": 9.03,
	"К": 8.03,
	"Л": 8.47,
	"М": 10.61,
	"Н": 9.03,
	"О": 9.38,
	"П": 8.91,
	"Р": 7.75,
	"С": 8.72,
	"Т": 7.73,
	"У": 7.73,
	"Ф": 9.97,
	"Х": 8.27,
	"Ц": 9.27,
	"Ч": 8.33,
	"Ш": 11.56,
	"Щ": 11.89,
	"Ъ": 9.22,
	"Ы": 10.73,
	"Ь": 7.69,
	"Э": 8.83,
	"Ю": 12.19,
	"Я": 8.06,
	"а": 6.75,
	"б": 7.27,
	"в": 6.58,
	"г": 5.58,
	"д": 7.36,
	"е": 6.98,
	"ж": 9.42,
	"з": 6.33,
	"и": 7.27,
	"й": 7.27,
	"к": 6.53,
	"л": 6.94,
	"м": 9.03,
	"н": 7.17,
	"о": 7.22,
	"п": 7.13,
	"р": 7.45,
	"с": 6.84,
	"т": 6.05,
	"у": 6.64,
	"ф": 8.89,
	"х": 6.42,
	"ц": 7.45,
	"ч": 6.83,
	"ш": 9.81,
	"щ": 10.16,
	"ъ": 7.34,
	"ы": 8.77,
	"ь": 6.2,
	"э": 6.84,
	"ю": 9.56,
	"я": 6.38,
	"ѐ": 6.98,
	"ё": 6.98,
	"ђ": 7.52,
	"ѓ": 5.58,
	"є": 6.84,
	"ѕ": 6.41,
	"і": 3.09,
	"ї": 3.09,
	"ј": 3.08,
	"љ": 10.11,
	"њ": 10.36,
	"ћ": 7.52,
	"ќ": 6.53,
	"ѝ": 7.27,
	"ў": 6.64,
	"џ": 7.13,
	"Ѡ": 10.52,
	"ѡ": 8.25,
	"Ѣ": 9.61,
	"ѣ": 7.11,
	"Ѥ": 12.22,
	"ѥ": 8.83,
	"Ѧ": 8.02,
	"ѧ": 6,
	"Ѩ": 11.41,
	"ѩ": 8.72,
	"Ѫ": 11.23,
	"ѫ": 8.75,
	"Ѭ": 12.52,
	"ѭ": 8.81,
	"Ѯ": 7.23,
	"ѯ": 6.52,
	"Ѱ": 9.98,
	"ѱ": 8.67,
	"Ѳ": 9.38,
	"ѳ": 7.22,
	"Ѵ": 9.17,
	"ѵ": 7,
	"Ѷ": 9.17,
	"ѷ": 7,
	"Ѹ": 15.34,
	"ѹ": 12.69,
	"Ѻ": 9.33,
	"ѻ": 7.38,
	"Ѽ": 10.52,
	"ѽ": 8.25,
	"Ѿ": 10.52,
	"ѿ": 8.25,
	"Ҁ": 8.05,
	"ҁ": 5.86,
	"҂": 7.55,
	"҃": 0,
	"҄": 0,
	"҅": 0,
	"҆": 0,
	"҈": 0,
	"҉": 0,
	"Ҍ": 8.06,
	"ҍ": 6.53,
	"Ҏ": 7.63,
	"ҏ": 7.45,
	"Ґ": 6.8,
	"ґ": 5.58,
	"Ғ": 7.17,
	"ғ": 5.91,
	"Ҕ": 7.88,
	"ҕ": 6.77,
	"Җ": 12.67,
	"җ": 9.83,
	"Ҙ": 7.36,
	"ҙ": 6.33,
	"Қ": 8.45,
	"қ": 6.81,
	"Ҝ": 8.73,
	"ҝ": 7.47,
	"Ҟ": 8.41,
	"ҟ": 6.86,
	"Ҡ": 9.56,
	"ҡ": 7.47,
	"Ң": 9.36,
	"ң": 7.5,
	"Ҥ": 12.44,
	"ҥ": 9.73,
	"Ҧ": 13.11,
	"ҧ": 10.88,
	"Ҩ": 11.69,
	"ҩ": 9.83,
	"Ҫ": 8.72,
	"ҫ": 6.84,
	"Ҭ": 7.73,
	"ҭ": 6.05,
	"Ү": 7.98,
	"ү": 6.52,
	"Ұ": 7.98,
	"ұ": 6.52,
	"Ҳ": 8.53,
	"ҳ": 6.73,
	"Ҵ": 11.03,
	"ҵ": 8.63,
	"Ҷ": 8.66,
	"ҷ": 7.16,
	"Ҹ": 8.67,
	"ҹ": 7.03,
	"Һ": 8.53,
	"һ": 7.19,
	"Ҽ": 10.34,
	"ҽ": 8.61,
	"Ҿ": 10.34,
	"ҿ": 8.61,
	"Ӏ": 3.33,
	"Ӂ": 12.25,
	"ӂ": 9.42,
	"Ӄ": 7.72,
	"ӄ": 6.47,
	"Ӈ": 9.03,
	"ӈ": 7.17,
	"Ӌ": 8.33,
	"ӌ": 6.83,
	"Ӑ": 8.2,
	"ӑ": 6.75,
	"Ӓ": 8.2,
	"ӓ": 6.75,
	"Ӕ": 11.53,
	"ӕ": 10.95,
	"Ӗ": 7.27,
	"ӗ": 6.98,
	"Ә": 8.95,
	"ә": 6.98,
	"Ӛ": 8.95,
	"ӛ": 6.98,
	"Ӝ": 12.25,
	"ӝ": 9.42,
	"Ӟ": 7.36,
	"ӟ": 6.33,
	"Ӡ": 7.19,
	"ӡ": 6.92,
	"Ӣ": 9.03,
	"ӣ": 7.27,
	"Ӥ": 9.03,
	"ӥ": 7.27,
	"Ӧ": 9.38,
	"ӧ": 7.22,
	"Ө": 9.38,
	"ө": 7.22,
	"Ӫ": 9.38,
	"ӫ": 7.22,
	"Ӭ": 8.83,
	"ӭ": 6.84,
	"Ӯ": 7.73,
	"ӯ": 6.64,
	"Ӱ": 7.73,
	"ӱ": 6.64,
	"Ӳ": 7.73,
	"ӳ": 6.64,
	"Ӵ": 8.33,
	"ӵ": 6.83,
	"Ӹ": 10.73,
	"ӹ": 8.77,
	"Ա": 9.98,
	"Բ": 8.36,
	"Գ": 9.11,
	"Դ": 9.17,
	"Ե": 8.36,
	"Զ": 8.05,
	"Է": 7.56,
	"Ը": 8.36,
	"Թ": 9.73,
	"Ժ": 9.19,
	"Ի": 8.44,
	"Լ": 4.95,
	"Խ": 9.83,
	"Ծ": 8.55,
	"Կ": 8.52,
	"Հ": 6.91,
	"Ձ": 7.8,
	"Ղ": 9.17,
	"Ճ": 8.27,
	"Մ": 9.66,
	"Յ": 7.53,
	"Ն": 7.55,
	"Շ": 7.86,
	"Ո": 8.7,
	"Չ": 7.61,
	"Պ": 9.53,
	"Ջ": 7.72,
	"Ռ": 9.67,
	"Ս": 8.7,
	"Վ": 9.45,
	"Տ": 6.86,
	"Ր": 8.08,
	"Ց": 8.03,
	"Ւ": 7.19,
	"Փ": 9.61,
	"Ք": 7.41,
	"Օ": 9.31,
	"Ֆ": 8.39,
	"ՙ": 2.55,
	"՚": 2.55,
	"՛": 2.55,
	"՜": 3.5,
	"՝": 2.55,
	"՞": 5.31,
	"՟": 4.98,
	"ա": 11.05,
	"բ": 7.17,
	"գ": 7.67,
	"դ": 7.7,
	"ե": 7.17,
	"զ": 7.2,
	"է": 5.7,
	"ը": 7.17,
	"թ": 8.03,
	"ժ": 7.31,
	"ի": 7.17,
	"լ": 3.19,
	"խ": 11.05,
	"ծ": 7.08,
	"կ": 7.17,
	"հ": 6.75,
	"ձ": 7.2,
	"ղ": 7.2,
	"ճ": 6.92,
	"մ": 7.23,
	"յ": 3.19,
	"ն": 7.2,
	"շ": 4.97,
	"ո": 7.17,
	"չ": 4.14,
	"պ": 11.05,
	"ջ": 6.22,
	"ռ": 7.44,
	"ս": 7.17,
	"վ": 7.19,
	"տ": 11.19,
	"ր": 7.17,
	"ց": 7.2,
	"ւ": 3.86,
	"փ": 11.19,
	"ք": 7.17,
	"օ": 7.02,
	"ֆ": 7.69,
	"և": 7.56,
	"։": 3.06,
	"֊": 5.3,
	"֑": 1.2,
	"֒": 1.38,
	"֓": 0.92,
	"֔": 0.55,
	"֕": 1.16,
	"֖": 0.88,
	"֗": 0.94,
	"֘": 1.53,
	"֙": 1.69,
	"֚": 0,
	"֛": 0.91,
	"֜": 1.14,
	"֝": 0,
	"֞": 2.03,
	"֟": 2.36,
	"֠": 0,
	"֡": 1,
	"֣": 0.88,
	"֤": 1.02,
	"֥": 0.75,
	"֦": 1.84,
	"֧": 0.89,
	"֨": 0.59,
	"֩": 2.27,
	"֪": 1.27,
	"֫": 1.02,
	"֬": 0.88,
	"֭": 0,
	"֮": 2.98,
	"֯": 0.78,
	"ְ": 0,
	"ֱ": 0,
	"ֲ": 0,
	"ֳ": 0,
	"ִ": 0,
	"ֵ": 0,
	"ֶ": 0,
	"ַ": 0,
	"ָ": 0,
	"ֹ": 0.22,
	"ֻ": 0,
	"ּ": 0,
	"ֽ": 0,
	"־": 5.23,
	"ֿ": 0,
	"׀": 3.77,
	"ׁ": 0.22,
	"ׂ": 0.22,
	"׃": 3.8,
	"ׄ": 0,
	"א": 7.69,
	"ב": 7.41,
	"ג": 5.45,
	"ד": 6.94,
	"ה": 8.22,
	"ו": 3.38,
	"ז": 5.22,
	"ח": 8.19,
	"ט": 8.06,
	"י": 3.38,
	"ך": 6.95,
	"כ": 6.3,
	"ל": 6.33,
	"ם": 8.19,
	"מ": 8.22,
	"ן": 3.38,
	"נ": 4.83,
	"ס": 7.84,
	"ע": 7.23,
	"ף": 7.73,
	"פ": 7.47,
	"ץ": 6.3,
	"צ": 6.55,
	"ק": 7.52,
	"ר": 6.95,
	"ש": 9.48,
	"ת": 8.78,
	"װ": 6.73,
	"ױ": 6.73,
	"ײ": 6.73,
	"׳": 3.23,
	"״": 5.7,
	"،": 2.92,
	"؛": 3.05,
	"؟": 6.03,
	"ء": 5.06,
	"آ": 2.86,
	"أ": 2.86,
	"ؤ": 5.42,
	"إ": 2.86,
	"ئ": 8.77,
	"ا": 2.86,
	"ب": 10.81,
	"ة": 5.25,
	"ت": 10.81,
	"ث": 10.81,
	"ج": 7.75,
	"ح": 7.75,
	"خ": 7.75,
	"د": 5.89,
	"ذ": 5.89,
	"ر": 4.22,
	"ز": 4.22,
	"س": 12.94,
	"ش": 12.94,
	"ص": 13.67,
	"ض": 13.67,
	"ط": 9.05,
	"ظ": 9.05,
	"ع": 7.14,
	"غ": 7.14,
	"ـ": 3.55,
	"ف": 10.89,
	"ق": 8.19,
	"ك": 9.77,
	"ل": 7.53,
	"م": 6.19,
	"ن": 7.39,
	"ه": 5.25,
	"و": 5.42,
	"ى": 8.77,
	"ي": 8.77,
	"ً": 0,
	"ٌ": 0,
	"ٍ": 0,
	"َ": 0,
	"ُ": 0,
	"ِ": 0,
	"ّ": 0,
	"ْ": 0,
	"ٓ": 0,
	"ٔ": 0,
	"ٕ": 0,
	"٠": 3.66,
	"١": 3.44,
	"٢": 6.19,
	"٣": 7.45,
	"٤": 5.41,
	"٥": 6.31,
	"٦": 5.98,
	"٧": 6.83,
	"٨": 6.83,
	"٩": 6.09,
	"٪": 7.59,
	"٫": 3.89,
	"٬": 3.89,
	"٭": 6.31,
	"ٰ": 0,
	"ٱ": 2.86,
	"ٲ": 2.86,
	"ٳ": 2.86,
	"ٴ": 0,
	"ٵ": 2.91,
	"ٶ": 5.42,
	"ٷ": 5.42,
	"ٸ": 8.77,
	"ٹ": 10.81,
	"ٺ": 10.81,
	"ٻ": 10.81,
	"ټ": 10.81,
	"ٽ": 10.81,
	"پ": 10.81,
	"ٿ": 10.81,
	"ڀ": 10.81,
	"ځ": 7.75,
	"ڂ": 7.75,
	"ڃ": 7.75,
	"ڄ": 7.75,
	"څ": 7.75,
	"چ": 7.75,
	"ڇ": 7.75,
	"ڈ": 5.89,
	"ډ": 5.89,
	"ڊ": 5.89,
	"ڋ": 5.89,
	"ڌ": 5.89,
	"ڍ": 5.89,
	"ڎ": 5.89,
	"ڏ": 5.89,
	"ڐ": 5.89,
	"ڑ": 4.22,
	"ڒ": 4.22,
	"ړ": 4.22,
	"ڔ": 4.14,
	"ڕ": 4.22,
	"ږ": 4.22,
	"ڗ": 4.22,
	"ژ": 4.22,
	"ڙ": 4.22,
	"ښ": 12.94,
	"ڛ": 12.94,
	"ڜ": 12.94,
	"ڝ": 13.67,
	"ڞ": 13.67,
	"ڟ": 9.05,
	"ڠ": 7.14,
	"ڡ": 10.89,
	"ڢ": 10.89,
	"ڣ": 10.89,
	"ڤ": 10.89,
	"ڥ": 10.89,
	"ڦ": 10.89,
	"ڧ": 8.19,
	"ڨ": 8.19,
	"ک": 10.05,
	"ڪ": 12.17,
	"ګ": 10.05,
	"ڬ": 9.77,
	"ڭ": 9.77,
	"ڮ": 9.77,
	"گ": 10.05,
	"ڰ": 10.05,
	"ڱ": 10.05,
	"ڲ": 10.05,
	"ڳ": 10.05,
	"ڴ": 10.05,
	"ڵ": 7.53,
	"ڶ": 7.53,
	"ڷ": 7.53,
	"ڸ": 7.53,
	"ڹ": 7.39,
	"ں": 7.39,
	"ڻ": 7.39,
	"ڼ": 7.39,
	"ڽ": 7.39,
	"ھ": 8.2,
	"ڿ": 7.75,
	"ۀ": 5.25,
	"ہ": 5.25,
	"ۂ": 5.25,
	"ۃ": 5.25,
	"ۄ": 5.42,
	"ۅ": 5.42,
	"ۆ": 5.42,
	"ۇ": 5.42,
	"ۈ": 5.42,
	"ۉ": 5.42,
	"ۊ": 5.42,
	"ۋ": 5.42,
	"ی": 8.77,
	"ۍ": 8.77,
	"ێ": 8.77,
	"ۏ": 5.42,
	"ې": 8.77,
	"ۑ": 8.77,
	"ے": 10.73,
	"ۓ": 10.73,
	"۔": 4.3,
	"ە": 5.25,
	"ۖ": 0,
	"ۗ": 0,
	"ۘ": 0,
	"ۙ": 0,
	"ۚ": 0,
	"ۛ": 0,
	"ۜ": 0,
	"۝": 14.11,
	"۞": 12.27,
	"۟": 0,
	"۠": 0,
	"ۡ": 0,
	"ۢ": 0,
	"ۣ": 0,
	"ۤ": 0,
	"ۥ": 0,
	"ۦ": 0,
	"ۧ": 0,
	"ۨ": 0,
	"۩": 9.59,
	"۪": 0,
	"۫": 0,
	"۬": 0,
	"ۭ": 0,
	"۰": 3.66,
	"۱": 3.44,
	"۲": 6.19,
	"۳": 7.45,
	"۴": 6.73,
	"۵": 6.92,
	"۶": 6.75,
	"۷": 6.83,
	"۸": 6.8,
	"۹": 6.09,
	"ۺ": 12.94,
	"ۻ": 13.67,
	"ۼ": 7.14,
	"۽": 5.06,
	"۾": 6.19,
	"܀": 7.09,
	"܁": 3.58,
	"܂": 3.09,
	"܃": 3.09,
	"܄": 3.09,
	"܅": 6.42,
	"܆": 4.64,
	"܇": 4.64,
	"܈": 4.52,
	"܉": 4.52,
	"܊": 6.95,
	"܋": 11.08,
	"܌": 8.33,
	"܍": 9.11,
	"܏": 0,
	"ܐ": 11.17,
	"ܑ": 1.47,
	"ܒ": 11.5,
	"ܓ": 13.09,
	"ܔ": 13.09,
	"ܕ": 6.47,
	"ܖ": 6.47,
	"ܗ": 11.17,
	"ܘ": 7.33,
	"ܙ": 3.31,
	"ܚ": 8.42,
	"ܛ": 12,
	"ܜ": 12,
	"ܝ": 2.92,
	"ܞ": 14.64,
	"ܟ": 10.67,
	"ܠ": 7.88,
	"ܡ": 10.63,
	"ܢ": 8.14,
	"ܣ": 10.64,
	"ܤ": 10.64,
	"ܥ": 11.44,
	"ܦ": 10.13,
	"ܧ": 9.58,
	"ܨ": 7.52,
	"ܩ": 10.02,
	"ܪ": 6.47,
	"ܫ": 11.34,
	"ܬ": 8.92,
	"ܰ": 1.27,
	"ܱ": 1.2,
	"ܲ": 0,
	"ܳ": 1.05,
	"ܴ": 0.94,
	"ܵ": 0.69,
	"ܶ": 1.45,
	"ܷ": 1.34,
	"ܸ": 1.06,
	"ܹ": 1.11,
	"ܺ": 1.41,
	"ܻ": 1.33,
	"ܼ": 0.42,
	"ܽ": 1.25,
	"ܾ": 1.25,
	"ܿ": 0.44,
	"݀": 4.78,
	"݁": 0.72,
	"݂": 0.39,
	"݃": 0.47,
	"݄": 0.47,
	"݅": 1.28,
	"݆": 1.28,
	"݇": 1.36,
	"݈": 1.36,
	"݉": 2.08,
	"݊": 1.47,
	"ހ": 6.36,
	"ށ": 8.14,
	"ނ": 9.72,
	"ރ": 7.8,
	"ބ": 8.55,
	"ޅ": 6.55,
	"ކ": 6.61,
	"އ": 6.41,
	"ވ": 6.47,
	"މ": 6.22,
	"ފ": 5.39,
	"ދ": 7.61,
	"ތ": 7.8,
	"ލ": 6.92,
	"ގ": 6,
	"ޏ": 8.67,
	"ސ": 12.23,
	"ޑ": 4.69,
	"ޒ": 6.84,
	"ޓ": 8.06,
	"ޔ": 8.75,
	"ޕ": 5.39,
	"ޖ": 7,
	"ޗ": 7.77,
	"ޘ": 7.42,
	"ޙ": 6.36,
	"ޚ": 6.36,
	"ޛ": 7.61,
	"ޜ": 7.8,
	"ޝ": 12.23,
	"ޞ": 12.23,
	"ޟ": 12.23,
	"ޠ": 7.8,
	"ޡ": 7.8,
	"ޢ": 6.47,
	"ޣ": 6.47,
	"ޤ": 6,
	"ޥ": 6.08,
	"ަ": 0,
	"ާ": 0,
	"ި": 0.75,
	"ީ": 0,
	"ު": 0,
	"ޫ": 0,
	"ެ": 0,
	"ޭ": 0,
	"ޮ": 0,
	"ޯ": 0,
	"ް": 0,
	"ँ": 7.92,
	"ं": 7.92,
	"ः": 11.14,
	"अ": 8.7,
	"आ": 11.97,
	"इ": 6.38,
	"ई": 6.38,
	"उ": 5.7,
	"ऊ": 8.11,
	"ऋ": 9.89,
	"ऌ": 8.59,
	"ऍ": 6.58,
	"ऎ": 6.58,
	"ए": 6.58,
	"ऐ": 6.58,
	"ऑ": 11.97,
	"ऒ": 11.97,
	"ओ": 11.97,
	"औ": 11.97,
	"क": 9.25,
	"ख": 9.52,
	"ग": 6.69,
	"घ": 7.63,
	"ङ": 7.47,
	"च": 7.73,
	"छ": 8.14,
	"ज": 8.91,
	"झ": 9.28,
	"ञ": 8.42,
	"ट": 6.05,
	"ठ": 6.89,
	"ड": 6.53,
	"ढ": 6.31,
	"ण": 9.08,
	"त": 6.69,
	"थ": 7.75,
	"द": 6.28,
	"ध": 7.59,
	"न": 6.16,
	"ऩ": 6.16,
	"प": 6.75,
	"फ": 9.53,
	"ब": 6.81,
	"भ": 7,
	"म": 6.95,
	"य": 7.31,
	"र": 4.83,
	"ऱ": 4.91,
	"ल": 8.56,
	"ळ": 8.8,
	"ऴ": 8.8,
	"व": 6.58,
	"श": 8.63,
	"ष": 6.88,
	"स": 8.17,
	"ह": 6.09,
	"़": 7.92,
	"ऽ": 5.89,
	"ा": 11.2,
	"ि": 11.2,
	"ी": 11.2,
	"ु": 7.92,
	"ू": 7.92,
	"ृ": 7.92,
	"ॄ": 7.92,
	"ॅ": 7.92,
	"ॆ": 7.92,
	"े": 7.92,
	"ै": 7.92,
	"ॉ": 11.2,
	"ॊ": 11.2,
	"ो": 11.2,
	"ौ": 11.2,
	"्": 7.92,
	"ॐ": 14.69,
	"॑": 2.06,
	"॒": 5.83,
	"॓": 3.53,
	"॔": 2.28,
	"क़": 9.25,
	"ख़": 9.52,
	"ग़": 6.69,
	"ज़": 8.91,
	"ड़": 6.53,
	"ढ़": 6.31,
	"फ़": 9.53,
	"य़": 7.31,
	"ॠ": 9.89,
	"ॡ": 8.59,
	"ॢ": 7.92,
	"ॣ": 7.92,
	"।": 5.73,
	"॥": 8.92,
	"०": 5.59,
	"१": 5.8,
	"२": 5.92,
	"३": 5.86,
	"४": 6.08,
	"५": 6.48,
	"६": 6.34,
	"७": 7.81,
	"८": 5.77,
	"९": 5.73,
	"॰": 6,
	"ঁ": 7.92,
	"ং": 13.17,
	"ঃ": 13.06,
	"অ": 10.72,
	"আ": 14.02,
	"ই": 5.94,
	"ঈ": 7.91,
	"উ": 8.03,
	"ঊ": 8.2,
	"ঋ": 9.03,
	"ঌ": 7.38,
	"এ": 8.48,
	"ঐ": 9.11,
	"ও": 7.22,
	"ঔ": 8.55,
	"ক": 8.3,
	"খ": 7.89,
	"গ": 7.59,
	"ঘ": 7.5,
	"ঙ": 8.25,
	"চ": 6.31,
	"ছ": 7.14,
	"জ": 9.56,
	"ঝ": 9.23,
	"ঞ": 11.39,
	"ট": 6.56,
	"ঠ": 6.53,
	"ড": 8.03,
	"ঢ": 6.58,
	"ণ": 7.3,
	"ত": 8.19,
	"থ": 8.13,
	"দ": 6.58,
	"ধ": 7.3,
	"ন": 7.56,
	"প": 7.86,
	"ফ": 9.02,
	"ব": 6.59,
	"ভ": 8.64,
	"ম": 7.03,
	"য": 6.77,
	"র": 6.59,
	"ল": 8.86,
	"শ": 8.38,
	"ষ": 6.78,
	"স": 7.92,
	"হ": 5.94,
	"়": 7.92,
	"া": 11.2,
	"ি": 11.2,
	"ী": 11.2,
	"ু": 7.92,
	"ূ": 7.92,
	"ৃ": 7.92,
	"ৄ": 7.92,
	"ে": 11.19,
	"ৈ": 11.19,
	"ো": 14.45,
	"ৌ": 14.45,
	"্": 7.92,
	"ৗ": 11.2,
	"ড়": 8.03,
	"ঢ়": 6.58,
	"য়": 6.77,
	"ৠ": 9.03,
	"ৡ": 7.38,
	"ৢ": 7.92,
	"ৣ": 7.92,
	"০": 7.14,
	"১": 6.31,
	"২": 5.75,
	"৩": 8.7,
	"৪": 6.02,
	"৫": 7.31,
	"৬": 7.64,
	"৭": 6.78,
	"৮": 8.33,
	"৯": 7.58,
	"ৰ": 6.64,
	"ৱ": 6.59,
	"৲": 4.97,
	"৳": 7.16,
	"৴": 4.78,
	"৵": 8.19,
	"৶": 7.59,
	"৷": 3.28,
	"৸": 6.8,
	"৹": 6.38,
	"৺": 7.61,
	"ਂ": 8.13,
	"ਅ": 8.48,
	"ਆ": 11.31,
	"ਇ": 9.63,
	"ਈ": 9.63,
	"ਉ": 7.08,
	"ਊ": 7.08,
	"ਏ": 6.69,
	"ਐ": 8.48,
	"ਓ": 7.05,
	"ਔ": 8.48,
	"ਕ": 6.81,
	"ਖ": 6.86,
	"ਗ": 8.72,
	"ਘ": 8.52,
	"ਙ": 6.39,
	"ਚ": 7.14,
	"ਛ": 6.92,
	"ਜ": 7.03,
	"ਝ": 6.42,
	"ਞ": 6.8,
	"ਟ": 6.36,
	"ਠ": 6.89,
	"ਡ": 6.44,
	"ਢ": 7.09,
	"ਣ": 6.73,
	"ਤ": 6.11,
	"ਥ": 6.94,
	"ਦ": 6.83,
	"ਧ": 6.69,
	"ਨ": 6.89,
	"ਪ": 6.67,
	"ਫ": 6.64,
	"ਬ": 6.89,
	"ਭ": 6.44,
	"ਮ": 6.72,
	"ਯ": 8.22,
	"ਰ": 6.42,
	"ਲ": 7.83,
	"ਲ਼": 7.86,
	"ਵ": 6.59,
	"ਸ਼": 6.72,
	"ਸ": 6.72,
	"ਹ": 6.42,
	"਼": 8.13,
	"ਾ": 10.97,
	"ਿ": 11.08,
	"ੀ": 11.08,
	"ੁ": 8.13,
	"ੂ": 8.13,
	"ੇ": 8.13,
	"ੈ": 8.13,
	"ੋ": 8.13,
	"ੌ": 8.13,
	"੍": 8.13,
	"ਖ਼": 6.86,
	"ਗ਼": 8.72,
	"ਜ਼": 7.03,
	"ੜ": 6.22,
	"ਫ਼": 6.64,
	"੦": 6.11,
	"੧": 5.58,
	"੨": 5.95,
	"੩": 5.91,
	"੪": 6.63,
	"੫": 6.78,
	"੬": 6.03,
	"੭": 6.27,
	"੮": 6.78,
	"੯": 6.78,
	"ੰ": 8.13,
	"ੱ": 8.13,
	"ੲ": 6.69,
	"ੳ": 7.08,
	"ੴ": 12.59,
	"ઁ": 7.81,
	"ં": 7.81,
	"ઃ": 10.69,
	"અ": 10.83,
	"આ": 14.08,
	"ઇ": 7.53,
	"ઈ": 7.55,
	"ઉ": 7.75,
	"ઊ": 10.77,
	"ઋ": 10.27,
	"ઍ": 10.83,
	"એ": 10.83,
	"ઐ": 10.83,
	"ઑ": 14.08,
	"ઓ": 14.08,
	"ઔ": 14.08,
	"ક": 6.75,
	"ખ": 9.23,
	"ગ": 8.59,
	"ઘ": 8,
	"ઙ": 6.66,
	"ચ": 8.44,
	"છ": 8.78,
	"જ": 7.61,
	"ઝ": 9.11,
	"ઞ": 8.59,
	"ટ": 5.94,
	"ઠ": 7.25,
	"ડ": 6.06,
	"ઢ": 6.88,
	"ણ": 9.98,
	"ત": 7.03,
	"થ": 8.05,
	"દ": 5.86,
	"ધ": 7.88,
	"ન": 6.47,
	"પ": 6.88,
	"ફ": 6.89,
	"બ": 9.3,
	"ભ": 9.69,
	"મ": 6.92,
	"ય": 7.78,
	"ર": 5.7,
	"લ": 8.03,
	"ળ": 9.34,
	"વ": 7.27,
	"શ": 8.86,
	"ષ": 6.98,
	"સ": 8.8,
	"હ": 7.08,
	"઼": 7.81,
	"ઽ": 6.23,
	"ા": 11.08,
	"િ": 11.08,
	"ી": 11.08,
	"ુ": 7.81,
	"ૂ": 7.81,
	"ૃ": 7.81,
	"ૄ": 7.81,
	"ૅ": 7.81,
	"ે": 7.81,
	"ૈ": 7.81,
	"ૉ": 11.08,
	"ો": 11.08,
	"ૌ": 11.08,
	"્": 7.81,
	"ૐ": 13.36,
	"ૠ": 10.64,
	"૦": 5.86,
	"૧": 6.08,
	"૨": 5.75,
	"૩": 5.77,
	"૪": 6.36,
	"૫": 6.55,
	"૬": 5.81,
	"૭": 7.61,
	"૮": 5.67,
	"૯": 6.16,
	"ଁ": 6.13,
	"ଂ": 9.75,
	"ଃ": 11.02,
	"ଅ": 7.53,
	"ଆ": 9.86,
	"ଇ": 8,
	"ଈ": 8.08,
	"ଉ": 7.97,
	"ଊ": 8.23,
	"ଋ": 8.19,
	"ଌ": 6.09,
	"ଏ": 7.72,
	"ଐ": 9.86,
	"ଓ": 7.67,
	"ଔ": 9.84,
	"କ": 7.94,
	"ଖ": 7.91,
	"ଗ": 7.86,
	"ଘ": 7.78,
	"ଙ": 8.53,
	"ଚ": 7.63,
	"ଛ": 7.72,
	"ଜ": 7.94,
	"ଝ": 7.7,
	"ଞ": 7.81,
	"ଟ": 7.67,
	"ଠ": 8.59,
	"ଡ": 7.72,
	"ଢ": 7.72,
	"ଣ": 7.75,
	"ତ": 7.72,
	"ଥ": 7.53,
	"ଦ": 7.61,
	"ଧ": 6.98,
	"ନ": 7.61,
	"ପ": 7.78,
	"ଫ": 9.47,
	"ବ": 7.63,
	"ଭ": 8.11,
	"ମ": 7.78,
	"ଯ": 8.2,
	"ର": 7.86,
	"ଲ": 8.42,
	"ଳ": 7.94,
	"ଶ": 7.91,
	"ଷ": 7.92,
	"ସ": 7.72,
	"ହ": 7.45,
	"଼": 6.13,
	"ଽ": 4.16,
	"ା": 8.39,
	"ି": 6.13,
	"ୀ": 9.67,
	"ୁ": 6.13,
	"ୂ": 6.13,
	"ୃ": 6.13,
	"େ": 11.53,
	"ୈ": 11.53,
	"ୋ": 13.81,
	"ୌ": 13.81,
	"୍": 6.13,
	"ୖ": 6.13,
	"ୗ": 8.39,
	"ଡ଼": 7.72,
	"ଢ଼": 7.72,
	"ୟ": 8.8,
	"ୠ": 8.23,
	"ୡ": 6.09,
	"୦": 6.88,
	"୧": 6.88,
	"୨": 6.88,
	"୩": 6.88,
	"୪": 6.88,
	"୫": 6.88,
	"୬": 6.88,
	"୭": 6.88,
	"୮": 6.88,
	"୯": 6.88,
	"୰": 6.7,
	"ஂ": 7.53,
	"ஃ": 8.16,
	"அ": 10.83,
	"ஆ": 12.94,
	"இ": 11.31,
	"ஈ": 7.58,
	"உ": 11.47,
	"ஊ": 13.3,
	"எ": 8.17,
	"ஏ": 8.47,
	"ஐ": 9.41,
	"ஒ": 9,
	"ஓ": 9,
	"ஔ": 18.59,
	"க": 8.56,
	"ங": 9.94,
	"ச": 7.55,
	"ஜ": 9.05,
	"ஞ": 11.61,
	"ட": 8.73,
	"ண": 14.89,
	"த": 8.14,
	"ந": 8.02,
	"ன": 11.11,
	"ப": 7.64,
	"ம": 8.03,
	"ய": 8.16,
	"ர": 6.09,
	"ற": 7.75,
	"ல": 9.41,
	"ள": 10.2,
	"ழ": 8.05,
	"வ": 8.8,
	"ஷ": 10.84,
	"ஸ": 12.02,
	"ஹ": 14.22,
	"ா": 13.41,
	"ி": 10.02,
	"ீ": 7.53,
	"ு": 12.42,
	"ூ": 14.06,
	"ெ": 16.25,
	"ே": 14.48,
	"ை": 18.19,
	"ொ": 22.27,
	"ோ": 20.52,
	"ௌ": 26.44,
	"்": 7.53,
	"ௗ": 17.22,
	"௧": 8.56,
	"௨": 7.59,
	"௩": 8.91,
	"௪": 8.09,
	"௫": 8.94,
	"௬": 10.38,
	"௭": 8.17,
	"௮": 10.77,
	"௯": 11.09,
	"௰": 8.66,
	"௱": 8.78,
	"௲": 10.16,
	"ఁ": 12.09,
	"ం": 15.38,
	"ః": 12.45,
	"అ": 10.56,
	"ఆ": 10.28,
	"ఇ": 9.31,
	"ఈ": 12.13,
	"ఉ": 10.77,
	"ఊ": 14.7,
	"ఋ": 17.97,
	"ఌ": 11.98,
	"ఎ": 9.19,
	"ఏ": 9.19,
	"ఐ": 9.69,
	"ఒ": 9.02,
	"ఓ": 9.02,
	"ఔ": 9.28,
	"క": 6.2,
	"ఖ": 10.81,
	"గ": 7.2,
	"ఘ": 13.27,
	"ఙ": 9.23,
	"చ": 9.66,
	"ఛ": 9.66,
	"జ": 9.19,
	"ఝ": 15.77,
	"ఞ": 12.31,
	"ట": 10.2,
	"ఠ": 7.45,
	"డ": 9.84,
	"ఢ": 9.84,
	"ణ": 10,
	"త": 9.83,
	"థ": 9.8,
	"ద": 9.8,
	"ధ": 9.8,
	"న": 9.13,
	"ప": 9.17,
	"ఫ": 9.17,
	"బ": 9.78,
	"భ": 9.78,
	"మ": 13.3,
	"య": 15.77,
	"ర": 7.45,
	"ఱ": 10.61,
	"ల": 9.28,
	"ళ": 7.78,
	"వ": 9.14,
	"శ": 6.69,
	"ష": 9.14,
	"స": 9.16,
	"హ": 12.98,
	"ా": 11.84,
	"ి": 7.92,
	"ీ": 7.92,
	"ు": 12.11,
	"ూ": 15.13,
	"ృ": 13.03,
	"ౄ": 16.66,
	"ె": 7.92,
	"ే": 7.92,
	"ై": 7.92,
	"ొ": 7.92,
	"ో": 7.92,
	"ౌ": 11.92,
	"్": 7.92,
	"ౕ": 7.92,
	"ౖ": 7.92,
	"ౠ": 21.98,
	"ౡ": 16.16,
	"౦": 6.97,
	"౧": 6.83,
	"౨": 8.41,
	"౩": 6,
	"౪": 7.05,
	"౫": 7.77,
	"౬": 5.48,
	"౭": 6.2,
	"౮": 7.09,
	"౯": 5.48,
	"ಂ": 13.34,
	"ಃ": 10.41,
	"ಅ": 10.36,
	"ಆ": 10.09,
	"ಇ": 8.55,
	"ಈ": 12.13,
	"ಉ": 14.67,
	"ಊ": 19.17,
	"ಋ": 14.3,
	"ಌ": 10.16,
	"ಎ": 9.45,
	"ಏ": 9.45,
	"ಐ": 9.69,
	"ಒ": 9.31,
	"ಓ": 9.31,
	"ಔ": 9.34,
	"ಕ": 6.89,
	"ಖ": 10.2,
	"ಗ": 7.78,
	"ಘ": 11.95,
	"ಙ": 9.31,
	"ಚ": 9.58,
	"ಛ": 10.13,
	"ಜ": 9.31,
	"ಝ": 16.56,
	"ಞ": 11.59,
	"ಟ": 9.78,
	"ಠ": 7.81,
	"ಡ": 9.22,
	"ಢ": 9.22,
	"ಣ": 10.38,
	"ತ": 7.47,
	"ಥ": 9.19,
	"ದ": 9.19,
	"ಧ": 9.19,
	"ನ": 8.55,
	"ಪ": 9.52,
	"ಫ": 9.52,
	"ಬ": 9.61,
	"ಭ": 9.67,
	"ಮ": 13.88,
	"ಯ": 16.05,
	"ರ": 7.81,
	"ಱ": 10.72,
	"ಲ": 9.11,
	"ಳ": 8.53,
	"ವ": 9.53,
	"ಶ": 7.56,
	"ಷ": 9.63,
	"ಸ": 8.52,
	"ಹ": 9.63,
	"ಾ": 12.13,
	"ಿ": 10.66,
	"ೀ": 15.56,
	"ು": 11.11,
	"ೂ": 15.69,
	"ೃ": 8.22,
	"ೄ": 12.67,
	"ೆ": 6.73,
	"ೇ": 11.64,
	"ೈ": 8.94,
	"ೊ": 15.69,
	"ೋ": 20.59,
	"ೌ": 11.91,
	"್": 10.5,
	"ೕ": 11.64,
	"ೖ": 8.94,
	"ೞ": 10.44,
	"ೠ": 18.84,
	"ೡ": 15.44,
	"೦": 8.27,
	"೧": 8.27,
	"೨": 8.27,
	"೩": 8.27,
	"೪": 8.27,
	"೫": 8.27,
	"೬": 8.27,
	"೭": 8.27,
	"೮": 8.27,
	"೯": 8.27,
	"ം": 4.63,
	"ഃ": 3.41,
	"അ": 14.88,
	"ആ": 16.47,
	"ഇ": 10.8,
	"ഈ": 19.56,
	"ഉ": 7.64,
	"ഊ": 16.34,
	"ഋ": 9.64,
	"ഌ": 11.98,
	"എ": 13.36,
	"ഏ": 13.36,
	"ഐ": 19.59,
	"ഒ": 7.64,
	"ഓ": 12.59,
	"ഔ": 16.23,
	"ക": 10.63,
	"ഖ": 9.59,
	"ഗ": 9.03,
	"ഘ": 14.47,
	"ങ": 11.64,
	"ച": 9.97,
	"ഛ": 13.91,
	"ജ": 9.58,
	"ഝ": 17.34,
	"ഞ": 15.09,
	"ട": 6.22,
	"ഠ": 6.97,
	"ഡ": 13.13,
	"ഢ": 13.52,
	"ണ": 14.91,
	"ത": 10.47,
	"ഥ": 8.84,
	"ദ": 6.67,
	"ധ": 10.08,
	"ന": 10.08,
	"പ": 8.56,
	"ഫ": 12.33,
	"ബ": 13.73,
	"ഭ": 6.95,
	"മ": 6.97,
	"യ": 10.59,
	"ര": 7.34,
	"റ": 6.86,
	"ല": 9.22,
	"ള": 7.81,
	"ഴ": 6.91,
	"വ": 9.59,
	"ശ": 10.31,
	"ഷ": 12.14,
	"സ": 13.13,
	"ഹ": 13.22,
	"ാ": 11.78,
	"ി": 9.73,
	"ീ": 9.64,
	"ു": 10.44,
	"ൂ": 10.5,
	"ൃ": 11.11,
	"െ": 13.72,
	"േ": 12.69,
	"ൈ": 20,
	"ൊ": 18.66,
	"ോ": 17.94,
	"ൌ": 15.97,
	"്": 7.19,
	"ൗ": 15.97,
	"ൠ": 9.59,
	"ൡ": 13.22,
	"൦": 6.97,
	"൧": 9.39,
	"൨": 9.59,
	"൩": 11.84,
	"൪": 7.42,
	"൫": 10.59,
	"൬": 14.47,
	"൭": 5.28,
	"൮": 9.59,
	"൯": 11.06,
	"ං": 5,
	"ඃ": 3.34,
	"අ": 6.84,
	"ආ": 10.02,
	"ඇ": 9.88,
	"ඈ": 9.89,
	"ඉ": 6.89,
	"ඊ": 6.73,
	"උ": 7.14,
	"ඌ": 11.83,
	"ඍ": 11.64,
	"ඎ": 15.73,
	"ඏ": 8.66,
	"ඐ": 13.47,
	"එ": 7.73,
	"ඒ": 7.78,
	"ඓ": 12.64,
	"ඔ": 7.88,
	"ඕ": 7.84,
	"ඖ": 12.89,
	"ක": 8.92,
	"ඛ": 8.44,
	"ග": 7.89,
	"ඝ": 7.06,
	"ඞ": 8,
	"ඟ": 9.5,
	"ච": 7.53,
	"ඡ": 6.73,
	"ජ": 6.59,
	"ඣ": 14.22,
	"ඤ": 12.89,
	"ඥ": 11.81,
	"ඦ": 7.81,
	"ට": 7.14,
	"ඨ": 7.52,
	"ඩ": 8.13,
	"ඪ": 7.75,
	"ණ": 10.69,
	"ඬ": 9.73,
	"ත": 8.33,
	"ථ": 7.19,
	"ද": 6.16,
	"ධ": 7.89,
	"න": 8.17,
	"ඳ": 7.84,
	"ප": 6.59,
	"ඵ": 7.72,
	"බ": 8.11,
	"භ": 9.3,
	"ම": 8.08,
	"ඹ": 7.89,
	"ය": 7.42,
	"ර": 6.56,
	"ල": 7.42,
	"ව": 7.36,
	"ශ": 8.27,
	"ෂ": 6.55,
	"ස": 7.73,
	"හ": 8.91,
	"ළ": 8.06,
	"ෆ": 7.52,
	"්": 7.27,
	"ා": 10.28,
	"ැ": 9.84,
	"ෑ": 9.95,
	"ි": 6.97,
	"ී": 6.97,
	"ු": 6.97,
	"ූ": 6.97,
	"ෘ": 11.28,
	"ෙ": 12.64,
	"ේ": 13.16,
	"ෛ": 18.8,
	"ො": 16.02,
	"ෝ": 15.66,
	"ෞ": 17.42,
	"ෟ": 12.05,
	"ෲ": 15.5,
	"ෳ": 4.97,
	"෴": 13.17,
	"ก": 7.28,
	"ข": 6.94,
	"ฃ": 6.91,
	"ค": 7.84,
	"ฅ": 7.83,
	"ฆ": 7.63,
	"ง": 5.67,
	"จ": 6.25,
	"ฉ": 7.22,
	"ช": 7.14,
	"ซ": 7.19,
	"ฌ": 9.89,
	"ญ": 9.86,
	"ฎ": 7.91,
	"ฏ": 7.91,
	"ฐ": 6.39,
	"ฑ": 8.27,
	"ฒ": 10.45,
	"ณ": 9.98,
	"ด": 7.73,
	"ต": 7.73,
	"ถ": 7.28,
	"ท": 7.73,
	"ธ": 6.69,
	"น": 7.45,
	"บ": 7.8,
	"ป": 7.8,
	"ผ": 7.56,
	"ฝ": 7.56,
	"พ": 8.17,
	"ฟ": 8.17,
	"ภ": 7.91,
	"ม": 7.55,
	"ย": 7.22,
	"ร": 6.02,
	"ฤ": 7.28,
	"ล": 7.06,
	"ฦ": 7.91,
	"ว": 6.16,
	"ศ": 7.94,
	"ษ": 8.08,
	"ส": 7.16,
	"ห": 7.73,
	"ฬ": 8.36,
	"อ": 6.94,
	"ฮ": 7.06,
	"ฯ": 6.61,
	"ะ": 5.25,
	"ั": 6.09,
	"า": 6.06,
	"ำ": 12.16,
	"ิ": 6.09,
	"ี": 6.09,
	"ึ": 6.09,
	"ื": 6.09,
	"ุ": 6.09,
	"ู": 6.09,
	"ฺ": 6.09,
	"฿": 7.56,
	"เ": 3.8,
	"แ": 6.97,
	"โ": 5.34,
	"ใ": 5.8,
	"ไ": 5.58,
	"ๅ": 6.06,
	"ๆ": 6.8,
	"็": 6.09,
	"่": 6.09,
	"้": 6.09,
	"๊": 6.09,
	"๋": 6.09,
	"์": 6.09,
	"ํ": 6.09,
	"๎": 6.09,
	"๏": 8.78,
	"๐": 7.03,
	"๑": 7.38,
	"๒": 7.88,
	"๓": 8.14,
	"๔": 7.39,
	"๕": 7.39,
	"๖": 6.95,
	"๗": 9.16,
	"๘": 7.45,
	"๙": 8.02,
	"๚": 8.63,
	"๛": 14.72,
	"ກ": 7.42,
	"ຂ": 6.5,
	"ຄ": 6.81,
	"ງ": 6.14,
	"ຈ": 6.69,
	"ຊ": 6.59,
	"ຍ": 6.81,
	"ດ": 7,
	"ຕ": 7.23,
	"ຖ": 7.48,
	"ທ": 7.7,
	"ນ": 7.38,
	"ບ": 6.33,
	"ປ": 6.38,
	"ຜ": 8.11,
	"ຝ": 8.02,
	"ພ": 7.98,
	"ຟ": 8.03,
	"ມ": 7.42,
	"ຢ": 6.72,
	"ຣ": 6.5,
	"ລ": 6.67,
	"ວ": 6.42,
	"ສ": 6.67,
	"ຫ": 9.22,
	"ອ": 6.67,
	"ຮ": 6.61,
	"ຯ": 6.34,
	"ະ": 6.17,
	"ັ": 0,
	"າ": 5.17,
	"ຳ": 0,
	"ິ": 0,
	"ີ": 0,
	"ຶ": 0,
	"ື": 0,
	"ຸ": 0,
	"ູ": 0,
	"ົ": 0,
	"ຼ": 0,
	"ຽ": 5.45,
	"ເ": 4.09,
	"ແ": 7.09,
	"ໂ": 4.05,
	"ໃ": 4.08,
	"ໄ": 4,
	"ໆ": 7.05,
	"່": 0,
	"້": 0,
	"໊": 0,
	"໋": 0,
	"໌": 3.91,
	"ໍ": 0,
	"໐": 6.7,
	"໑": 6.09,
	"໒": 5.98,
	"໓": 6.91,
	"໔": 6.14,
	"໕": 6.33,
	"໖": 7.48,
	"໗": 7.55,
	"໘": 7.98,
	"໙": 7.53,
	"ໜ": 12.02,
	"ໝ": 12.02,
	"ༀ": 8.52,
	"༁": 8.3,
	"༂": 11.06,
	"༃": 11.47,
	"༄": 10.59,
	"༅": 7.7,
	"༆": 10.61,
	"༇": 17.73,
	"༈": 6.75,
	"༉": 7.47,
	"༊": 13.03,
	"་": 1.83,
	"༌": 1.61,
	"།": 3.45,
	"༎": 6.56,
	"༏": 2.84,
	"༐": 4.73,
	"༑": 4.73,
	"༒": 22.84,
	"༓": 7.22,
	"༔": 4.86,
	"༕": 9.53,
	"༖": 9.03,
	"༗": 13.02,
	"༘": 6.31,
	"༙": 3.53,
	"༚": 3.53,
	"༛": 6.27,
	"༜": 6.23,
	"༝": 3.8,
	"༞": 6.23,
	"༟": 6.38,
	"༠": 3.86,
	"༡": 3.89,
	"༢": 4.88,
	"༣": 4,
	"༤": 4.88,
	"༥": 4.48,
	"༦": 6.5,
	"༧": 6.58,
	"༨": 5.55,
	"༩": 5.03,
	"༪": 6.06,
	"༫": 4.64,
	"༬": 3.56,
	"༭": 4.91,
	"༮": 8.67,
	"༯": 7.91,
	"༰": 7.91,
	"༱": 6.63,
	"༲": 6.97,
	"༳": 4.86,
	"༴": 7.09,
	"༵": 4.06,
	"༶": 6.61,
	"༷": 3.3,
	"༸": 7.91,
	"༹": 2.36,
	"༺": 16.58,
	"༻": 16.58,
	"༼": 7.31,
	"༽": 7.61,
	"༾": 6.05,
	"༿": 5.63,
	"ཀ": 7.91,
	"ཁ": 6.83,
	"ག": 7.89,
	"གྷ": 7.09,
	"ང": 6.16,
	"ཅ": 6.5,
	"ཆ": 7.31,
	"ཇ": 6.28,
	"ཉ": 6.22,
	"ཊ": 6.16,
	"ཋ": 5.92,
	"ཌ": 6.81,
	"ཌྷ": 6.98,
	"ཎ": 7.56,
	"ཏ": 6.5,
	"ཐ": 6.28,
	"ད": 6.42,
	"དྷ": 6.81,
	"ན": 6.42,
	"པ": 6.48,
	"ཕ": 6.48,
	"བ": 6.48,
	"བྷ": 6.66,
	"མ": 7.28,
	"ཙ": 5.83,
	"ཚ": 7.23,
	"ཛ": 6.06,
	"ཛྷ": 6.16,
	"ཝ": 7.56,
	"ཞ": 6.94,
	"ཟ": 6.17,
	"འ": 6.27,
	"ཡ": 7.09,
	"ར": 6.72,
	"ལ": 6.8,
	"ཤ": 8.34,
	"ཥ": 9.5,
	"ས": 7.05,
	"ཧ": 7.7,
	"ཨ": 8.14,
	"ཀྵ": 7.09,
	"ཪ": 6.72,
	"ཱ": 5.78,
	"ི": 7.38,
	"ཱི": 5.78,
	"ུ": 8.36,
	"ཱུ": 14.14,
	"ྲྀ": 7.23,
	"ཷ": 13,
	"ླྀ": 7.77,
	"ཹ": 13.53,
	"ེ": 7.13,
	"ཻ": 7.7,
	"ོ": 7.69,
	"ཽ": 8.67,
	"ཾ": 3.97,
	"ཿ": 3.75,
	"ྀ": 7.03,
	"ཱྀ": 5.78,
	"ྂ": 5.25,
	"ྃ": 5.41,
	"྄": 1.73,
	"྅": 5.7,
	"྆": 3.81,
	"྇": 4.22,
	"ྈ": 7.09,
	"ྉ": 7.09,
	"ྊ": 9.05,
	"ྋ": 9.06,
	"ྐ": 7.11,
	"ྑ": 6.8,
	"ྒ": 7.27,
	"ྒྷ": 7.05,
	"ྔ": 7.11,
	"ྕ": 6.8,
	"ྖ": 7.23,
	"ྗ": 7.3,
	"ྙ": 6.64,
	"ྚ": 6.19,
	"ྛ": 6.19,
	"ྜ": 7.58,
	"ྜྷ": 6.66,
	"ྞ": 6.7,
	"ྟ": 6.19,
	"ྠ": 6,
	"ྡ": 7.11,
	"ྡྷ": 7.27,
	"ྣ": 6.5,
	"ྤ": 5.97,
	"ྥ": 5.97,
	"ྦ": 5.97,
	"ྦྷ": 5.98,
	"ྨ": 6.77,
	"ྩ": 8.75,
	"ྪ": 8.64,
	"ྫ": 8.03,
	"ྫྷ": 7.42,
	"ྭ": 6.61,
	"ྮ": 6.92,
	"ྯ": 6.59,
	"ྰ": 7.03,
	"ྱ": 9.19,
	"ྲ": 7.23,
	"ླ": 7.77,
	"ྴ": 8.69,
	"ྵ": 8.69,
	"ྶ": 7.67,
	"ྷ": 7.08,
	"ྸ": 7.64,
	"ྐྵ": 9.48,
	"ྺ": 7.63,
	"ྻ": 7.42,
	"ྼ": 8.56,
	"྾": 7.38,
	"྿": 7.38,
	"࿀": 7.78,
	"࿁": 7.78,
	"࿂": 11.63,
	"࿃": 12.41,
	"࿄": 9.23,
	"࿅": 9.2,
	"࿆": 11.33,
	"࿇": 9.3,
	"࿈": 9.61,
	"࿉": 10.47,
	"࿊": 12.53,
	"࿋": 12.72,
	"࿌": 12.47,
	"࿏": 5.73,
	"က": 13.5,
	"ခ": 8.13,
	"ဂ": 8.03,
	"ဃ": 13.5,
	"င": 7.81,
	"စ": 8.09,
	"ဆ": 13.53,
	"ဇ": 8.22,
	"ဈ": 10.44,
	"ဉ": 7.94,
	"ည": 13.31,
	"ဋ": 8,
	"ဌ": 7.92,
	"ဍ": 8,
	"ဎ": 8.13,
	"ဏ": 15.06,
	"တ": 13.5,
	"ထ": 13.5,
	"ဒ": 7.69,
	"ဓ": 8.09,
	"န": 6.84,
	"ပ": 8.13,
	"ဖ": 8.11,
	"ဗ": 8.13,
	"ဘ": 13.5,
	"မ": 8.13,
	"ယ": 13.52,
	"ရ": 8.28,
	"လ": 13.52,
	"ဝ": 8.09,
	"သ": 13.53,
	"ဟ": 13.5,
	"ဠ": 8,
	"အ": 12.83,
	"ဣ": 13.2,
	"ဤ": 16.13,
	"ဥ": 7.94,
	"ဦ": 7.94,
	"ဧ": 7.58,
	"ဩ": 16.44,
	"ဪ": 29.44,
	"ာ": 12.59,
	"ိ": 7.14,
	"ီ": 7.14,
	"ု": 7.14,
	"ူ": 7.14,
	"ေ": 14.55,
	"ဲ": 7.14,
	"ံ": 7.14,
	"့": 7.14,
	"း": 11.28,
	"္": 7.14,
	"၀": 7.83,
	"၁": 7.48,
	"၂": 8.11,
	"၃": 7.42,
	"၄": 7.42,
	"၅": 8.11,
	"၆": 8.64,
	"၇": 7.77,
	"၈": 7.83,
	"၉": 8.64,
	"၊": 3.25,
	"။": 5.55,
	"၌": 8,
	"၍": 10.72,
	"၎": 7.92,
	"၏": 13.66,
	"ၐ": 8.03,
	"ၑ": 8.13,
	"ၒ": 7.94,
	"ၓ": 7.94,
	"ၔ": 7.92,
	"ၕ": 7.81,
	"ၖ": 11.56,
	"ၗ": 11.61,
	"ၘ": 7.14,
	"ၙ": 7.14,
	"Ⴀ": 7.95,
	"Ⴁ": 8.13,
	"Ⴂ": 8.5,
	"Ⴃ": 8.36,
	"Ⴄ": 7.31,
	"Ⴅ": 9.48,
	"Ⴆ": 7.97,
	"Ⴇ": 9.42,
	"Ⴈ": 6.73,
	"Ⴉ": 7.61,
	"Ⴊ": 9.39,
	"Ⴋ": 8.42,
	"Ⴌ": 7.55,
	"Ⴍ": 8.19,
	"Ⴎ": 8.47,
	"Ⴏ": 8.31,
	"Ⴐ": 8.81,
	"Ⴑ": 7.39,
	"Ⴒ": 7.11,
	"Ⴓ": 8.17,
	"Ⴔ": 8.16,
	"Ⴕ": 8.47,
	"Ⴖ": 7.72,
	"Ⴗ": 7.48,
	"Ⴘ": 7.48,
	"Ⴙ": 7.55,
	"Ⴚ": 7.59,
	"Ⴛ": 9.25,
	"Ⴜ": 7.11,
	"Ⴝ": 7.95,
	"Ⴞ": 7.55,
	"Ⴟ": 8.06,
	"Ⴠ": 8.83,
	"Ⴡ": 6.92,
	"Ⴢ": 7.28,
	"Ⴣ": 7.27,
	"Ⴤ": 8.11,
	"Ⴥ": 9.52,
	"ა": 6.22,
	"ბ": 6.83,
	"გ": 6.33,
	"დ": 9.98,
	"ე": 6.47,
	"ვ": 6.42,
	"ზ": 7.45,
	"თ": 10.17,
	"ი": 6.47,
	"კ": 6.27,
	"ლ": 11.67,
	"მ": 6.92,
	"ნ": 6.94,
	"ო": 8.84,
	"პ": 6.42,
	"ჟ": 6.69,
	"რ": 8.88,
	"ს": 6.63,
	"ტ": 7.97,
	"უ": 6.69,
	"ფ": 9.61,
	"ქ": 6.42,
	"ღ": 8.84,
	"ყ": 6.63,
	"შ": 6.97,
	"ჩ": 6.8,
	"ც": 7.06,
	"ძ": 6.91,
	"წ": 6.97,
	"ჭ": 7.23,
	"ხ": 6.91,
	"ჯ": 6.22,
	"ჰ": 6.38,
	"ჱ": 7.13,
	"ჲ": 6.38,
	"ჳ": 6.53,
	"ჴ": 6.53,
	"ჵ": 7.09,
	"ჶ": 8.81,
	"჻": 6.45,
	"ᄀ": 10.39,
	"ᄁ": 10.39,
	"ᄂ": 10.39,
	"ᄃ": 10.39,
	"ᄄ": 10.39,
	"ᄅ": 10.39,
	"ᄆ": 10.39,
	"ᄇ": 10.39,
	"ᄈ": 10.39,
	"ᄉ": 10.39,
	"ᄊ": 10.39,
	"ᄋ": 10.39,
	"ᄌ": 10.39,
	"ᄍ": 10.39,
	"ᄎ": 10.39,
	"ᄏ": 10.39,
	"ᄐ": 10.39,
	"ᄑ": 10.39,
	"ᄒ": 10.39,
	"ᄓ": 12,
	"ᄔ": 12,
	"ᄕ": 12,
	"ᄖ": 12,
	"ᄗ": 12,
	"ᄘ": 12,
	"ᄙ": 12,
	"ᄚ": 12,
	"ᄛ": 12,
	"ᄜ": 12,
	"ᄝ": 12,
	"ᄞ": 12,
	"ᄟ": 12,
	"ᄠ": 12,
	"ᄡ": 12,
	"ᄢ": 12,
	"ᄣ": 12,
	"ᄤ": 12,
	"ᄥ": 12,
	"ᄦ": 12,
	"ᄧ": 12,
	"ᄨ": 12,
	"ᄩ": 12,
	"ᄪ": 12,
	"ᄫ": 12,
	"ᄬ": 12,
	"ᄭ": 12,
	"ᄮ": 12,
	"ᄯ": 12,
	"ᄰ": 12,
	"ᄱ": 12,
	"ᄲ": 12,
	"ᄳ": 12,
	"ᄴ": 12,
	"ᄵ": 12,
	"ᄶ": 12,
	"ᄷ": 12,
	"ᄸ": 12,
	"ᄹ": 12,
	"ᄺ": 12,
	"ᄻ": 12,
	"ᄼ": 12,
	"ᄽ": 12,
	"ᄾ": 12,
	"ᄿ": 12,
	"ᅀ": 12,
	"ᅁ": 12,
	"ᅂ": 12,
	"ᅃ": 12,
	"ᅄ": 12,
	"ᅅ": 12,
	"ᅆ": 12,
	"ᅇ": 12,
	"ᅈ": 12,
	"ᅉ": 12,
	"ᅊ": 12,
	"ᅋ": 12,
	"ᅌ": 12,
	"ᅍ": 12,
	"ᅎ": 12,
	"ᅏ": 12,
	"ᅐ": 12,
	"ᅑ": 12,
	"ᅒ": 12,
	"ᅓ": 12,
	"ᅔ": 12,
	"ᅕ": 12,
	"ᅖ": 12,
	"ᅗ": 12,
	"ᅘ": 12,
	"ᅙ": 12,
	"ᅟ": 0,
	"ᅠ": 0,
	"ᅡ": 10.39,
	"ᅢ": 10.39,
	"ᅣ": 10.39,
	"ᅤ": 10.39,
	"ᅥ": 10.39,
	"ᅦ": 10.39,
	"ᅧ": 10.39,
	"ᅨ": 10.39,
	"ᅩ": 10.39,
	"ᅪ": 10.39,
	"ᅫ": 10.39,
	"ᅬ": 10.39,
	"ᅭ": 10.39,
	"ᅮ": 10.39,
	"ᅯ": 10.39,
	"ᅰ": 10.39,
	"ᅱ": 10.39,
	"ᅲ": 10.39,
	"ᅳ": 10.39,
	"ᅴ": 10.39,
	"ᅵ": 10.39,
	"ᅶ": 12,
	"ᅷ": 12,
	"ᅸ": 12,
	"ᅹ": 12,
	"ᅺ": 12,
	"ᅻ": 12,
	"ᅼ": 12,
	"ᅽ": 12,
	"ᅾ": 12,
	"ᅿ": 12,
	"ᆀ": 12,
	"ᆁ": 12,
	"ᆂ": 12,
	"ᆃ": 12,
	"ᆄ": 12,
	"ᆅ": 12,
	"ᆆ": 12,
	"ᆇ": 12,
	"ᆈ": 12,
	"ᆉ": 12,
	"ᆊ": 12,
	"ᆋ": 12,
	"ᆌ": 12,
	"ᆍ": 12,
	"ᆎ": 12,
	"ᆏ": 12,
	"ᆐ": 12,
	"ᆑ": 12,
	"ᆒ": 12,
	"ᆓ": 12,
	"ᆔ": 12,
	"ᆕ": 12,
	"ᆖ": 12,
	"ᆗ": 12,
	"ᆘ": 12,
	"ᆙ": 12,
	"ᆚ": 12,
	"ᆛ": 12,
	"ᆜ": 12,
	"ᆝ": 12,
	"ᆞ": 10.39,
	"ᆟ": 12,
	"ᆠ": 12,
	"ᆡ": 12,
	"ᆢ": 10.39,
	"ᆨ": 10.39,
	"ᆩ": 10.39,
	"ᆪ": 10.39,
	"ᆫ": 10.39,
	"ᆬ": 10.39,
	"ᆭ": 10.39,
	"ᆮ": 10.39,
	"ᆯ": 10.39,
	"ᆰ": 10.39,
	"ᆱ": 10.39,
	"ᆲ": 10.39,
	"ᆳ": 10.39,
	"ᆴ": 10.39,
	"ᆵ": 10.39,
	"ᆶ": 10.39,
	"ᆷ": 10.39,
	"ᆸ": 10.39,
	"ᆹ": 10.39,
	"ᆺ": 10.39,
	"ᆻ": 10.39,
	"ᆼ": 10.39,
	"ᆽ": 10.39,
	"ᆾ": 10.39,
	"ᆿ": 10.39,
	"ᇀ": 10.39,
	"ᇁ": 10.39,
	"ᇂ": 10.39,
	"ᇃ": 12,
	"ᇄ": 12,
	"ᇅ": 12,
	"ᇆ": 12,
	"ᇇ": 12,
	"ᇈ": 12,
	"ᇉ": 12,
	"ᇊ": 12,
	"ᇋ": 12,
	"ᇌ": 12,
	"ᇍ": 12,
	"ᇎ": 12,
	"ᇏ": 12,
	"ᇐ": 12,
	"ᇑ": 12,
	"ᇒ": 12,
	"ᇓ": 12,
	"ᇔ": 12,
	"ᇕ": 12,
	"ᇖ": 12,
	"ᇗ": 12,
	"ᇘ": 12,
	"ᇙ": 12,
	"ᇚ": 12,
	"ᇛ": 12,
	"ᇜ": 12,
	"ᇝ": 12,
	"ᇞ": 12,
	"ᇟ": 12,
	"ᇠ": 12,
	"ᇡ": 12,
	"ᇢ": 12,
	"ᇣ": 12,
	"ᇤ": 12,
	"ᇥ": 12,
	"ᇦ": 12,
	"ᇧ": 12,
	"ᇨ": 12,
	"ᇩ": 12,
	"ᇪ": 12,
	"ᇫ": 12,
	"ᇬ": 12,
	"ᇭ": 12,
	"ᇮ": 12,
	"ᇯ": 12,
	"ᇰ": 12,
	"ᇱ": 12,
	"ᇲ": 12,
	"ᇳ": 12,
	"ᇴ": 12,
	"ᇵ": 12,
	"ᇶ": 12,
	"ᇷ": 12,
	"ᇸ": 12,
	"ᇹ": 12,
	"ሀ": 8.34,
	"ሁ": 10.81,
	"ሂ": 7.73,
	"ሃ": 7.98,
	"ሄ": 7.86,
	"ህ": 8.75,
	"ሆ": 10.78,
	"ለ": 7.78,
	"ሉ": 9.98,
	"ሊ": 9.97,
	"ላ": 7.78,
	"ሌ": 10.28,
	"ል": 8.8,
	"ሎ": 12.64,
	"ሏ": 10.34,
	"ሐ": 12.27,
	"ሑ": 14.63,
	"ሒ": 14.61,
	"ሓ": 12.27,
	"ሔ": 14.55,
	"ሕ": 12.27,
	"ሖ": 12.31,
	"ሗ": 14.7,
	"መ": 13.06,
	"ሙ": 16.17,
	"ሚ": 13.78,
	"ማ": 13.06,
	"ሜ": 13.75,
	"ም": 13.06,
	"ሞ": 13.06,
	"ሟ": 13.77,
	"ሠ": 11.86,
	"ሡ": 14.69,
	"ሢ": 12.11,
	"ሣ": 11.86,
	"ሤ": 12.14,
	"ሥ": 13.3,
	"ሦ": 11.69,
	"ሧ": 12.11,
	"ረ": 7.36,
	"ሩ": 8.53,
	"ሪ": 8.3,
	"ራ": 10.83,
	"ሬ": 10,
	"ር": 7.48,
	"ሮ": 9.83,
	"ሯ": 10.83,
	"ሰ": 8.11,
	"ሱ": 10.58,
	"ሲ": 10.53,
	"ሳ": 8.11,
	"ሴ": 10.47,
	"ስ": 8.11,
	"ሶ": 8.11,
	"ሷ": 10.63,
	"ሸ": 9.14,
	"ሹ": 11.03,
	"ሺ": 11,
	"ሻ": 9.14,
	"ሼ": 10.92,
	"ሽ": 9.61,
	"ሾ": 9.14,
	"ሿ": 11.09,
	"ቀ": 10.22,
	"ቁ": 10.22,
	"ቂ": 10.22,
	"ቃ": 10.22,
	"ቄ": 10.22,
	"ቅ": 10.22,
	"ቆ": 10.22,
	"ቈ": 11.64,
	"ቊ": 14.7,
	"ቋ": 10.22,
	"ቌ": 10.22,
	"ቍ": 14.72,
	"ቐ": 10.56,
	"ቑ": 10.56,
	"ቒ": 10.56,
	"ቓ": 10.56,
	"ቔ": 10.56,
	"ቕ": 11.64,
	"ቖ": 10.56,
	"ቘ": 11.84,
	"ቚ": 14.91,
	"ቛ": 10.56,
	"ቜ": 10.56,
	"ቝ": 12.8,
	"በ": 8.56,
	"ቡ": 10.81,
	"ቢ": 10.77,
	"ባ": 8.56,
	"ቤ": 10.7,
	"ብ": 11.13,
	"ቦ": 8.56,
	"ቧ": 10.86,
	"ቨ": 9.14,
	"ቩ": 11.03,
	"ቪ": 11,
	"ቫ": 9.14,
	"ቬ": 10.92,
	"ቭ": 11.36,
	"ቮ": 9.14,
	"ቯ": 11.09,
	"ተ": 9.31,
	"ቱ": 9.31,
	"ቲ": 9.31,
	"ታ": 9.39,
	"ቴ": 9.44,
	"ት": 9.31,
	"ቶ": 9.31,
	"ቷ": 9.31,
	"ቸ": 9.31,
	"ቹ": 9.33,
	"ቺ": 9.31,
	"ቻ": 9.39,
	"ቼ": 9.31,
	"ች": 10.97,
	"ቾ": 9.5,
	"ቿ": 9.31,
	"ኀ": 8.33,
	"ኁ": 10.39,
	"ኂ": 9.81,
	"ኃ": 8.33,
	"ኄ": 9.69,
	"ኅ": 8.03,
	"ኆ": 12.28,
	"ኈ": 12.42,
	"ኊ": 11.78,
	"ኋ": 9.09,
	"ኌ": 9.69,
	"ኍ": 11.78,
	"ነ": 6.38,
	"ኑ": 8.44,
	"ኒ": 7.86,
	"ና": 7.59,
	"ኔ": 7.73,
	"ን": 8.2,
	"ኖ": 9.5,
	"ኗ": 8.84,
	"ኘ": 9.08,
	"ኙ": 10.48,
	"ኚ": 9.89,
	"ኛ": 9.08,
	"ኜ": 9.77,
	"ኝ": 9.08,
	"ኞ": 11.09,
	"ኟ": 9.39,
	"አ": 7.67,
	"ኡ": 10.36,
	"ኢ": 10.36,
	"ኣ": 7.67,
	"ኤ": 10.3,
	"እ": 7.88,
	"ኦ": 7.7,
	"ኧ": 9.55,
	"ከ": 8.66,
	"ኩ": 11.11,
	"ኪ": 11.06,
	"ካ": 8.66,
	"ኬ": 11,
	"ክ": 8.66,
	"ኮ": 8.66,
	"ኰ": 13.42,
	"ኲ": 12.48,
	"ኳ": 10.42,
	"ኴ": 11,
	"ኵ": 12.48,
	"ኸ": 10.73,
	"ኹ": 13.2,
	"ኺ": 13.16,
	"ኻ": 10.73,
	"ኼ": 13.09,
	"ኽ": 10.73,
	"ኾ": 10.73,
	"ዀ": 15.52,
	"ዂ": 14.58,
	"ዃ": 13.25,
	"ዄ": 13.09,
	"ዅ": 14.58,
	"ወ": 11.2,
	"ዉ": 13.27,
	"ዊ": 11.2,
	"ዋ": 11.2,
	"ዌ": 11.2,
	"ው": 14.09,
	"ዎ": 11.2,
	"ዐ": 8.09,
	"ዑ": 10.75,
	"ዒ": 10.41,
	"ዓ": 7.81,
	"ዔ": 10.39,
	"ዕ": 7.86,
	"ዖ": 8.48,
	"ዘ": 8.91,
	"ዙ": 10.97,
	"ዚ": 10.98,
	"ዛ": 8.91,
	"ዜ": 10.95,
	"ዝ": 10.8,
	"ዞ": 8.91,
	"ዟ": 11.11,
	"ዠ": 13.42,
	"ዡ": 13.42,
	"ዢ": 13.42,
	"ዣ": 13.42,
	"ዤ": 13.42,
	"ዥ": 14.91,
	"ዦ": 13.42,
	"ዧ": 13.42,
	"የ": 6.98,
	"ዩ": 8.72,
	"ዪ": 9.98,
	"ያ": 7.14,
	"ዬ": 11.33,
	"ይ": 8.41,
	"ዮ": 9.81,
	"ደ": 9.2,
	"ዱ": 12.3,
	"ዲ": 11.59,
	"ዳ": 9,
	"ዴ": 10.97,
	"ድ": 10.11,
	"ዶ": 9.97,
	"ዷ": 11.61,
	"ዸ": 9.14,
	"ዹ": 11.86,
	"ዺ": 11.16,
	"ዻ": 8.56,
	"ዼ": 10.91,
	"ዽ": 10.81,
	"ዾ": 9.97,
	"ዿ": 11.17,
	"ጀ": 9.33,
	"ጁ": 12.42,
	"ጂ": 11.72,
	"ጃ": 9.13,
	"ጄ": 11.47,
	"ጅ": 11,
	"ጆ": 10.02,
	"ጇ": 11.73,
	"ገ": 7.02,
	"ጉ": 10.02,
	"ጊ": 7.28,
	"ጋ": 7.66,
	"ጌ": 7.22,
	"ግ": 9.64,
	"ጎ": 7.02,
	"ጐ": 12.33,
	"ጒ": 11.41,
	"ጓ": 7.5,
	"ጔ": 8.83,
	"ጕ": 11.41,
	"ጘ": 8.84,
	"ጙ": 10.88,
	"ጚ": 8.84,
	"ጛ": 8.84,
	"ጜ": 8.84,
	"ጝ": 10.56,
	"ጞ": 9.5,
	"ጠ": 13.25,
	"ጡ": 15.56,
	"ጢ": 15.55,
	"ጣ": 13.2,
	"ጤ": 15.5,
	"ጥ": 12.84,
	"ጦ": 13.25,
	"ጧ": 15.58,
	"ጨ": 16.34,
	"ጩ": 16.59,
	"ጪ": 16.53,
	"ጫ": 16.34,
	"ጬ": 19.92,
	"ጭ": 15.84,
	"ጮ": 16.08,
	"ጯ": 16.61,
	"ጰ": 8,
	"ጱ": 10.55,
	"ጲ": 10.42,
	"ጳ": 7.84,
	"ጴ": 10.36,
	"ጵ": 10.2,
	"ጶ": 8.06,
	"ጷ": 10.34,
	"ጸ": 8.3,
	"ጹ": 10.72,
	"ጺ": 10.59,
	"ጻ": 8.02,
	"ጼ": 10.53,
	"ጽ": 10.39,
	"ጾ": 8.36,
	"ጿ": 10.41,
	"ፀ": 8.09,
	"ፁ": 10.75,
	"ፂ": 8.3,
	"ፃ": 7.36,
	"ፄ": 8.33,
	"ፅ": 7.86,
	"ፆ": 8.42,
	"ፈ": 10.27,
	"ፉ": 10.39,
	"ፊ": 11.14,
	"ፋ": 10.39,
	"ፌ": 12.23,
	"ፍ": 10.09,
	"ፎ": 10.3,
	"ፏ": 10.09,
	"ፐ": 9.31,
	"ፑ": 9.33,
	"ፒ": 9.31,
	"ፓ": 9.39,
	"ፔ": 9.31,
	"ፕ": 9.31,
	"ፖ": 9.31,
	"ፗ": 9.31,
	"ፘ": 9.67,
	"ፙ": 13.75,
	"ፚ": 11.3,
	"፡": 3.61,
	"።": 7.41,
	"፣": 4.31,
	"፤": 4.31,
	"፥": 4.31,
	"፦": 5.98,
	"፧": 3.61,
	"፨": 11.22,
	"፩": 6.67,
	"፪": 6.08,
	"፫": 6.44,
	"፬": 6.61,
	"፭": 7.86,
	"፮": 7.23,
	"፯": 7.34,
	"፰": 7.8,
	"፱": 6.75,
	"፲": 5.02,
	"፳": 8.97,
	"፴": 8.91,
	"፵": 10.48,
	"፶": 6.61,
	"፷": 7.8,
	"፸": 9.45,
	"፹": 9.84,
	"፺": 6.31,
	"፻": 6.78,
	"፼": 12.45,
	"Ꭰ": 8.72,
	"Ꭱ": 8.25,
	"Ꭲ": 7.05,
	"Ꭳ": 9.06,
	"Ꭴ": 10.78,
	"Ꭵ": 3.78,
	"Ꭶ": 8.41,
	"Ꭷ": 10,
	"Ꭸ": 6.16,
	"Ꭹ": 7.64,
	"Ꭺ": 8.06,
	"Ꭻ": 6.36,
	"Ꭼ": 7.11,
	"Ꭽ": 9.33,
	"Ꭾ": 6.41,
	"Ꭿ": 9.03,
	"Ꮀ": 6.41,
	"Ꮁ": 6.45,
	"Ꮂ": 9.94,
	"Ꮃ": 10.95,
	"Ꮄ": 8.45,
	"Ꮅ": 6.56,
	"Ꮆ": 8.59,
	"Ꮇ": 10.34,
	"Ꮈ": 6.38,
	"Ꮉ": 10.23,
	"Ꮊ": 11.5,
	"Ꮋ": 9,
	"Ꮌ": 6.16,
	"Ꮍ": 8.42,
	"Ꮎ": 8.77,
	"Ꮏ": 7.63,
	"Ꮐ": 8.48,
	"Ꮑ": 9.11,
	"Ꮒ": 7.56,
	"Ꮓ": 7.27,
	"Ꮔ": 6.66,
	"Ꮕ": 11.55,
	"Ꮖ": 7.11,
	"Ꮗ": 9.83,
	"Ꮘ": 8.58,
	"Ꮙ": 13.06,
	"Ꮚ": 9.83,
	"Ꮛ": 7.55,
	"Ꮜ": 8.8,
	"Ꮝ": 10.91,
	"Ꮞ": 7.88,
	"Ꮟ": 7.88,
	"Ꮠ": 6.17,
	"Ꮡ": 8.28,
	"Ꮢ": 8.25,
	"Ꮣ": 6.7,
	"Ꮤ": 11.33,
	"Ꮥ": 8.53,
	"Ꮦ": 8.38,
	"Ꮧ": 7.13,
	"Ꮨ": 7.06,
	"Ꮩ": 8.28,
	"Ꮪ": 7.88,
	"Ꮫ": 10.55,
	"Ꮬ": 9.73,
	"Ꮭ": 6.84,
	"Ꮮ": 6.45,
	"Ꮯ": 8.19,
	"Ꮰ": 8.44,
	"Ꮱ": 10.22,
	"Ꮲ": 7.73,
	"Ꮳ": 8.34,
	"Ꮴ": 8.28,
	"Ꮵ": 9.52,
	"Ꮶ": 8.39,
	"Ꮷ": 6.09,
	"Ꮸ": 10.59,
	"Ꮹ": 9.3,
	"Ꮺ": 11,
	"Ꮻ": 8.77,
	"Ꮼ": 10.22,
	"Ꮽ": 7.97,
	"Ꮾ": 7.75,
	"Ꮿ": 9.83,
	"Ᏸ": 7.83,
	"Ᏹ": 9.05,
	"Ᏺ": 7.77,
	"Ᏻ": 10.39,
	"Ᏼ": 8.44,
	"ᐁ": 9.52,
	"ᐂ": 9.52,
	"ᐃ": 9.52,
	"ᐄ": 9.52,
	"ᐅ": 8.95,
	"ᐆ": 8.95,
	"ᐇ": 8.95,
	"ᐈ": 8.95,
	"ᐉ": 8.95,
	"ᐊ": 8.98,
	"ᐋ": 8.98,
	"ᐌ": 9.64,
	"ᐍ": 9.64,
	"ᐎ": 9.64,
	"ᐏ": 9.64,
	"ᐐ": 9.64,
	"ᐑ": 9.64,
	"ᐒ": 10.61,
	"ᐓ": 11.22,
	"ᐔ": 10.61,
	"ᐕ": 11.22,
	"ᐖ": 8.95,
	"ᐗ": 11.22,
	"ᐘ": 10.61,
	"ᐙ": 11.22,
	"ᐚ": 10.61,
	"ᐛ": 8.95,
	"ᐜ": 7.98,
	"ᐝ": 7.11,
	"ᐞ": 5.95,
	"ᐟ": 3.84,
	"ᐠ": 3.84,
	"ᐡ": 5.52,
	"ᐢ": 5.52,
	"ᐣ": 4.11,
	"ᐤ": 5.78,
	"ᐥ": 6,
	"ᐦ": 3.83,
	"ᐧ": 2.5,
	"ᐨ": 4.81,
	"ᐩ": 4.95,
	"ᐪ": 4.8,
	"ᐫ": 13.33,
	"ᐬ": 10.69,
	"ᐭ": 11.5,
	"ᐮ": 12.58,
	"ᐯ": 9.98,
	"ᐰ": 9.95,
	"ᐱ": 9.95,
	"ᐲ": 9.95,
	"ᐳ": 9.13,
	"ᐴ": 9.13,
	"ᐵ": 9.13,
	"ᐶ": 9.13,
	"ᐷ": 9.13,
	"ᐸ": 9.13,
	"ᐹ": 9.13,
	"ᐺ": 10.08,
	"ᐻ": 10.08,
	"ᐼ": 10.08,
	"ᐽ": 10.23,
	"ᐾ": 10.08,
	"ᐿ": 9.97,
	"ᑀ": 10.34,
	"ᑁ": 11.09,
	"ᑂ": 10.34,
	"ᑃ": 11.09,
	"ᑄ": 11.16,
	"ᑅ": 10.34,
	"ᑆ": 11.23,
	"ᑇ": 10.34,
	"ᑈ": 9.13,
	"ᑉ": 5.05,
	"ᑊ": 1.67,
	"ᑋ": 4.42,
	"ᑌ": 9.8,
	"ᑍ": 9.8,
	"ᑎ": 9.8,
	"ᑏ": 9.8,
	"ᑐ": 8.42,
	"ᑑ": 8.42,
	"ᑒ": 8.42,
	"ᑓ": 8.42,
	"ᑔ": 8.42,
	"ᑕ": 8.42,
	"ᑖ": 8.42,
	"ᑗ": 11.63,
	"ᑘ": 11.28,
	"ᑙ": 11.27,
	"ᑚ": 11.64,
	"ᑛ": 11.27,
	"ᑜ": 11.64,
	"ᑝ": 9.89,
	"ᑞ": 10.09,
	"ᑟ": 9.89,
	"ᑠ": 10.09,
	"ᑡ": 10.09,
	"ᑢ": 9.89,
	"ᑣ": 10.09,
	"ᑤ": 9.89,
	"ᑥ": 10.11,
	"ᑦ": 4.11,
	"ᑧ": 11.5,
	"ᑨ": 11.5,
	"ᑩ": 10.48,
	"ᑪ": 10.48,
	"ᑫ": 7.52,
	"ᑬ": 7.52,
	"ᑭ": 7.52,
	"ᑮ": 7.52,
	"ᑯ": 7.52,
	"ᑰ": 7.52,
	"ᑱ": 7.52,
	"ᑲ": 7.52,
	"ᑳ": 7.52,
	"ᑴ": 9.19,
	"ᑵ": 9.19,
	"ᑶ": 8.84,
	"ᑷ": 9.52,
	"ᑸ": 8.84,
	"ᑹ": 9.52,
	"ᑺ": 9.19,
	"ᑻ": 9.19,
	"ᑼ": 9.19,
	"ᑽ": 9.19,
	"ᑾ": 9.19,
	"ᑿ": 9.19,
	"ᒀ": 9.19,
	"ᒁ": 9.19,
	"ᒂ": 9.19,
	"ᒃ": 4.64,
	"ᒄ": 4.64,
	"ᒅ": 9.31,
	"ᒆ": 9.64,
	"ᒇ": 9.45,
	"ᒈ": 9.45,
	"ᒉ": 7.81,
	"ᒊ": 7.81,
	"ᒋ": 7.81,
	"ᒌ": 7.81,
	"ᒍ": 7.81,
	"ᒎ": 7.81,
	"ᒏ": 7.81,
	"ᒐ": 7.81,
	"ᒑ": 7.81,
	"ᒒ": 9.48,
	"ᒓ": 9.48,
	"ᒔ": 9.48,
	"ᒕ": 9.48,
	"ᒖ": 9.48,
	"ᒗ": 9.48,
	"ᒘ": 9.48,
	"ᒙ": 9.48,
	"ᒚ": 9.48,
	"ᒛ": 9.48,
	"ᒜ": 9.48,
	"ᒝ": 9.48,
	"ᒞ": 9.48,
	"ᒟ": 9.48,
	"ᒠ": 9.48,
	"ᒡ": 4.48,
	"ᒢ": 4.48,
	"ᒣ": 7.72,
	"ᒤ": 7.47,
	"ᒥ": 7.47,
	"ᒦ": 7.47,
	"ᒧ": 7.47,
	"ᒨ": 7.47,
	"ᒩ": 7.47,
	"ᒪ": 7.47,
	"ᒫ": 7.47,
	"ᒬ": 8.69,
	"ᒭ": 9.39,
	"ᒮ": 9.14,
	"ᒯ": 8.44,
	"ᒰ": 9.14,
	"ᒱ": 8.44,
	"ᒲ": 8.44,
	"ᒳ": 9.14,
	"ᒴ": 8.44,
	"ᒵ": 9.14,
	"ᒶ": 9.14,
	"ᒷ": 8.44,
	"ᒸ": 9.14,
	"ᒹ": 8.44,
	"ᒺ": 9,
	"ᒻ": 4.19,
	"ᒼ": 4.11,
	"ᒽ": 4.19,
	"ᒾ": 5.17,
	"ᒿ": 7.27,
	"ᓀ": 11.02,
	"ᓁ": 11.02,
	"ᓂ": 11.02,
	"ᓃ": 11.02,
	"ᓄ": 11.02,
	"ᓅ": 11.02,
	"ᓆ": 11.02,
	"ᓇ": 11.02,
	"ᓈ": 11.02,
	"ᓉ": 12.69,
	"ᓊ": 12.69,
	"ᓋ": 12.69,
	"ᓌ": 11.02,
	"ᓍ": 12.69,
	"ᓎ": 11.02,
	"ᓏ": 11.02,
	"ᓐ": 6.5,
	"ᓑ": 5.52,
	"ᓒ": 6.5,
	"ᓓ": 10.48,
	"ᓔ": 10.48,
	"ᓕ": 10.48,
	"ᓖ": 10.48,
	"ᓗ": 10.48,
	"ᓘ": 10.48,
	"ᓙ": 10.48,
	"ᓚ": 10.48,
	"ᓛ": 10.48,
	"ᓜ": 12.16,
	"ᓝ": 12.16,
	"ᓞ": 11.89,
	"ᓟ": 12.42,
	"ᓠ": 11.89,
	"ᓡ": 12.42,
	"ᓢ": 10.48,
	"ᓣ": 12.16,
	"ᓤ": 10.48,
	"ᓥ": 12.16,
	"ᓦ": 12.16,
	"ᓧ": 10.61,
	"ᓨ": 11.89,
	"ᓩ": 10.61,
	"ᓪ": 5.98,
	"ᓫ": 5.36,
	"ᓬ": 8.03,
	"ᓭ": 7.06,
	"ᓮ": 7.06,
	"ᓯ": 7.06,
	"ᓰ": 7.06,
	"ᓱ": 7.06,
	"ᓲ": 7.06,
	"ᓳ": 7.06,
	"ᓴ": 7.06,
	"ᓵ": 7.06,
	"ᓶ": 8.44,
	"ᓷ": 8.72,
	"ᓸ": 8.7,
	"ᓹ": 8.42,
	"ᓺ": 8.89,
	"ᓻ": 8.42,
	"ᓼ": 7.61,
	"ᓽ": 9.28,
	"ᓾ": 7.61,
	"ᓿ": 9.28,
	"ᔀ": 8.88,
	"ᔁ": 9.05,
	"ᔂ": 9.42,
	"ᔃ": 8.53,
	"ᔄ": 8.72,
	"ᔅ": 4.3,
	"ᔆ": 4.91,
	"ᔇ": 4.3,
	"ᔈ": 5.98,
	"ᔉ": 4.28,
	"ᔊ": 4.28,
	"ᔋ": 4.3,
	"ᔌ": 13.41,
	"ᔍ": 12.88,
	"ᔎ": 11.8,
	"ᔏ": 12.09,
	"ᔐ": 10.34,
	"ᔑ": 10.34,
	"ᔒ": 10.34,
	"ᔓ": 11.27,
	"ᔔ": 11.27,
	"ᔕ": 11.27,
	"ᔖ": 11.27,
	"ᔗ": 12,
	"ᔘ": 12,
	"ᔙ": 12,
	"ᔚ": 12,
	"ᔛ": 12,
	"ᔜ": 12,
	"ᔝ": 12.94,
	"ᔞ": 13.05,
	"ᔟ": 12.94,
	"ᔠ": 13.05,
	"ᔡ": 13.05,
	"ᔢ": 12.94,
	"ᔣ": 13.05,
	"ᔤ": 12.94,
	"ᔥ": 8.09,
	"ᔦ": 6.94,
	"ᔧ": 6.94,
	"ᔨ": 6.94,
	"ᔩ": 6.94,
	"ᔪ": 6.94,
	"ᔫ": 6.94,
	"ᔬ": 6.94,
	"ᔭ": 6.94,
	"ᔮ": 6.94,
	"ᔯ": 8.61,
	"ᔰ": 8.61,
	"ᔱ": 8.61,
	"ᔲ": 8.61,
	"ᔳ": 8.61,
	"ᔴ": 8.61,
	"ᔵ": 8.97,
	"ᔶ": 8.61,
	"ᔷ": 8.97,
	"ᔸ": 8.61,
	"ᔹ": 8.61,
	"ᔺ": 8.61,
	"ᔻ": 8.61,
	"ᔼ": 8.61,
	"ᔽ": 8.61,
	"ᔾ": 4.17,
	"ᔿ": 5.56,
	"ᕀ": 4.06,
	"ᕁ": 4.06,
	"ᕂ": 11.3,
	"ᕃ": 11.3,
	"ᕄ": 11.3,
	"ᕅ": 11.3,
	"ᕆ": 11.3,
	"ᕇ": 11.3,
	"ᕈ": 7.39,
	"ᕉ": 7.39,
	"ᕊ": 7.39,
	"ᕋ": 7.39,
	"ᕌ": 7.39,
	"ᕍ": 7.39,
	"ᕎ": 9.06,
	"ᕏ": 9.06,
	"ᕐ": 4.36,
	"ᕑ": 5.36,
	"ᕒ": 8.03,
	"ᕓ": 9.7,
	"ᕔ": 9.7,
	"ᕕ": 9.7,
	"ᕖ": 9.7,
	"ᕗ": 10.31,
	"ᕘ": 10.31,
	"ᕙ": 10.31,
	"ᕚ": 10.31,
	"ᕛ": 11.98,
	"ᕜ": 11.86,
	"ᕝ": 5.86,
	"ᕞ": 10.05,
	"ᕟ": 10.05,
	"ᕠ": 10.05,
	"ᕡ": 10.05,
	"ᕢ": 10.05,
	"ᕣ": 10.05,
	"ᕤ": 9,
	"ᕥ": 9,
	"ᕦ": 9,
	"ᕧ": 9,
	"ᕨ": 10.67,
	"ᕩ": 10.67,
	"ᕪ": 5.5,
	"ᕫ": 9.8,
	"ᕬ": 9.8,
	"ᕭ": 8.42,
	"ᕮ": 8.42,
	"ᕯ": 7.22,
	"ᕰ": 9.8,
	"ᕱ": 9.8,
	"ᕲ": 8.42,
	"ᕳ": 8.42,
	"ᕴ": 9.38,
	"ᕵ": 9.38,
	"ᕶ": 9.38,
	"ᕷ": 9.22,
	"ᕸ": 9.22,
	"ᕹ": 9.22,
	"ᕺ": 9.22,
	"ᕻ": 5.92,
	"ᕼ": 8.56,
	"ᕽ": 4,
	"ᕾ": 11.86,
	"ᕿ": 11.86,
	"ᖀ": 11.86,
	"ᖁ": 11.86,
	"ᖂ": 11.86,
	"ᖃ": 11.86,
	"ᖄ": 11.86,
	"ᖅ": 9,
	"ᖆ": 7.52,
	"ᖇ": 7.52,
	"ᖈ": 7.52,
	"ᖉ": 7.52,
	"ᖊ": 9.69,
	"ᖋ": 9.69,
	"ᖌ": 9.69,
	"ᖍ": 9.69,
	"ᖎ": 14.38,
	"ᖏ": 14.38,
	"ᖐ": 14.38,
	"ᖑ": 11.5,
	"ᖒ": 11.5,
	"ᖓ": 14.38,
	"ᖔ": 14.38,
	"ᖕ": 6.56,
	"ᖖ": 10.13,
	"ᖗ": 7.52,
	"ᖘ": 7.52,
	"ᖙ": 7.52,
	"ᖚ": 7.52,
	"ᖛ": 11.02,
	"ᖜ": 11.02,
	"ᖝ": 11.02,
	"ᖞ": 11.02,
	"ᖟ": 6.5,
	"ᖠ": 10.48,
	"ᖡ": 10.48,
	"ᖢ": 10.48,
	"ᖣ": 10.48,
	"ᖤ": 10.48,
	"ᖥ": 10.48,
	"ᖦ": 5.98,
	"ᖧ": 6.94,
	"ᖨ": 6.94,
	"ᖩ": 6.94,
	"ᖪ": 6.94,
	"ᖫ": 6.94,
	"ᖬ": 6.94,
	"ᖭ": 6.94,
	"ᖮ": 4.17,
	"ᖯ": 6.84,
	"ᖰ": 6.09,
	"ᖱ": 6.09,
	"ᖲ": 6.09,
	"ᖳ": 6.09,
	"ᖴ": 6.92,
	"ᖵ": 6.92,
	"ᖶ": 6.92,
	"ᖷ": 6.92,
	"ᖸ": 8.69,
	"ᖹ": 8.69,
	"ᖺ": 8.69,
	"ᖻ": 8.69,
	"ᖼ": 8.69,
	"ᖽ": 8.69,
	"ᖾ": 8.69,
	"ᖿ": 8.69,
	"ᗀ": 8.69,
	"ᗁ": 8.69,
	"ᗂ": 8.69,
	"ᗃ": 8.69,
	"ᗄ": 9.98,
	"ᗅ": 9.98,
	"ᗆ": 9.11,
	"ᗇ": 9.11,
	"ᗈ": 9.11,
	"ᗉ": 9.11,
	"ᗊ": 9.98,
	"ᗋ": 9.98,
	"ᗌ": 9.11,
	"ᗍ": 9.11,
	"ᗎ": 9.11,
	"ᗏ": 9.11,
	"ᗐ": 9.98,
	"ᗑ": 9.98,
	"ᗒ": 9.13,
	"ᗓ": 9.13,
	"ᗔ": 9.13,
	"ᗕ": 9.13,
	"ᗖ": 9.98,
	"ᗗ": 9.98,
	"ᗘ": 9.13,
	"ᗙ": 9.13,
	"ᗚ": 9.13,
	"ᗛ": 9.13,
	"ᗜ": 9.63,
	"ᗝ": 9.63,
	"ᗞ": 8.16,
	"ᗟ": 8.16,
	"ᗠ": 8.16,
	"ᗡ": 8.16,
	"ᗢ": 9.63,
	"ᗣ": 9.63,
	"ᗤ": 7.8,
	"ᗥ": 7.8,
	"ᗦ": 7.8,
	"ᗧ": 7.8,
	"ᗨ": 9.88,
	"ᗩ": 9.88,
	"ᗪ": 8.28,
	"ᗫ": 8.28,
	"ᗬ": 8.28,
	"ᗭ": 8.28,
	"ᗮ": 4.8,
	"ᗯ": 11.89,
	"ᗰ": 11.89,
	"ᗱ": 6.81,
	"ᗲ": 6.81,
	"ᗳ": 6.81,
	"ᗴ": 6.81,
	"ᗵ": 11.89,
	"ᗶ": 11.89,
	"ᗷ": 7.97,
	"ᗸ": 7.97,
	"ᗹ": 7.97,
	"ᗺ": 7.97,
	"ᗻ": 11.89,
	"ᗼ": 11.89,
	"ᗽ": 7.97,
	"ᗾ": 7.97,
	"ᗿ": 7.97,
	"ᘀ": 7.97,
	"ᘁ": 5.72,
	"ᘂ": 7.81,
	"ᘃ": 7.81,
	"ᘄ": 10.69,
	"ᘅ": 10.69,
	"ᘆ": 10.69,
	"ᘇ": 10.69,
	"ᘈ": 11.89,
	"ᘉ": 11.89,
	"ᘊ": 6.81,
	"ᘋ": 6.81,
	"ᘌ": 6.81,
	"ᘍ": 6.81,
	"ᘎ": 9.88,
	"ᘏ": 9.88,
	"ᘐ": 8.2,
	"ᘑ": 8.2,
	"ᘒ": 8.2,
	"ᘓ": 8.2,
	"ᘔ": 7.67,
	"ᘕ": 7.67,
	"ᘖ": 7.67,
	"ᘗ": 10.89,
	"ᘘ": 10.89,
	"ᘙ": 10.89,
	"ᘚ": 10.89,
	"ᘛ": 10.89,
	"ᘜ": 8.11,
	"ᘝ": 8.11,
	"ᘞ": 10.91,
	"ᘟ": 10.91,
	"ᘠ": 10.91,
	"ᘡ": 10.91,
	"ᘢ": 11.2,
	"ᘣ": 11.2,
	"ᘤ": 7.52,
	"ᘥ": 7.52,
	"ᘦ": 7.52,
	"ᘧ": 7.52,
	"ᘨ": 11.3,
	"ᘩ": 11.3,
	"ᘪ": 7.75,
	"ᘫ": 7.75,
	"ᘬ": 7.75,
	"ᘭ": 7.75,
	"ᘮ": 10.44,
	"ᘯ": 10.44,
	"ᘰ": 7.52,
	"ᘱ": 7.47,
	"ᘲ": 7.47,
	"ᘳ": 7.52,
	"ᘴ": 11.75,
	"ᘵ": 11.75,
	"ᘶ": 7.63,
	"ᘷ": 7.63,
	"ᘸ": 7.63,
	"ᘹ": 7.63,
	"ᘺ": 13.66,
	"ᘻ": 13.66,
	"ᘼ": 6.95,
	"ᘽ": 6.95,
	"ᘾ": 6.95,
	"ᘿ": 6.95,
	"ᙀ": 9.14,
	"ᙁ": 9.14,
	"ᙂ": 8.27,
	"ᙃ": 8.27,
	"ᙄ": 8.27,
	"ᙅ": 8.27,
	"ᙆ": 4.89,
	"ᙇ": 4.89,
	"ᙈ": 9.14,
	"ᙉ": 9.14,
	"ᙊ": 8.27,
	"ᙋ": 8.27,
	"ᙌ": 8.27,
	"ᙍ": 8.27,
	"ᙎ": 12.23,
	"ᙏ": 12.23,
	"ᙐ": 6.81,
	"ᙑ": 6.81,
	"ᙒ": 6.81,
	"ᙓ": 6.81,
	"ᙔ": 12.23,
	"ᙕ": 12.23,
	"ᙖ": 7.39,
	"ᙗ": 7.39,
	"ᙘ": 7.39,
	"ᙙ": 7.39,
	"ᙚ": 4.52,
	"ᙛ": 12.23,
	"ᙜ": 12.23,
	"ᙝ": 7.66,
	"ᙞ": 7.66,
	"ᙟ": 7.66,
	"ᙠ": 7.66,
	"ᙡ": 12.23,
	"ᙢ": 12.23,
	"ᙣ": 6.81,
	"ᙤ": 6.81,
	"ᙥ": 6.81,
	"ᙦ": 6.81,
	"ᙧ": 12.23,
	"ᙨ": 12.23,
	"ᙩ": 7.66,
	"ᙪ": 7.66,
	"ᙫ": 7.66,
	"ᙬ": 7.66,
	"᙭": 7.5,
	"᙮": 5.75,
	"ᙯ": 11.86,
	"ᙰ": 17.94,
	"ᙱ": 17.94,
	"ᙲ": 18.34,
	"ᙳ": 15.14,
	"ᙴ": 15.14,
	"ᙵ": 17.94,
	"ᙶ": 17.94,
	"ᚁ": 4.5,
	"ᚂ": 6.31,
	"ᚃ": 8.11,
	"ᚄ": 9.91,
	"ᚅ": 11.7,
	"ᚆ": 4.5,
	"ᚇ": 6.31,
	"ᚈ": 8.11,
	"ᚉ": 9.91,
	"ᚊ": 11.7,
	"ᚋ": 5.41,
	"ᚌ": 7.2,
	"ᚍ": 9,
	"ᚎ": 10.81,
	"ᚏ": 12.61,
	"ᚐ": 4.5,
	"ᚑ": 6.31,
	"ᚒ": 8.11,
	"ᚓ": 9.91,
	"ᚔ": 11.7,
	"ᚕ": 7.2,
	"ᚖ": 7.66,
	"ᚗ": 7,
	"ᚘ": 7.63,
	"ᚙ": 9.7,
	"ᚚ": 7.2,
	"᚛": 6.88,
	"᚜": 6.88,
	"ᚠ": 8.06,
	"ᚡ": 8.06,
	"ᚢ": 7.39,
	"ᚣ": 7.39,
	"ᚤ": 7.39,
	"ᚥ": 7.39,
	"ᚦ": 7.13,
	"ᚧ": 7.13,
	"ᚨ": 6.28,
	"ᚩ": 9.17,
	"ᚪ": 8.94,
	"ᚫ": 4.77,
	"ᚬ": 9.33,
	"ᚭ": 6.16,
	"ᚮ": 6.69,
	"ᚯ": 9.41,
	"ᚰ": 9.14,
	"ᚱ": 7.45,
	"ᚲ": 6,
	"ᚳ": 7.3,
	"ᚴ": 7.53,
	"ᚵ": 7.53,
	"ᚶ": 8.5,
	"ᚷ": 12.22,
	"ᚸ": 12.41,
	"ᚹ": 6.97,
	"ᚺ": 7.69,
	"ᚻ": 7.69,
	"ᚼ": 9.25,
	"ᚽ": 5.41,
	"ᚾ": 9.22,
	"ᚿ": 6.02,
	"ᛀ": 9.25,
	"ᛁ": 3.48,
	"ᛂ": 4.5,
	"ᛃ": 8.91,
	"ᛄ": 6.94,
	"ᛅ": 9.11,
	"ᛆ": 6.69,
	"ᛇ": 11.77,
	"ᛈ": 9.09,
	"ᛉ": 12.16,
	"ᛊ": 7.77,
	"ᛋ": 7.22,
	"ᛌ": 3.55,
	"ᛍ": 5.42,
	"ᛎ": 9.31,
	"ᛏ": 11.7,
	"ᛐ": 7.92,
	"ᛑ": 8.94,
	"ᛒ": 7.19,
	"ᛓ": 6.22,
	"ᛔ": 7.19,
	"ᛕ": 7.86,
	"ᛖ": 11.53,
	"ᛗ": 11.53,
	"ᛘ": 9.94,
	"ᛙ": 5.25,
	"ᛚ": 7.36,
	"ᛛ": 8.38,
	"ᛜ": 10.83,
	"ᛝ": 8.39,
	"ᛞ": 11.91,
	"ᛟ": 8.48,
	"ᛠ": 15.33,
	"ᛡ": 7.97,
	"ᛢ": 15.45,
	"ᛣ": 11.83,
	"ᛤ": 12.41,
	"ᛥ": 11.39,
	"ᛦ": 9.69,
	"ᛧ": 3.67,
	"ᛨ": 11.91,
	"ᛩ": 7.53,
	"ᛪ": 10.78,
	"᛫": 4.8,
	"᛬": 4.3,
	"᛭": 8.05,
	"ᛮ": 10.56,
	"ᛯ": 10.09,
	"ᛰ": 8.47,
	"ក": 7.2,
	"ខ": 7.2,
	"គ": 7.2,
	"ឃ": 11.41,
	"ង": 7.2,
	"ច": 7.2,
	"ឆ": 7.2,
	"ជ": 7.2,
	"ឈ": 15.61,
	"ញ": 11.41,
	"ដ": 7.2,
	"ឋ": 7.2,
	"ឌ": 7.2,
	"ឍ": 11.41,
	"ណ": 15.61,
	"ត": 7.2,
	"ថ": 7.2,
	"ទ": 7.47,
	"ធ": 7.2,
	"ន": 7.2,
	"ប": 7.2,
	"ផ": 7.2,
	"ព": 7.2,
	"ភ": 7.2,
	"ម": 7.2,
	"យ": 11.41,
	"រ": 4.2,
	"ល": 11.41,
	"វ": 4.2,
	"ឝ": 7.2,
	"ឞ": 7.2,
	"ស": 11.41,
	"ហ": 11.41,
	"ឡ": 11.67,
	"អ": 6.97,
	"ឣ": 7.2,
	"ឤ": 11.41,
	"ឥ": 7.2,
	"ឦ": 11.41,
	"ឧ": 7.2,
	"ឨ": 7.2,
	"ឩ": 8.53,
	"ឪ": 7.45,
	"ឫ": 7.2,
	"ឬ": 7.2,
	"ឭ": 7.2,
	"ឮ": 7.2,
	"ឯ": 7.2,
	"ឰ": 7.2,
	"ឱ": 7.2,
	"ឲ": 7.2,
	"ឳ": 7.2,
	"឴": 5.42,
	"឵": 5.42,
	"ា": 10.3,
	"ិ": 6.69,
	"ី": 6.69,
	"ឹ": 6.69,
	"ឺ": 6.69,
	"ុ": 5.73,
	"ូ": 5.73,
	"ួ": 5.73,
	"ើ": 10.81,
	"ឿ": 12.27,
	"ៀ": 12.27,
	"េ": 9.98,
	"ែ": 9.98,
	"ៃ": 10.73,
	"ោ": 14.52,
	"ៅ": 14.94,
	"ំ": 5.73,
	"ះ": 9.55,
	"ៈ": 8.58,
	"៉": 5.73,
	"៊": 7.17,
	"់": 5.73,
	"៌": 5.73,
	"៍": 5.78,
	"៎": 5.73,
	"៏": 5.73,
	"័": 5.73,
	"៑": 5.73,
	"្": 5.73,
	"៓": 5.73,
	"។": 5.58,
	"៕": 7.45,
	"៖": 4.13,
	"ៗ": 6.36,
	"៘": 21.91,
	"៙": 7.77,
	"៚": 14.11,
	"៛": 4.56,
	"ៜ": 6.36,
	"០": 6.36,
	"១": 6.36,
	"២": 7.94,
	"៣": 10.56,
	"៤": 7.14,
	"៥": 7.14,
	"៦": 7.14,
	"៧": 8.38,
	"៨": 7.14,
	"៩": 6.78,
	"᠀": 6.42,
	"᠁": 12.38,
	"᠂": 4.61,
	"᠃": 7.66,
	"᠄": 4.61,
	"᠅": 6.98,
	"᠆": 4.81,
	"᠇": 6.42,
	"᠈": 5.08,
	"᠉": 7.72,
	"᠊": 2.03,
	"᠋": 0,
	"᠌": 0,
	"᠍": 0,
	"᠐": 6.88,
	"᠑": 6.88,
	"᠒": 7.27,
	"᠓": 10.5,
	"᠔": 6.42,
	"᠕": 8.55,
	"᠖": 7.56,
	"᠗": 7.56,
	"᠘": 6.78,
	"᠙": 6.42,
	"ᠠ": 11.16,
	"ᠡ": 9.89,
	"ᠢ": 11.92,
	"ᠣ": 11.19,
	"ᠤ": 11.19,
	"ᠥ": 14.83,
	"ᠦ": 14.83,
	"ᠧ": 14.41,
	"ᠨ": 6.81,
	"ᠩ": 8.86,
	"ᠪ": 8.17,
	"ᠫ": 8.11,
	"ᠬ": 10.36,
	"ᠭ": 10.36,
	"ᠮ": 6.81,
	"ᠯ": 6.81,
	"ᠰ": 9.08,
	"ᠱ": 9.08,
	"ᠲ": 8.95,
	"ᠳ": 8.98,
	"ᠴ": 9.22,
	"ᠵ": 5.95,
	"ᠶ": 5.95,
	"ᠷ": 8.33,
	"ᠸ": 7.14,
	"ᠹ": 8.17,
	"ᠺ": 6.63,
	"ᠻ": 6.61,
	"ᠼ": 10.72,
	"ᠽ": 9.78,
	"ᠾ": 13.06,
	"ᠿ": 10.91,
	"ᡀ": 13.06,
	"ᡁ": 7.7,
	"ᡂ": 14.13,
	"ᡃ": 2.42,
	"ᡄ": 10.8,
	"ᡅ": 10.88,
	"ᡆ": 10.98,
	"ᡇ": 13.52,
	"ᡈ": 10.98,
	"ᡉ": 13.52,
	"ᡊ": 12.83,
	"ᡋ": 11.11,
	"ᡌ": 8.59,
	"ᡍ": 10.34,
	"ᡎ": 10.34,
	"ᡏ": 6.31,
	"ᡐ": 8.69,
	"ᡑ": 6.63,
	"ᡒ": 9.42,
	"ᡓ": 9.22,
	"ᡔ": 7.81,
	"ᡕ": 5.42,
	"ᡖ": 9,
	"ᡗ": 6.83,
	"ᡘ": 6.58,
	"ᡙ": 13.2,
	"ᡚ": 8.88,
	"ᡛ": 6.22,
	"ᡜ": 8.73,
	"ᡝ": 9.89,
	"ᡞ": 11.92,
	"ᡟ": 3.42,
	"ᡠ": 11.19,
	"ᡡ": 14.83,
	"ᡢ": 11.05,
	"ᡣ": 5.14,
	"ᡤ": 8.33,
	"ᡥ": 9.52,
	"ᡦ": 8.63,
	"ᡧ": 8.19,
	"ᡨ": 9.98,
	"ᡩ": 8.95,
	"ᡪ": 6.16,
	"ᡫ": 7.14,
	"ᡬ": 6.63,
	"ᡭ": 6.63,
	"ᡮ": 9.08,
	"ᡯ": 9.08,
	"ᡰ": 4.48,
	"ᡱ": 9.22,
	"ᡲ": 6.16,
	"ᡳ": 11.92,
	"ᡴ": 6.58,
	"ᡵ": 10.42,
	"ᡶ": 6.73,
	"ᡷ": 5.95,
	"ᢀ": 7,
	"ᢁ": 9.48,
	"ᢂ": 8.08,
	"ᢃ": 5.8,
	"ᢄ": 5.8,
	"ᢅ": 7.14,
	"ᢆ": 7.14,
	"ᢇ": 12.27,
	"ᢈ": 11.92,
	"ᢉ": 8.48,
	"ᢊ": 10.92,
	"ᢋ": 7.53,
	"ᢌ": 6.13,
	"ᢍ": 9.52,
	"ᢎ": 7.39,
	"ᢏ": 6.31,
	"ᢐ": 6.53,
	"ᢑ": 6.63,
	"ᢒ": 8.17,
	"ᢓ": 8.11,
	"ᢔ": 7.88,
	"ᢕ": 10,
	"ᢖ": 8.73,
	"ᢗ": 6.61,
	"ᢘ": 7.5,
	"ᢙ": 10.33,
	"ᢚ": 14.03,
	"ᢛ": 10.2,
	"ᢜ": 9.08,
	"ᢝ": 11.08,
	"ᢞ": 6.25,
	"ᢟ": 8.38,
	"ᢠ": 6.63,
	"ᢡ": 12.58,
	"ᢢ": 9.08,
	"ᢣ": 6.25,
	"ᢤ": 9.08,
	"ᢥ": 9.08,
	"ᢦ": 6.06,
	"ᢧ": 6.69,
	"ᢨ": 11.98,
	"ᢩ": 7.14,
	"Ḁ": 8.09,
	"ḁ": 6.63,
	"Ḃ": 7.89,
	"ḃ": 7.38,
	"Ḅ": 7.89,
	"ḅ": 7.38,
	"Ḇ": 7.89,
	"ḇ": 7.38,
	"Ḉ": 8.59,
	"ḉ": 6.72,
	"Ḋ": 8.72,
	"ḋ": 7.38,
	"Ḍ": 8.72,
	"ḍ": 7.38,
	"Ḏ": 8.72,
	"ḏ": 7.38,
	"Ḑ": 8.72,
	"ḑ": 7.38,
	"Ḓ": 8.72,
	"ḓ": 7.38,
	"Ḕ": 7.16,
	"ḕ": 6.86,
	"Ḗ": 7.16,
	"ḗ": 6.86,
	"Ḙ": 7.16,
	"ḙ": 6.86,
	"Ḛ": 7.16,
	"ḛ": 6.86,
	"Ḝ": 7.16,
	"ḝ": 6.86,
	"Ḟ": 6.88,
	"ḟ": 4.34,
	"Ḡ": 8.97,
	"ḡ": 7.31,
	"Ḣ": 8.91,
	"ḣ": 7.06,
	"Ḥ": 8.91,
	"ḥ": 7.06,
	"Ḧ": 8.91,
	"ḧ": 7.06,
	"Ḩ": 8.91,
	"ḩ": 7.06,
	"Ḫ": 8.91,
	"ḫ": 7.06,
	"Ḭ": 3.22,
	"ḭ": 2.97,
	"Ḯ": 3.22,
	"ḯ": 2.97,
	"Ḱ": 7.91,
	"ḱ": 6.52,
	"Ḳ": 7.91,
	"ḳ": 6.52,
	"Ḵ": 7.91,
	"ḵ": 6.52,
	"Ḷ": 6.83,
	"ḷ": 3.05,
	"Ḹ": 6.83,
	"ḹ": 3.05,
	"Ḻ": 6.83,
	"ḻ": 3.05,
	"Ḽ": 6.83,
	"ḽ": 3.05,
	"Ḿ": 10.5,
	"ḿ": 10.45,
	"Ṁ": 10.5,
	"ṁ": 10.45,
	"Ṃ": 10.5,
	"ṃ": 10.45,
	"Ṅ": 8.91,
	"ṅ": 7.02,
	"Ṇ": 8.91,
	"ṇ": 7.02,
	"Ṉ": 8.91,
	"ṉ": 7.02,
	"Ṋ": 8.91,
	"ṋ": 7.02,
	"Ṍ": 9.27,
	"ṍ": 7.09,
	"Ṏ": 9.27,
	"ṏ": 7.09,
	"Ṑ": 9.27,
	"ṑ": 7.09,
	"Ṓ": 9.27,
	"ṓ": 7.09,
	"Ṕ": 7.63,
	"ṕ": 7.33,
	"Ṗ": 7.63,
	"ṗ": 7.33,
	"Ṙ": 7.84,
	"ṙ": 4.58,
	"Ṛ": 7.84,
	"ṛ": 4.58,
	"Ṝ": 7.84,
	"ṝ": 4.58,
	"Ṟ": 7.84,
	"ṟ": 4.58,
	"Ṡ": 7.66,
	"ṡ": 6.28,
	"Ṣ": 7.66,
	"ṣ": 6.28,
	"Ṥ": 7.66,
	"ṥ": 6.28,
	"Ṧ": 7.66,
	"ṧ": 6.28,
	"Ṩ": 7.66,
	"ṩ": 6.28,
	"Ṫ": 7.61,
	"ṫ": 4.36,
	"Ṭ": 7.61,
	"ṭ": 4.36,
	"Ṯ": 7.61,
	"ṯ": 4.36,
	"Ṱ": 7.61,
	"ṱ": 4.36,
	"Ṳ": 8.86,
	"ṳ": 7.02,
	"Ṵ": 8.86,
	"ṵ": 7.02,
	"Ṷ": 8.86,
	"ṷ": 7.02,
	"Ṹ": 8.86,
	"ṹ": 7.02,
	"Ṻ": 8.86,
	"ṻ": 7.02,
	"Ṽ": 8.09,
	"ṽ": 6.52,
	"Ṿ": 8.09,
	"ṿ": 6.52,
	"Ẁ": 11.63,
	"ẁ": 9.3,
	"Ẃ": 11.63,
	"ẃ": 9.3,
	"Ẅ": 11.63,
	"ẅ": 9.3,
	"Ẇ": 11.63,
	"ẇ": 9.3,
	"Ẉ": 11.63,
	"ẉ": 9.3,
	"Ẋ": 8.16,
	"ẋ": 6.3,
	"Ẍ": 8.16,
	"ẍ": 6.3,
	"Ẏ": 7.88,
	"ẏ": 6.52,
	"Ẑ": 7.95,
	"ẑ": 6.47,
	"Ẓ": 7.95,
	"ẓ": 6.47,
	"Ẕ": 7.95,
	"ẕ": 6.47,
	"ẖ": 7.06,
	"ẗ": 4.36,
	"ẘ": 9.3,
	"ẙ": 6.52,
	"ẚ": 6.69,
	"ẛ": 3.34,
	"Ạ": 8.09,
	"ạ": 6.63,
	"Ả": 8.09,
	"ả": 6.63,
	"Ấ": 8.09,
	"ấ": 6.63,
	"Ầ": 8.09,
	"ầ": 6.63,
	"Ẩ": 8.09,
	"ẩ": 6.63,
	"Ẫ": 8.09,
	"ẫ": 6.63,
	"Ậ": 8.09,
	"ậ": 6.63,
	"Ắ": 8.09,
	"ắ": 6.63,
	"Ằ": 8.09,
	"ằ": 6.63,
	"Ẳ": 8.09,
	"ẳ": 6.63,
	"Ẵ": 8.09,
	"ẵ": 6.63,
	"Ặ": 8.09,
	"ặ": 6.63,
	"Ẹ": 7.16,
	"ẹ": 6.86,
	"Ẻ": 7.16,
	"ẻ": 6.86,
	"Ẽ": 7.16,
	"ẽ": 6.86,
	"Ế": 7.16,
	"ế": 6.86,
	"Ề": 7.16,
	"ề": 6.86,
	"Ể": 7.16,
	"ể": 6.86,
	"Ễ": 7.16,
	"ễ": 6.86,
	"Ệ": 7.16,
	"ệ": 6.86,
	"Ỉ": 3.22,
	"ỉ": 2.97,
	"Ị": 3.22,
	"ị": 2.97,
	"Ọ": 9.27,
	"ọ": 7.09,
	"Ỏ": 9.27,
	"ỏ": 7.09,
	"Ố": 9.27,
	"ố": 7.09,
	"Ồ": 9.27,
	"ồ": 7.09,
	"Ổ": 9.27,
	"ổ": 7.09,
	"Ỗ": 9.27,
	"ỗ": 7.09,
	"Ộ": 9.27,
	"ộ": 7.09,
	"Ớ": 9.27,
	"ớ": 7.09,
	"Ờ": 9.27,
	"ờ": 7.09,
	"Ở": 9.27,
	"ở": 7.09,
	"Ỡ": 9.27,
	"ỡ": 7.23,
	"Ợ": 9.27,
	"ợ": 7.09,
	"Ụ": 8.86,
	"ụ": 7.02,
	"Ủ": 8.86,
	"ủ": 7.02,
	"Ứ": 8.86,
	"ứ": 7.34,
	"Ừ": 8.86,
	"ừ": 7.34,
	"Ử": 8.86,
	"ử": 7.34,
	"Ữ": 8.86,
	"ữ": 7.34,
	"Ự": 8.86,
	"ự": 7.34,
	"Ỳ": 7.88,
	"ỳ": 6.52,
	"Ỵ": 7.88,
	"ỵ": 6.52,
	"Ỷ": 7.88,
	"ỷ": 6.52,
	"Ỹ": 7.88,
	"ỹ": 6.52,
	"ἀ": 7.34,
	"ἁ": 7.34,
	"ἂ": 7.34,
	"ἃ": 7.34,
	"ἄ": 7.34,
	"ἅ": 7.34,
	"ἆ": 7.34,
	"ἇ": 7.34,
	"Ἀ": 8.64,
	"Ἁ": 8.55,
	"Ἂ": 11.14,
	"Ἃ": 11.2,
	"Ἄ": 11.2,
	"Ἅ": 11.33,
	"Ἆ": 11.7,
	"Ἇ": 11.44,
	"ἐ": 6.69,
	"ἑ": 6.69,
	"ἒ": 6.69,
	"ἓ": 6.69,
	"ἔ": 6.69,
	"ἕ": 6.69,
	"Ἐ": 10.14,
	"Ἑ": 10.14,
	"Ἒ": 12.69,
	"Ἓ": 12.81,
	"Ἔ": 12.53,
	"Ἕ": 12.63,
	"ἠ": 7.34,
	"ἡ": 7.34,
	"ἢ": 7.34,
	"ἣ": 7.34,
	"ἤ": 7.34,
	"ἥ": 7.34,
	"ἦ": 7.34,
	"ἧ": 7.34,
	"Ἠ": 10.81,
	"Ἡ": 10.81,
	"Ἢ": 13.36,
	"Ἣ": 13.47,
	"Ἤ": 13.2,
	"Ἥ": 13.28,
	"Ἦ": 13.75,
	"Ἧ": 13.75,
	"ἰ": 3.34,
	"ἱ": 3.34,
	"ἲ": 3.34,
	"ἳ": 3.34,
	"ἴ": 3.34,
	"ἵ": 3.34,
	"ἶ": 3.34,
	"ἷ": 3.34,
	"Ἰ": 5.48,
	"Ἱ": 5.48,
	"Ἲ": 8.02,
	"Ἳ": 8.14,
	"Ἴ": 7.88,
	"Ἵ": 7.95,
	"Ἶ": 8.42,
	"Ἷ": 8.42,
	"ὀ": 7.34,
	"ὁ": 7.34,
	"ὂ": 7.34,
	"ὃ": 7.34,
	"ὄ": 7.34,
	"ὅ": 7.34,
	"Ὀ": 11.48,
	"Ὁ": 11.48,
	"Ὂ": 14.02,
	"Ὃ": 14.14,
	"Ὄ": 13.88,
	"Ὅ": 13.95,
	"ὐ": 7.34,
	"ὑ": 7.34,
	"ὒ": 7.34,
	"ὓ": 7.34,
	"ὔ": 7.34,
	"ὕ": 7.34,
	"ὖ": 7.34,
	"ὗ": 7.34,
	"Ὑ": 10.14,
	"Ὓ": 12.81,
	"Ὕ": 12.63,
	"Ὗ": 13.09,
	"ὠ": 9.11,
	"ὡ": 9.11,
	"ὢ": 9.11,
	"ὣ": 9.11,
	"ὤ": 9.11,
	"ὥ": 9.11,
	"ὦ": 9.11,
	"ὧ": 9.11,
	"Ὠ": 11.36,
	"Ὡ": 11.36,
	"Ὢ": 13.91,
	"Ὣ": 14.03,
	"Ὤ": 13.77,
	"Ὥ": 13.83,
	"Ὦ": 14.3,
	"Ὧ": 14.3,
	"ὰ": 7.34,
	"ά": 7.34,
	"ὲ": 6.69,
	"έ": 6.69,
	"ὴ": 7.34,
	"ή": 7.34,
	"ὶ": 3.34,
	"ί": 3.34,
	"ὸ": 7.34,
	"ό": 7.34,
	"ὺ": 7.34,
	"ύ": 7.34,
	"ὼ": 9.11,
	"ώ": 9.11,
	"ᾀ": 7.34,
	"ᾁ": 7.34,
	"ᾂ": 7.34,
	"ᾃ": 7.34,
	"ᾄ": 7.34,
	"ᾅ": 7.34,
	"ᾆ": 7.34,
	"ᾇ": 7.34,
	"ᾈ": 12.11,
	"ᾉ": 12.08,
	"ᾊ": 14.36,
	"ᾋ": 14.77,
	"ᾌ": 14.25,
	"ᾍ": 14.42,
	"ᾎ": 14.75,
	"ᾏ": 14.72,
	"ᾐ": 7.34,
	"ᾑ": 7.34,
	"ᾒ": 7.34,
	"ᾓ": 7.34,
	"ᾔ": 7.34,
	"ᾕ": 7.34,
	"ᾖ": 7.34,
	"ᾗ": 7.34,
	"ᾘ": 14.14,
	"ᾙ": 14.14,
	"ᾚ": 16.69,
	"ᾛ": 16.81,
	"ᾜ": 16.53,
	"ᾝ": 16.61,
	"ᾞ": 17.08,
	"ᾟ": 17.08,
	"ᾠ": 9.11,
	"ᾡ": 9.11,
	"ᾢ": 9.11,
	"ᾣ": 9.11,
	"ᾤ": 9.11,
	"ᾥ": 9.11,
	"ᾦ": 9.11,
	"ᾧ": 9.11,
	"ᾨ": 14.7,
	"ᾩ": 14.7,
	"ᾪ": 17.23,
	"ᾫ": 17.36,
	"ᾬ": 17.08,
	"ᾭ": 17.17,
	"ᾮ": 17.64,
	"ᾯ": 17.64,
	"ᾰ": 7.34,
	"ᾱ": 7.34,
	"ᾲ": 7.34,
	"ᾳ": 7.34,
	"ᾴ": 7.34,
	"ᾶ": 7.34,
	"ᾷ": 7.34,
	"Ᾰ": 8.02,
	"Ᾱ": 8.02,
	"Ὰ": 9.61,
	"Ά": 9.58,
	"ᾼ": 11.5,
	"᾽": 2.14,
	"ι": 3.34,
	"᾿": 2.66,
	"῀": 3.22,
	"῁": 3.22,
	"ῂ": 7.34,
	"ῃ": 7.34,
	"ῄ": 7.34,
	"ῆ": 7.34,
	"ῇ": 7.34,
	"Ὲ": 10.02,
	"Έ": 9.98,
	"Ὴ": 10.25,
	"Ή": 10.09,
	"ῌ": 12.3,
	"῍": 4.69,
	"῎": 4.53,
	"῏": 5.08,
	"ῐ": 3.34,
	"ῑ": 3.34,
	"ῒ": 3.34,
	"ΐ": 3.34,
	"ῖ": 3.34,
	"ῗ": 3.34,
	"Ῐ": 3.34,
	"Ῑ": 3.34,
	"Ὶ": 4.91,
	"Ί": 4.92,
	"῝": 4.81,
	"῞": 4.61,
	"῟": 5.08,
	"ῠ": 7.34,
	"ῡ": 7.34,
	"ῢ": 7.34,
	"ΰ": 7.34,
	"ῤ": 7.34,
	"ῥ": 7.34,
	"ῦ": 7.34,
	"ῧ": 7.34,
	"Ῠ": 8.02,
	"Ῡ": 8.02,
	"Ὺ": 10.05,
	"Ύ": 10.61,
	"Ῥ": 10.14,
	"῭": 4.06,
	"΅": 4.2,
	"`": 3.22,
	"ῲ": 9.11,
	"ῳ": 9.11,
	"ῴ": 9.11,
	"ῶ": 9.11,
	"ῷ": 9.11,
	"Ὸ": 11.03,
	"Ό": 11.31,
	"Ὼ": 11.36,
	"Ώ": 11.5,
	"ῼ": 12.72,
	"´": 3.22,
	"῾": 2.66,
	"‌": 0,
	"‍": 0,
	"‎": 0,
	"‏": 0,
	"‐": 5.67,
	"‑": 5.67,
	"‒": 7.56,
	"―": 12,
	"‖": 5.33,
	"‗": 4,
	"‛": 2.67,
	"‟": 4,
	"‣": 5.67,
	"․": 3.89,
	"‥": 8.02,
	"‧": 3.89,
	"‪": 0,
	"‫": 0,
	"‬": 0,
	"‭": 0,
	"‮": 0,
	"‱": 16.55,
	"′": 3.56,
	"″": 5.52,
	"‴": 7.45,
	"‵": 4,
	"‶": 6.28,
	"‷": 8.09,
	"‸": 6.84,
	"※": 7.02,
	"‼": 6.69,
	"‽": 6.16,
	"‾": 4,
	"‿": 7.22,
	"⁀": 11.67,
	"⁁": 6.84,
	"⁂": 10.94,
	"⁃": 5.67,
	"⁄": 2.72,
	"⁅": 3.34,
	"⁆": 3.34,
	"⁈": 10.02,
	"⁉": 10.02,
	"⁊": 7.45,
	"⁋": 6.45,
	"⁌": 6.45,
	"⁍": 6.45,
	"⁪": 0,
	"⁫": 0,
	"⁬": 0,
	"⁭": 0,
	"⁮": 0,
	"⁯": 0,
	"⁰": 4.28,
	"⁴": 4.38,
	"⁵": 4.2,
	"⁶": 4.33,
	"⁷": 3.88,
	"⁸": 4.34,
	"⁹": 4.33,
	"⁺": 4.03,
	"⁻": 4.03,
	"⁼": 4.03,
	"⁽": 3.2,
	"⁾": 3.2,
	"ⁿ": 4.95,
	"₀": 4.28,
	"₁": 3.16,
	"₂": 4.11,
	"₃": 4.27,
	"₄": 4.38,
	"₅": 4.2,
	"₆": 4.33,
	"₇": 3.88,
	"₈": 4.34,
	"₉": 4.33,
	"₊": 4.03,
	"₋": 4.03,
	"₌": 4.03,
	"₍": 3.2,
	"₎": 3.2,
	"₠": 6.67,
	"₡": 7.56,
	"₢": 7.56,
	"₣": 7.56,
	"₤": 7.56,
	"₥": 7.56,
	"₦": 7.56,
	"₧": 7.56,
	"₨": 12.23,
	"₩": 10.73,
	"₪": 8.67,
	"₫": 7.56,
	"₭": 7.56,
	"₮": 7.56,
	"₯": 12.52,
	"⃐": 5.53,
	"⃑": 5.28,
	"⃒": 0,
	"⃓": 3.08,
	"⃔": 6.47,
	"⃕": 5.47,
	"⃖": 5.5,
	"⃗": 5.27,
	"⃘": 0,
	"⃙": 4.59,
	"⃚": 4.61,
	"⃛": 5.83,
	"⃜": 7.05,
	"⃝": 0,
	"⃞": 0,
	"⃟": 0,
	"⃠": 10.81,
	"⃡": 5.73,
	"⃢": 12,
	"⃣": 12.19,
	"℀": 10.39,
	"℁": 10.17,
	"ℂ": 8.67,
	"℃": 14.25,
	"℄": 7.56,
	"℅": 10.61,
	"℆": 10.83,
	"ℇ": 7.59,
	"℈": 7.23,
	"℉": 12.53,
	"ℊ": 11.09,
	"ℋ": 10.56,
	"ℌ": 7.72,
	"ℍ": 8.67,
	"ℎ": 6.03,
	"ℏ": 6.7,
	"ℐ": 6.7,
	"ℑ": 7.22,
	"ℒ": 8.3,
	"ℓ": 6,
	"℔": 9.81,
	"ℕ": 7.23,
	"№": 13.92,
	"℗": 8.33,
	"℘": 7.38,
	"ℙ": 8.02,
	"ℚ": 9.34,
	"ℛ": 8.91,
	"ℜ": 8.75,
	"ℝ": 7.23,
	"℞": 7.59,
	"℟": 8.53,
	"℠": 10.11,
	"℡": 11.02,
	"℣": 8.36,
	"ℤ": 7.23,
	"℥": 6.16,
	"Ω": 9.33,
	"℧": 9.22,
	"ℨ": 6.13,
	"℩": 2.67,
	"K": 7.91,
	"Å": 8.09,
	"ℬ": 8.42,
	"ℭ": 8,
	"℮": 9.13,
	"ℯ": 5.94,
	"ℰ": 7.34,
	"ℱ": 7.95,
	"Ⅎ": 7.34,
	"ℳ": 10.75,
	"ℴ": 6.55,
	"ℵ": 7.73,
	"ℶ": 6.77,
	"ℷ": 5.14,
	"ℸ": 6.02,
	"ℹ": 7.92,
	"℺": 9.34,
	"⅓": 9.92,
	"⅔": 10.86,
	"⅕": 9.86,
	"⅖": 10.86,
	"⅗": 11.02,
	"⅘": 11.13,
	"⅙": 10.02,
	"⅚": 11.06,
	"⅛": 10.03,
	"⅜": 11.14,
	"⅝": 11.08,
	"⅞": 9.73,
	"⅟": 10.02,
	"Ⅰ": 3.22,
	"Ⅱ": 5.89,
	"Ⅲ": 8.56,
	"Ⅳ": 10.06,
	"Ⅴ": 8.09,
	"Ⅵ": 10.06,
	"Ⅶ": 12.73,
	"Ⅷ": 15.41,
	"Ⅸ": 9.92,
	"Ⅹ": 8.16,
	"Ⅺ": 9.92,
	"Ⅻ": 12.59,
	"Ⅼ": 6.83,
	"Ⅽ": 8.59,
	"Ⅾ": 8.72,
	"Ⅿ": 10.5,
	"ⅰ": 2.97,
	"ⅱ": 5.55,
	"ⅲ": 8.11,
	"ⅳ": 8.05,
	"ⅴ": 6.69,
	"ⅵ": 8.05,
	"ⅶ": 10.52,
	"ⅷ": 13.09,
	"ⅸ": 7.88,
	"ⅹ": 6.42,
	"ⅺ": 7.88,
	"ⅻ": 10.36,
	"ⅼ": 3.05,
	"ⅽ": 6.72,
	"ⅾ": 7.38,
	"ⅿ": 10.45,
	"ↀ": 12.5,
	"ↁ": 9,
	"ↂ": 12.5,
	"Ↄ": 8.59,
	"←": 10.88,
	"↑": 9.38,
	"→": 10.88,
	"↓": 9.38,
	"↔": 11.52,
	"↕": 6.63,
	"↖": 9.17,
	"↗": 9.17,
	"↘": 9.17,
	"↙": 9.17,
	"↚": 7.23,
	"↛": 7.23,
	"↜": 7.23,
	"↝": 7.23,
	"↞": 7.23,
	"↟": 7.23,
	"↠": 7.23,
	"↡": 7.23,
	"↢": 7.23,
	"↣": 7.23,
	"↤": 7.23,
	"↥": 7.23,
	"↦": 7.23,
	"↧": 7.23,
	"↨": 7.23,
	"↩": 12,
	"↪": 11.86,
	"↫": 7.23,
	"↬": 7.23,
	"↭": 7.23,
	"↮": 7.23,
	"↯": 7.23,
	"↰": 10.39,
	"↱": 10.39,
	"↲": 10.39,
	"↳": 10.39,
	"↴": 10.39,
	"↵": 12,
	"↶": 10.39,
	"↷": 10.39,
	"↸": 12.27,
	"↹": 12.27,
	"↺": 9.83,
	"↻": 9.83,
	"↼": 10.39,
	"↽": 7.23,
	"↾": 7.23,
	"↿": 7.23,
	"⇀": 10.39,
	"⇁": 7.23,
	"⇂": 7.23,
	"⇃": 7.23,
	"⇄": 11.09,
	"⇅": 13.31,
	"⇆": 11.09,
	"⇇": 7.23,
	"⇈": 7.23,
	"⇉": 7.23,
	"⇊": 7.23,
	"⇋": 11.09,
	"⇌": 11.09,
	"⇍": 10.56,
	"⇎": 7.23,
	"⇏": 10.44,
	"⇐": 11.09,
	"⇑": 10.39,
	"⇒": 10.16,
	"⇓": 10.39,
	"⇔": 10.16,
	"⇕": 7.23,
	"⇖": 7.23,
	"⇗": 7.23,
	"⇘": 7.23,
	"⇙": 7.23,
	"⇚": 7.23,
	"⇛": 7.23,
	"⇜": 7.23,
	"⇝": 7.23,
	"⇞": 7.75,
	"⇟": 7.75,
	"⇠": 10.39,
	"⇡": 10.39,
	"⇢": 10.39,
	"⇣": 10.39,
	"⇤": 12,
	"⇥": 12,
	"⇦": 12.27,
	"⇧": 11.78,
	"⇨": 12.27,
	"⇩": 12.27,
	"⇪": 11.59,
	"⇫": 7.23,
	"⇬": 7.23,
	"⇭": 7.23,
	"⇮": 7.23,
	"⇯": 7.23,
	"⇰": 10.39,
	"⇱": 7.23,
	"⇲": 7.23,
	"⇳": 7.23,
	"∀": 7.58,
	"∁": 5.64,
	"∂": 7.05,
	"∃": 6.31,
	"∄": 6.42,
	"∅": 8.61,
	"∆": 8.17,
	"∇": 8.17,
	"∈": 6.92,
	"∉": 7.34,
	"∊": 6.13,
	"∋": 6.92,
	"∌": 7.08,
	"∍": 6.13,
	"∎": 6.27,
	"∏": 8.86,
	"∐": 9.89,
	"∑": 7.59,
	"−": 7.56,
	"∓": 6.77,
	"∔": 7.19,
	"∕": 2.02,
	"∖": 8.45,
	"∗": 7.56,
	"∘": 7.56,
	"∙": 7.56,
	"√": 8.25,
	"∛": 8.25,
	"∜": 8.7,
	"∝": 6.23,
	"∞": 10.86,
	"∟": 6.98,
	"∠": 7.17,
	"∡": 7.22,
	"∢": 7.27,
	"∣": 3,
	"∤": 5.67,
	"∥": 4.16,
	"∦": 6.31,
	"∧": 7.13,
	"∨": 7.13,
	"∩": 6.38,
	"∪": 6.38,
	"∫": 6.47,
	"∬": 10.98,
	"∭": 13.5,
	"∮": 8.14,
	"∯": 11.09,
	"∰": 14,
	"∱": 7.19,
	"∲": 7.55,
	"∳": 7.17,
	"∴": 7.25,
	"∵": 7.17,
	"∶": 4.05,
	"∷": 6.92,
	"∸": 6.75,
	"∹": 6.92,
	"∺": 6.97,
	"∻": 6.72,
	"∼": 7.56,
	"∽": 6.61,
	"∾": 6.52,
	"∿": 7.02,
	"≀": 4.69,
	"≁": 6.89,
	"≂": 6.97,
	"≃": 7.02,
	"≄": 8.06,
	"≅": 8.36,
	"≆": 7.56,
	"≇": 7.34,
	"≈": 7.56,
	"≉": 7.09,
	"≊": 7.25,
	"≋": 8.06,
	"≌": 6.52,
	"≍": 7.25,
	"≎": 7.17,
	"≏": 7.13,
	"≐": 6.73,
	"≑": 7.67,
	"≒": 7.59,
	"≓": 7.59,
	"≔": 9.17,
	"≕": 9.17,
	"≖": 6.95,
	"≗": 7.16,
	"≘": 7.08,
	"≙": 7.3,
	"≚": 7.44,
	"≛": 7.77,
	"≜": 7.64,
	"≝": 6.77,
	"≞": 6.91,
	"≟": 7.08,
	"≠": 7.56,
	"≡": 7.56,
	"≢": 7.09,
	"≣": 7.13,
	"≤": 7.56,
	"≥": 7.56,
	"≦": 6.91,
	"≧": 6.78,
	"≨": 7.47,
	"≩": 7.08,
	"≪": 8.81,
	"≫": 8.42,
	"≬": 4.3,
	"≭": 6.64,
	"≮": 6.52,
	"≯": 6.69,
	"≰": 6.81,
	"≱": 6.77,
	"≲": 6.78,
	"≳": 6.81,
	"≴": 7,
	"≵": 6.97,
	"≶": 7.27,
	"≷": 7.27,
	"≸": 6.73,
	"≹": 6.92,
	"≺": 6.81,
	"≻": 6.94,
	"≼": 7.16,
	"≽": 6.94,
	"≾": 7.03,
	"≿": 6.98,
	"⊀": 7.3,
	"⊁": 6.95,
	"⊂": 7.59,
	"⊃": 7.59,
	"⊄": 7.73,
	"⊅": 7.58,
	"⊆": 7.97,
	"⊇": 7.97,
	"⊈": 8.02,
	"⊉": 7.8,
	"⊊": 6.75,
	"⊋": 6.75,
	"⊌": 6.98,
	"⊍": 6.98,
	"⊎": 7.31,
	"⊏": 7.86,
	"⊐": 7.86,
	"⊑": 7.83,
	"⊒": 7.83,
	"⊓": 7.34,
	"⊔": 7.34,
	"⊕": 11.11,
	"⊖": 11.11,
	"⊗": 11.11,
	"⊘": 8.67,
	"⊙": 9.08,
	"⊚": 8.83,
	"⊛": 8.63,
	"⊜": 11.11,
	"⊝": 11.11,
	"⊞": 9.41,
	"⊟": 9.13,
	"⊠": 8.8,
	"⊡": 8.59,
	"⊢": 9.02,
	"⊣": 9.02,
	"⊤": 9.02,
	"⊥": 9.02,
	"⊦": 3.97,
	"⊧": 4.02,
	"⊨": 7.48,
	"⊩": 8.75,
	"⊪": 7.48,
	"⊫": 9.08,
	"⊬": 9.31,
	"⊭": 9.34,
	"⊮": 10.5,
	"⊯": 10.03,
	"⊰": 7.59,
	"⊱": 7.59,
	"⊲": 8.91,
	"⊳": 8.91,
	"⊴": 8.44,
	"⊵": 8.44,
	"⊶": 8.83,
	"⊷": 8.83,
	"⊸": 7.16,
	"⊹": 8.2,
	"⊺": 5.77,
	"⊻": 8.36,
	"⊼": 8.36,
	"⊽": 8.09,
	"⊾": 8.91,
	"⊿": 7.58,
	"⋀": 8.06,
	"⋁": 8.06,
	"⋂": 7.69,
	"⋃": 7.69,
	"⋄": 4.58,
	"⋅": 7.56,
	"⋆": 5.39,
	"⋇": 7.58,
	"⋈": 9.28,
	"⋉": 8.89,
	"⋊": 8.89,
	"⋋": 8.69,
	"⋌": 8.69,
	"⋍": 7.02,
	"⋎": 7.63,
	"⋏": 7.63,
	"⋐": 7.78,
	"⋑": 7.78,
	"⋒": 6.84,
	"⋓": 6.84,
	"⋔": 6.59,
	"⋕": 7.38,
	"⋖": 7.25,
	"⋗": 7.25,
	"⋘": 11.63,
	"⋙": 11.63,
	"⋚": 7.81,
	"⋛": 7.81,
	"⋜": 7.77,
	"⋝": 7.77,
	"⋞": 8.03,
	"⋟": 8.03,
	"⋠": 8,
	"⋡": 7.88,
	"⋢": 8.23,
	"⋣": 7.97,
	"⋤": 8.06,
	"⋥": 8.09,
	"⋦": 8.13,
	"⋧": 8.23,
	"⋨": 8.63,
	"⋩": 8.27,
	"⋪": 8.98,
	"⋫": 9.19,
	"⋬": 9.27,
	"⋭": 9.33,
	"⋮": 4.94,
	"⋯": 12.27,
	"⋰": 11.05,
	"⋱": 11.28,
	"⌀": 7.56,
	"⌁": 7.23,
	"⌂": 7.23,
	"⌃": 10.53,
	"⌄": 7.23,
	"⌅": 10.53,
	"⌆": 7.28,
	"⌇": 11.09,
	"⌈": 7.23,
	"⌉": 7.23,
	"⌊": 7.23,
	"⌋": 7.23,
	"⌌": 7.23,
	"⌍": 7.23,
	"⌎": 7.23,
	"⌏": 7.23,
	"⌐": 7.23,
	"⌑": 7.23,
	"⌒": 12.27,
	"⌓": 7.23,
	"⌔": 10.39,
	"⌕": 7.23,
	"⌖": 11.2,
	"⌗": 8,
	"⌘": 11.03,
	"⌙": 7.23,
	"⌚": 6.94,
	"⌛": 7.83,
	"⌜": 7.23,
	"⌝": 7.23,
	"⌞": 7.23,
	"⌟": 7.23,
	"⌠": 7.23,
	"⌡": 7.23,
	"⌢": 10.39,
	"⌣": 10.39,
	"⌤": 9.55,
	"⌥": 11.7,
	"⌦": 12.2,
	"⌧": 10.89,
	"⌨": 7.23,
	"〈": 11.09,
	"〉": 11.09,
	"⌫": 12.2,
	"⌬": 8,
	"⌭": 13.2,
	"⌮": 8.83,
	"⌯": 6.17,
	"⌰": 10.45,
	"⌱": 11.59,
	"⌲": 7.77,
	"⌳": 7.77,
	"⌴": 8.78,
	"⌵": 7.23,
	"⌶": 8.28,
	"⌷": 7.23,
	"⌸": 7.23,
	"⌹": 7.23,
	"⌺": 7.23,
	"⌻": 7.23,
	"⌼": 7.23,
	"⌽": 12,
	"⌾": 7.23,
	"⌿": 6.52,
	"⍀": 6.52,
	"⍁": 7.23,
	"⍂": 7.23,
	"⍃": 7.23,
	"⍄": 7.23,
	"⍅": 8.06,
	"⍆": 8.06,
	"⍇": 7.23,
	"⍈": 7.23,
	"⍉": 7.23,
	"⍊": 8.28,
	"⍋": 7.23,
	"⍌": 7.23,
	"⍍": 7.23,
	"⍎": 8.28,
	"⍏": 8.2,
	"⍐": 7.23,
	"⍑": 8.28,
	"⍒": 7.23,
	"⍓": 7.23,
	"⍔": 7.23,
	"⍕": 8.28,
	"⍖": 8.2,
	"⍗": 7.23,
	"⍘": 7.23,
	"⍙": 7.23,
	"⍚": 7.23,
	"⍛": 7.23,
	"⍜": 7.23,
	"⍝": 6.45,
	"⍞": 7.23,
	"⍟": 7.23,
	"⍠": 7.23,
	"⍡": 8.28,
	"⍢": 7.31,
	"⍣": 7.23,
	"⍤": 7.23,
	"⍥": 7.23,
	"⍦": 6.45,
	"⍧": 6.77,
	"⍨": 7.23,
	"⍩": 7.23,
	"⍪": 3.59,
	"⍫": 7.23,
	"⍬": 7.23,
	"⍭": 7.23,
	"⍮": 7.23,
	"⍯": 7.23,
	"⍰": 7.23,
	"⍱": 8.06,
	"⍲": 8.06,
	"⍳": 7.23,
	"⍴": 7.23,
	"⍵": 7.23,
	"⍶": 7.23,
	"⍷": 7.23,
	"⍸": 7.23,
	"⍹": 7.23,
	"⍺": 7.23,
	"⍻": 8.52,
	"⍽": 3.8,
	"⍾": 10.16,
	"⍿": 3.7,
	"⎀": 7.23,
	"⎁": 7.23,
	"⎂": 7.23,
	"⎃": 7.23,
	"⎄": 11.25,
	"⎅": 7.98,
	"⎆": 10.64,
	"⎇": 11.7,
	"⎈": 12,
	"⎉": 7.23,
	"⎊": 7.23,
	"⎋": 11.11,
	"⎌": 8.67,
	"⎍": 12.33,
	"⎎": 7.64,
	"⎏": 8.95,
	"⎐": 8.95,
	"⎑": 8.95,
	"⎒": 8.95,
	"⎓": 8.88,
	"⎔": 9.02,
	"⎕": 7.23,
	"⎖": 5.17,
	"⎗": 7.08,
	"⎘": 7.08,
	"⎙": 9.02,
	"⎚": 9.02,
	"␀": 12.27,
	"␁": 12.27,
	"␂": 12.27,
	"␃": 12.27,
	"␄": 12.27,
	"␅": 12.27,
	"␆": 12.27,
	"␇": 12.27,
	"␈": 12.27,
	"␉": 12.27,
	"␊": 12.27,
	"␋": 12.27,
	"␌": 12.27,
	"␍": 12.27,
	"␎": 12.27,
	"␏": 12.27,
	"␐": 12.27,
	"␑": 12.27,
	"␒": 12.27,
	"␓": 12.27,
	"␔": 12.27,
	"␕": 12.27,
	"␖": 12.27,
	"␗": 12.27,
	"␘": 12.27,
	"␙": 12.27,
	"␚": 12.27,
	"␛": 12.27,
	"␜": 12.27,
	"␝": 12.27,
	"␞": 12.27,
	"␟": 12.27,
	"␠": 6.03,
	"␡": 12.27,
	"␢": 6.84,
	"␣": 7.19,
	"␤": 6.55,
	"␥": 7.55,
	"␦": 4.84,
	"⑀": 6.59,
	"⑁": 7.48,
	"⑂": 7.06,
	"⑃": 7.06,
	"⑄": 6.53,
	"⑅": 6.64,
	"⑆": 7.13,
	"⑇": 7.02,
	"⑈": 7.16,
	"⑉": 6.8,
	"⑊": 6.7,
	"①": 11.11,
	"②": 11.11,
	"③": 11.11,
	"④": 11.11,
	"⑤": 11.11,
	"⑥": 11.11,
	"⑦": 11.11,
	"⑧": 11.11,
	"⑨": 11.11,
	"⑩": 12.27,
	"⑪": 12.27,
	"⑫": 12.27,
	"⑬": 12.27,
	"⑭": 12.27,
	"⑮": 12.27,
	"⑯": 12.27,
	"⑰": 12.27,
	"⑱": 12.27,
	"⑲": 11.11,
	"⑳": 12.27,
	"⑴": 12.27,
	"⑵": 12.27,
	"⑶": 12.27,
	"⑷": 12.27,
	"⑸": 12.27,
	"⑹": 12.27,
	"⑺": 12.27,
	"⑻": 12.27,
	"⑼": 12.27,
	"⑽": 12.27,
	"⑾": 12.27,
	"⑿": 12.27,
	"⒀": 12.27,
	"⒁": 12.27,
	"⒂": 12.27,
	"⒃": 12.27,
	"⒄": 12.27,
	"⒅": 12.27,
	"⒆": 12.27,
	"⒇": 12.27,
	"⒈": 12.27,
	"⒉": 12.27,
	"⒊": 12.27,
	"⒋": 12.27,
	"⒌": 12.27,
	"⒍": 12.27,
	"⒎": 12.27,
	"⒏": 12.27,
	"⒐": 12.27,
	"⒑": 12.27,
	"⒒": 12.27,
	"⒓": 12.27,
	"⒔": 12.27,
	"⒕": 12.27,
	"⒖": 12.27,
	"⒗": 12.27,
	"⒘": 12.27,
	"⒙": 12.27,
	"⒚": 12.27,
	"⒛": 12.27,
	"⒜": 12.27,
	"⒝": 12.27,
	"⒞": 12.27,
	"⒟": 12.27,
	"⒠": 12.27,
	"⒡": 12.27,
	"⒢": 12.27,
	"⒣": 12.27,
	"⒤": 12.27,
	"⒥": 12.27,
	"⒦": 12.27,
	"⒧": 12.27,
	"⒨": 12.27,
	"⒩": 12.27,
	"⒪": 12.27,
	"⒫": 12.27,
	"⒬": 12.27,
	"⒭": 12.27,
	"⒮": 12.27,
	"⒯": 12.27,
	"⒰": 12.27,
	"⒱": 12.27,
	"⒲": 12.27,
	"⒳": 12.27,
	"⒴": 12.27,
	"⒵": 12.27,
	"Ⓐ": 11.11,
	"Ⓑ": 11.11,
	"Ⓒ": 11.11,
	"Ⓓ": 11.11,
	"Ⓔ": 11.11,
	"Ⓕ": 11.11,
	"Ⓖ": 11.11,
	"Ⓗ": 11.11,
	"Ⓘ": 11.11,
	"Ⓙ": 11.11,
	"Ⓚ": 11.11,
	"Ⓛ": 11.11,
	"Ⓜ": 11.11,
	"Ⓝ": 11.11,
	"Ⓞ": 11.11,
	"Ⓟ": 11.11,
	"Ⓠ": 11.11,
	"Ⓡ": 11.11,
	"Ⓢ": 11.11,
	"Ⓣ": 11.11,
	"Ⓤ": 11.11,
	"Ⓥ": 11.11,
	"Ⓦ": 11.11,
	"Ⓧ": 11.11,
	"Ⓨ": 11.11,
	"Ⓩ": 11.11,
	"ⓐ": 12.27,
	"ⓑ": 12.27,
	"ⓒ": 12.27,
	"ⓓ": 12.27,
	"ⓔ": 12.27,
	"ⓕ": 12.27,
	"ⓖ": 12.27,
	"ⓗ": 12.27,
	"ⓘ": 12.27,
	"ⓙ": 12.27,
	"ⓚ": 12.27,
	"ⓛ": 12.27,
	"ⓜ": 12.27,
	"ⓝ": 12.27,
	"ⓞ": 12.27,
	"ⓟ": 12.27,
	"ⓠ": 12.27,
	"ⓡ": 12.27,
	"ⓢ": 12.27,
	"ⓣ": 12.27,
	"ⓤ": 12.27,
	"ⓥ": 12.27,
	"ⓦ": 12.27,
	"ⓧ": 12.27,
	"ⓨ": 12.27,
	"ⓩ": 12.27,
	"⓪": 11.11,
	"─": 12,
	"━": 12,
	"│": 3.11,
	"┃": 12,
	"┄": 12.27,
	"┅": 12.27,
	"┆": 12.27,
	"┇": 12.27,
	"┈": 12.27,
	"┉": 12.27,
	"┊": 12.27,
	"┋": 12.27,
	"┌": 12,
	"┍": 12.27,
	"┎": 12.27,
	"┏": 12,
	"┐": 12,
	"┑": 12.27,
	"┒": 12.27,
	"┓": 12,
	"└": 12,
	"┕": 12.27,
	"┖": 12.27,
	"┗": 12,
	"┘": 12,
	"┙": 12.27,
	"┚": 12.27,
	"┛": 12,
	"├": 12.27,
	"┝": 12.27,
	"┞": 12.27,
	"┟": 12.27,
	"┠": 12.27,
	"┡": 12.27,
	"┢": 12.27,
	"┣": 12.27,
	"┤": 12.27,
	"┥": 12.27,
	"┦": 12.27,
	"┧": 12.27,
	"┨": 12.27,
	"┩": 12.27,
	"┪": 12.27,
	"┫": 12.27,
	"┬": 12.27,
	"┭": 12.27,
	"┮": 12.27,
	"┯": 12.27,
	"┰": 12.27,
	"┱": 12.27,
	"┲": 12.27,
	"┳": 12.27,
	"┴": 12.27,
	"┵": 12.27,
	"┶": 12.27,
	"┷": 12.27,
	"┸": 12.27,
	"┹": 12.27,
	"┺": 12.27,
	"┻": 12.27,
	"┼": 12.27,
	"┽": 12.27,
	"┾": 12.27,
	"┿": 12.27,
	"╀": 12.27,
	"╁": 12.27,
	"╂": 12.27,
	"╃": 12.27,
	"╄": 12.27,
	"╅": 12.27,
	"╆": 12.27,
	"╇": 12.27,
	"╈": 12.27,
	"╉": 12.27,
	"╊": 12.27,
	"╋": 12.27,
	"╌": 7.23,
	"╍": 7.23,
	"╎": 7.23,
	"╏": 7.23,
	"═": 12.27,
	"║": 12.27,
	"╒": 12.27,
	"╓": 12.27,
	"╔": 12.27,
	"╕": 12.27,
	"╖": 12.27,
	"╗": 12.27,
	"╘": 12.27,
	"╙": 12.27,
	"╚": 12.27,
	"╛": 12.27,
	"╜": 12.27,
	"╝": 12.27,
	"╞": 12.27,
	"╟": 12.27,
	"╠": 12.27,
	"╡": 12.27,
	"╢": 12.27,
	"╣": 12.27,
	"╤": 12.27,
	"╥": 12.27,
	"╦": 12.27,
	"╧": 12.27,
	"╨": 12.27,
	"╩": 12.27,
	"╪": 12.27,
	"╫": 12.27,
	"╬": 12.27,
	"╭": 12.27,
	"╮": 12.27,
	"╯": 12.27,
	"╰": 12.27,
	"╱": 12.27,
	"╲": 12.27,
	"╳": 12.27,
	"╴": 12.27,
	"╵": 7.23,
	"╶": 7.23,
	"╷": 7.23,
	"╸": 7.23,
	"╹": 7.23,
	"╺": 7.23,
	"╻": 7.23,
	"╼": 7.23,
	"╽": 7.23,
	"╾": 7.23,
	"╿": 7.23,
	"▀": 7.23,
	"▁": 12.27,
	"▂": 12.27,
	"▃": 12.27,
	"▄": 12.27,
	"▅": 12.27,
	"▆": 12.27,
	"▇": 12.27,
	"█": 12,
	"▉": 12.27,
	"▊": 12.27,
	"▋": 12.27,
	"▌": 12.27,
	"▍": 12.27,
	"▎": 12.27,
	"▏": 12.27,
	"▐": 7.23,
	"░": 10.39,
	"▒": 10.39,
	"▓": 12.27,
	"▔": 12.27,
	"▕": 12.27,
	"■": 10.89,
	"□": 10.92,
	"▢": 11.09,
	"▣": 10.39,
	"▤": 10.39,
	"▥": 10.39,
	"▦": 10.39,
	"▧": 10.39,
	"▨": 10.39,
	"▩": 10.39,
	"▪": 11.09,
	"▫": 11.09,
	"▬": 7.23,
	"▭": 10.39,
	"▮": 7.23,
	"▯": 7.23,
	"▰": 7.23,
	"▱": 11.09,
	"▲": 9.22,
	"△": 9.22,
	"▴": 5.67,
	"▵": 10.39,
	"▶": 9.63,
	"▷": 9.63,
	"▸": 5.67,
	"▹": 10.39,
	"►": 10.56,
	"▻": 7.23,
	"▼": 9.22,
	"▽": 9.22,
	"▾": 5.67,
	"▿": 10.39,
	"◀": 9.61,
	"◁": 9.61,
	"◂": 5.67,
	"◃": 10.39,
	"◄": 7.23,
	"◅": 7.23,
	"◆": 12.27,
	"◇": 12.27,
	"◈": 10.39,
	"◉": 11.09,
	"◊": 6.91,
	"○": 11.14,
	"◌": 11.09,
	"◍": 7.23,
	"◎": 12.27,
	"●": 11.11,
	"◐": 11.09,
	"◑": 11.09,
	"◒": 11.09,
	"◓": 11.09,
	"◔": 7.23,
	"◕": 7.23,
	"◖": 7.23,
	"◗": 7.23,
	"◘": 7.23,
	"◙": 7.23,
	"◚": 7.23,
	"◛": 7.23,
	"◜": 7.23,
	"◝": 7.23,
	"◞": 7.23,
	"◟": 7.23,
	"◠": 7.23,
	"◡": 7.23,
	"◢": 12.27,
	"◣": 12.27,
	"◤": 12.27,
	"◥": 12.27,
	"◦": 5.67,
	"◧": 7.23,
	"◨": 7.23,
	"◩": 7.23,
	"◪": 7.23,
	"◫": 7.23,
	"◬": 7.23,
	"◭": 7.23,
	"◮": 7.23,
	"◯": 11.09,
	"◰": 7.23,
	"◱": 7.23,
	"◲": 7.23,
	"◳": 7.23,
	"◴": 7.23,
	"◵": 7.23,
	"◶": 7.23,
	"◷": 7.23,
	"☀": 11.09,
	"☁": 11.09,
	"☂": 11.09,
	"☃": 11.09,
	"☄": 7.23,
	"★": 12.19,
	"☆": 12.19,
	"☇": 7.23,
	"☈": 7.23,
	"☉": 12.27,
	"☊": 7.23,
	"☋": 7.23,
	"☌": 7.23,
	"☍": 7.23,
	"☎": 11.09,
	"☏": 10.39,
	"☐": 9.97,
	"☑": 10.89,
	"☒": 10.89,
	"☓": 7.23,
	"☙": 7.23,
	"☚": 7.23,
	"☛": 7.23,
	"☜": 11.09,
	"☝": 11.09,
	"☞": 11.09,
	"☟": 11.09,
	"☠": 7.23,
	"☡": 7.23,
	"☢": 7.23,
	"☣": 7.23,
	"☤": 7.23,
	"☥": 7.23,
	"☦": 7.23,
	"☧": 7.23,
	"☨": 7.23,
	"☩": 7.23,
	"☪": 7.23,
	"☫": 7.23,
	"☬": 7.23,
	"☭": 7.23,
	"☮": 7.23,
	"☯": 10.39,
	"☰": 10.56,
	"☱": 10.36,
	"☲": 10.31,
	"☳": 10.77,
	"☴": 10.81,
	"☵": 10.92,
	"☶": 10.92,
	"☷": 11.02,
	"☸": 7.23,
	"☹": 8.86,
	"☺": 8.84,
	"☻": 8.86,
	"☼": 7.23,
	"☽": 7.23,
	"☾": 10.83,
	"☿": 7.23,
	"♀": 11.09,
	"♁": 7.23,
	"♂": 11.09,
	"♃": 7.23,
	"♄": 7.23,
	"♅": 7.23,
	"♆": 7.23,
	"♇": 7.23,
	"♈": 7.23,
	"♉": 7.23,
	"♊": 7.23,
	"♋": 7.23,
	"♌": 7.23,
	"♍": 7.23,
	"♎": 7.23,
	"♏": 7.23,
	"♐": 7.23,
	"♑": 7.23,
	"♒": 7.23,
	"♓": 7.23,
	"♔": 7.23,
	"♕": 7.23,
	"♖": 7.23,
	"♗": 7.23,
	"♘": 7.23,
	"♙": 7.23,
	"♚": 7.23,
	"♛": 7.23,
	"♜": 7.23,
	"♝": 7.23,
	"♞": 7.23,
	"♟": 7.23,
	"♠": 10.34,
	"♡": 11.58,
	"♢": 9.17,
	"♣": 10.39,
	"♤": 10.34,
	"♥": 11.58,
	"♦": 9.17,
	"♧": 10.52,
	"♨": 11.09,
	"♩": 11.09,
	"♪": 6.03,
	"♫": 11.09,
	"♬": 11.09,
	"♭": 5.16,
	"♮": 5.63,
	"♯": 6.09,
	"♰": 7.23,
	"♱": 7.23,
	"✁": 7.23,
	"✂": 11.09,
	"✃": 7.23,
	"✄": 7.23,
	"✆": 7.23,
	"✇": 7.23,
	"✈": 11.81,
	"✉": 7.23,
	"✌": 7.23,
	"✍": 7.23,
	"✎": 9.45,
	"✏": 7.23,
	"✐": 7.23,
	"✑": 7.23,
	"✒": 7.23,
	"✓": 10.41,
	"✔": 7.23,
	"✕": 7.23,
	"✖": 10.39,
	"✗": 9.7,
	"✘": 7.23,
	"✙": 7.23,
	"✚": 11.09,
	"✛": 7.23,
	"✜": 7.23,
	"✝": 7.23,
	"✞": 7.23,
	"✟": 7.23,
	"✠": 10.39,
	"✡": 7.23,
	"✢": 7.23,
	"✣": 10.39,
	"✤": 7.23,
	"✥": 7.23,
	"✦": 7.23,
	"✧": 7.23,
	"✩": 7.23,
	"✪": 7.23,
	"✫": 7.23,
	"✬": 7.23,
	"✭": 7.23,
	"✮": 7.23,
	"✯": 7.23,
	"✰": 7.23,
	"✱": 10.39,
	"✲": 7.23,
	"✳": 7.23,
	"✴": 7.23,
	"✵": 7.23,
	"✶": 7.23,
	"✷": 7.23,
	"✸": 7.23,
	"✹": 7.23,
	"✺": 7.23,
	"✻": 7.23,
	"✼": 7.23,
	"✽": 12.27,
	"✾": 7.23,
	"✿": 11.09,
	"❀": 11.09,
	"❁": 10.39,
	"❂": 7.23,
	"❃": 7.23,
	"❄": 7.23,
	"❅": 7.23,
	"❆": 7.23,
	"❇": 10.39,
	"❈": 7.23,
	"❉": 7.23,
	"❊": 7.23,
	"❋": 7.23,
	"❍": 7.23,
	"❏": 7.23,
	"❐": 7.23,
	"❑": 7.23,
	"❒": 7.23,
	"❖": 11.09,
	"❘": 3.47,
	"❙": 7.23,
	"❚": 7.23,
	"❛": 7.13,
	"❜": 7.13,
	"❝": 12.03,
	"❞": 12.03,
	"❡": 7.23,
	"❢": 7.23,
	"❣": 7.23,
	"❤": 7.23,
	"❥": 7.23,
	"❦": 7.23,
	"❧": 7.23,
	"❶": 11.11,
	"❷": 11.11,
	"❸": 11.11,
	"❹": 11.11,
	"❺": 11.11,
	"❻": 11.11,
	"❼": 11.11,
	"❽": 11.11,
	"❾": 11.11,
	"❿": 12.27,
	"➀": 11.11,
	"➁": 11.11,
	"➂": 11.11,
	"➃": 11.11,
	"➄": 11.11,
	"➅": 11.11,
	"➆": 11.11,
	"➇": 11.11,
	"➈": 11.11,
	"➉": 9.69,
	"➊": 11.11,
	"➋": 11.11,
	"➌": 11.11,
	"➍": 11.11,
	"➎": 11.11,
	"➏": 11.11,
	"➐": 11.11,
	"➑": 11.11,
	"➒": 11.11,
	"➓": 12.27,
	"➔": 10.39,
	"➘": 7.23,
	"➙": 7.23,
	"➚": 7.23,
	"➛": 10.39,
	"➜": 10.39,
	"➝": 7.23,
	"➞": 10.39,
	"➟": 7.23,
	"➠": 7.23,
	"➡": 11.09,
	"➢": 7.23,
	"➣": 7.23,
	"➤": 9.91,
	"➥": 7.23,
	"➦": 7.23,
	"➧": 7.23,
	"➨": 7.23,
	"➩": 7.23,
	"➪": 7.23,
	"➫": 7.23,
	"➬": 7.23,
	"➭": 7.23,
	"➮": 7.23,
	"➯": 7.23,
	"➱": 7.23,
	"➲": 10.39,
	"➳": 7.23,
	"➴": 7.23,
	"➵": 10.39,
	"➶": 7.23,
	"➷": 7.23,
	"➸": 7.23,
	"➹": 7.23,
	"➺": 7.23,
	"➻": 7.23,
	"➼": 7.23,
	"➽": 7.23,
	"➾": 7.23,
	"⠀": 8.2,
	"⠁": 8.2,
	"⠂": 8.2,
	"⠃": 8.2,
	"⠄": 8.2,
	"⠅": 8.2,
	"⠆": 8.2,
	"⠇": 8.2,
	"⠈": 8.2,
	"⠉": 8.2,
	"⠊": 8.2,
	"⠋": 8.2,
	"⠌": 8.2,
	"⠍": 8.2,
	"⠎": 8.2,
	"⠏": 8.2,
	"⠐": 8.2,
	"⠑": 8.2,
	"⠒": 8.2,
	"⠓": 8.2,
	"⠔": 8.2,
	"⠕": 8.2,
	"⠖": 8.2,
	"⠗": 8.2,
	"⠘": 8.2,
	"⠙": 8.2,
	"⠚": 8.2,
	"⠛": 8.2,
	"⠜": 8.2,
	"⠝": 8.2,
	"⠞": 8.2,
	"⠟": 8.2,
	"⠠": 8.2,
	"⠡": 8.2,
	"⠢": 8.2,
	"⠣": 8.2,
	"⠤": 8.2,
	"⠥": 8.2,
	"⠦": 8.2,
	"⠧": 8.2,
	"⠨": 8.2,
	"⠩": 8.2,
	"⠪": 8.2,
	"⠫": 8.2,
	"⠬": 8.2,
	"⠭": 8.2,
	"⠮": 8.2,
	"⠯": 8.2,
	"⠰": 8.2,
	"⠱": 8.2,
	"⠲": 8.2,
	"⠳": 8.2,
	"⠴": 8.2,
	"⠵": 8.2,
	"⠶": 8.2,
	"⠷": 8.2,
	"⠸": 8.2,
	"⠹": 8.2,
	"⠺": 8.2,
	"⠻": 8.2,
	"⠼": 8.2,
	"⠽": 8.2,
	"⠾": 8.2,
	"⠿": 8.2,
	"⡀": 8.2,
	"⡁": 8.2,
	"⡂": 8.2,
	"⡃": 8.2,
	"⡄": 8.2,
	"⡅": 8.2,
	"⡆": 8.2,
	"⡇": 8.2,
	"⡈": 8.2,
	"⡉": 8.2,
	"⡊": 8.2,
	"⡋": 8.2,
	"⡌": 8.2,
	"⡍": 8.2,
	"⡎": 8.2,
	"⡏": 8.2,
	"⡐": 8.2,
	"⡑": 8.2,
	"⡒": 8.2,
	"⡓": 8.2,
	"⡔": 8.2,
	"⡕": 8.2,
	"⡖": 8.2,
	"⡗": 8.2,
	"⡘": 8.2,
	"⡙": 8.2,
	"⡚": 8.2,
	"⡛": 8.2,
	"⡜": 8.2,
	"⡝": 8.2,
	"⡞": 8.2,
	"⡟": 8.2,
	"⡠": 8.2,
	"⡡": 8.2,
	"⡢": 8.2,
	"⡣": 8.2,
	"⡤": 8.2,
	"⡥": 8.2,
	"⡦": 8.2,
	"⡧": 8.2,
	"⡨": 8.2,
	"⡩": 8.2,
	"⡪": 8.2,
	"⡫": 8.2,
	"⡬": 8.2,
	"⡭": 8.2,
	"⡮": 8.2,
	"⡯": 8.2,
	"⡰": 8.2,
	"⡱": 8.2,
	"⡲": 8.2,
	"⡳": 8.2,
	"⡴": 8.2,
	"⡵": 8.2,
	"⡶": 8.2,
	"⡷": 8.2,
	"⡸": 8.2,
	"⡹": 8.2,
	"⡺": 8.2,
	"⡻": 8.2,
	"⡼": 8.2,
	"⡽": 8.2,
	"⡾": 8.2,
	"⡿": 8.2,
	"⢀": 8.2,
	"⢁": 8.2,
	"⢂": 8.2,
	"⢃": 8.2,
	"⢄": 8.2,
	"⢅": 8.2,
	"⢆": 8.2,
	"⢇": 8.2,
	"⢈": 8.2,
	"⢉": 8.2,
	"⢊": 8.2,
	"⢋": 8.2,
	"⢌": 8.2,
	"⢍": 8.2,
	"⢎": 8.2,
	"⢏": 8.2,
	"⢐": 8.2,
	"⢑": 8.2,
	"⢒": 8.2,
	"⢓": 8.2,
	"⢔": 8.2,
	"⢕": 8.2,
	"⢖": 8.2,
	"⢗": 8.2,
	"⢘": 8.2,
	"⢙": 8.2,
	"⢚": 8.2,
	"⢛": 8.2,
	"⢜": 8.2,
	"⢝": 8.2,
	"⢞": 8.2,
	"⢟": 8.2,
	"⢠": 8.2,
	"⢡": 8.2,
	"⢢": 8.2,
	"⢣": 8.2,
	"⢤": 8.2,
	"⢥": 8.2,
	"⢦": 8.2,
	"⢧": 8.2,
	"⢨": 8.2,
	"⢩": 8.2,
	"⢪": 8.2,
	"⢫": 8.2,
	"⢬": 8.2,
	"⢭": 8.2,
	"⢮": 8.2,
	"⢯": 8.2,
	"⢰": 8.2,
	"⢱": 8.2,
	"⢲": 8.2,
	"⢳": 8.2,
	"⢴": 8.2,
	"⢵": 8.2,
	"⢶": 8.2,
	"⢷": 8.2,
	"⢸": 8.2,
	"⢹": 8.2,
	"⢺": 8.2,
	"⢻": 8.2,
	"⢼": 8.2,
	"⢽": 8.2,
	"⢾": 8.2,
	"⢿": 8.2,
	"⣀": 8.2,
	"⣁": 8.2,
	"⣂": 8.2,
	"⣃": 8.2,
	"⣄": 8.2,
	"⣅": 8.2,
	"⣆": 8.2,
	"⣇": 8.2,
	"⣈": 8.2,
	"⣉": 8.2,
	"⣊": 8.2,
	"⣋": 8.2,
	"⣌": 8.2,
	"⣍": 8.2,
	"⣎": 8.2,
	"⣏": 8.2,
	"⣐": 8.2,
	"⣑": 8.2,
	"⣒": 8.2,
	"⣓": 8.2,
	"⣔": 8.2,
	"⣕": 8.2,
	"⣖": 8.2,
	"⣗": 8.2,
	"⣘": 8.2,
	"⣙": 8.2,
	"⣚": 8.2,
	"⣛": 8.2,
	"⣜": 8.2,
	"⣝": 8.2,
	"⣞": 8.2,
	"⣟": 8.2,
	"⣠": 8.2,
	"⣡": 8.2,
	"⣢": 8.2,
	"⣣": 8.2,
	"⣤": 8.2,
	"⣥": 8.2,
	"⣦": 8.2,
	"⣧": 8.2,
	"⣨": 8.2,
	"⣩": 8.2,
	"⣪": 8.2,
	"⣫": 8.2,
	"⣬": 8.2,
	"⣭": 8.2,
	"⣮": 8.2,
	"⣯": 8.2,
	"⣰": 8.2,
	"⣱": 8.2,
	"⣲": 8.2,
	"⣳": 8.2,
	"⣴": 8.2,
	"⣵": 8.2,
	"⣶": 8.2,
	"⣷": 8.2,
	"⣸": 8.2,
	"⣹": 8.2,
	"⣺": 8.2,
	"⣻": 8.2,
	"⣼": 8.2,
	"⣽": 8.2,
	"⣾": 8.2,
	"⣿": 8.2,
	"⺀": 12.27,
	"⺁": 12.27,
	"⺂": 12.27,
	"⺃": 12.27,
	"⺄": 12.27,
	"⺅": 12.27,
	"⺆": 12.27,
	"⺇": 12.27,
	"⺈": 12.27,
	"⺉": 12.27,
	"⺊": 12.27,
	"⺋": 12.27,
	"⺌": 12.27,
	"⺍": 12.27,
	"⺎": 12.27,
	"⺏": 12.27,
	"⺐": 12.27,
	"⺑": 12.27,
	"⺒": 12.27,
	"⺓": 12.27,
	"⺔": 12.27,
	"⺕": 12.27,
	"⺖": 12.27,
	"⺗": 12.27,
	"⺘": 12.27,
	"⺙": 12.27,
	"⺛": 12.27,
	"⺜": 12.27,
	"⺝": 12.27,
	"⺞": 12.27,
	"⺟": 12.27,
	"⺠": 12.27,
	"⺡": 12.27,
	"⺢": 12.27,
	"⺣": 12.27,
	"⺤": 12.27,
	"⺥": 12.27,
	"⺦": 12.27,
	"⺧": 12.27,
	"⺨": 12.27,
	"⺩": 12.27,
	"⺪": 12.27,
	"⺫": 12.27,
	"⺬": 12.27,
	"⺭": 12.27,
	"⺮": 12.27,
	"⺯": 12.27,
	"⺰": 12.27,
	"⺱": 12.27,
	"⺲": 12.27,
	"⺳": 12.27,
	"⺴": 12.27,
	"⺵": 12.27,
	"⺶": 12.27,
	"⺷": 12.27,
	"⺸": 12.27,
	"⺹": 12.27,
	"⺺": 12.27,
	"⺻": 12.27,
	"⺼": 12.27,
	"⺽": 12.27,
	"⺾": 12.27,
	"⺿": 12.27,
	"⻀": 12.27,
	"⻁": 12.27,
	"⻂": 12.27,
	"⻃": 12.27,
	"⻄": 12.27,
	"⻅": 12.27,
	"⻆": 12.27,
	"⻇": 12.27,
	"⻈": 12.27,
	"⻉": 12.27,
	"⻊": 12.27,
	"⻋": 12.27,
	"⻌": 12.27,
	"⻍": 12.27,
	"⻎": 12.27,
	"⻏": 12.27,
	"⻐": 12.27,
	"⻑": 12.27,
	"⻒": 12.27,
	"⻓": 12.27,
	"⻔": 12.27,
	"⻕": 12.27,
	"⻖": 12.27,
	"⻗": 12.27,
	"⻘": 12.27,
	"⻙": 12.27,
	"⻚": 12.27,
	"⻛": 12.27,
	"⻜": 12.27,
	"⻝": 12.27,
	"⻞": 12.27,
	"⻟": 12.27,
	"⻠": 12.27,
	"⻡": 12.27,
	"⻢": 12.27,
	"⻣": 12.27,
	"⻤": 12.27,
	"⻥": 12.27,
	"⻦": 12.27,
	"⻧": 12.27,
	"⻨": 12.27,
	"⻩": 12.27,
	"⻪": 12.27,
	"⻫": 12.27,
	"⻬": 12.27,
	"⻭": 12.27,
	"⻮": 12.27,
	"⻯": 12.27,
	"⻰": 12.27,
	"⻱": 12.27,
	"⻲": 12.27,
	"⻳": 12.27,
	"⼀": 12.27,
	"⼁": 12.27,
	"⼂": 12.27,
	"⼃": 12.27,
	"⼄": 12.27,
	"⼅": 12.27,
	"⼆": 12.27,
	"⼇": 12.27,
	"⼈": 12.27,
	"⼉": 12.27,
	"⼊": 12.27,
	"⼋": 12.27,
	"⼌": 12.27,
	"⼍": 12.27,
	"⼎": 12.27,
	"⼏": 12.27,
	"⼐": 12.27,
	"⼑": 12.27,
	"⼒": 12.27,
	"⼓": 12.27,
	"⼔": 12.27,
	"⼕": 12.27,
	"⼖": 12.27,
	"⼗": 12.27,
	"⼘": 12.27,
	"⼙": 12.27,
	"⼚": 12.27,
	"⼛": 12.27,
	"⼜": 12.27,
	"⼝": 12.27,
	"⼞": 12.27,
	"⼟": 12.27,
	"⼠": 12.27,
	"⼡": 12.27,
	"⼢": 12.27,
	"⼣": 12.27,
	"⼤": 12.27,
	"⼥": 12.27,
	"⼦": 12.27,
	"⼧": 12.27,
	"⼨": 12.27,
	"⼩": 12.27,
	"⼪": 12.27,
	"⼫": 12.27,
	"⼬": 12.27,
	"⼭": 12.27,
	"⼮": 12.27,
	"⼯": 12.27,
	"⼰": 12.27,
	"⼱": 12.27,
	"⼲": 12.27,
	"⼳": 12.27,
	"⼴": 12.27,
	"⼵": 12.27,
	"⼶": 12.27,
	"⼷": 12.27,
	"⼸": 12.27,
	"⼹": 12.27,
	"⼺": 12.27,
	"⼻": 12.27,
	"⼼": 12.27,
	"⼽": 12.27,
	"⼾": 12.27,
	"⼿": 12.27,
	"⽀": 12.27,
	"⽁": 12.27,
	"⽂": 12.27,
	"⽃": 12.27,
	"⽄": 12.27,
	"⽅": 12.27,
	"⽆": 12.27,
	"⽇": 12.27,
	"⽈": 12.27,
	"⽉": 12.27,
	"⽊": 12.27,
	"⽋": 12.27,
	"⽌": 12.27,
	"⽍": 12.27,
	"⽎": 12.27,
	"⽏": 12.27,
	"⽐": 12.27,
	"⽑": 12.27,
	"⽒": 12.27,
	"⽓": 12.27,
	"⽔": 12.27,
	"⽕": 12.27,
	"⽖": 12.27,
	"⽗": 12.27,
	"⽘": 12.27,
	"⽙": 12.27,
	"⽚": 12.27,
	"⽛": 12.27,
	"⽜": 12.27,
	"⽝": 12.27,
	"⽞": 12.27,
	"⽟": 12.27,
	"⽠": 12.27,
	"⽡": 12.27,
	"⽢": 12.27,
	"⽣": 12.27,
	"⽤": 12.27,
	"⽥": 12.27,
	"⽦": 12.27,
	"⽧": 12.27,
	"⽨": 12.27,
	"⽩": 12.27,
	"⽪": 12.27,
	"⽫": 12.27,
	"⽬": 12.27,
	"⽭": 12.27,
	"⽮": 12.27,
	"⽯": 12.27,
	"⽰": 12.27,
	"⽱": 12.27,
	"⽲": 12.27,
	"⽳": 12.27,
	"⽴": 12.27,
	"⽵": 12.27,
	"⽶": 12.27,
	"⽷": 12.27,
	"⽸": 12.27,
	"⽹": 12.27,
	"⽺": 12.27,
	"⽻": 12.27,
	"⽼": 12.27,
	"⽽": 12.27,
	"⽾": 12.27,
	"⽿": 12.27,
	"⾀": 12.27,
	"⾁": 12.27,
	"⾂": 12.27,
	"⾃": 12.27,
	"⾄": 12.27,
	"⾅": 12.27,
	"⾆": 12.27,
	"⾇": 12.27,
	"⾈": 12.27,
	"⾉": 12.27,
	"⾊": 12.27,
	"⾋": 12.27,
	"⾌": 12.27,
	"⾍": 12.27,
	"⾎": 12.27,
	"⾏": 12.27,
	"⾐": 12.27,
	"⾑": 12.27,
	"⾒": 12.27,
	"⾓": 12.27,
	"⾔": 12.27,
	"⾕": 12.27,
	"⾖": 12.27,
	"⾗": 12.27,
	"⾘": 12.27,
	"⾙": 12.27,
	"⾚": 12.27,
	"⾛": 12.27,
	"⾜": 12.27,
	"⾝": 12.27,
	"⾞": 12.27,
	"⾟": 12.27,
	"⾠": 12.27,
	"⾡": 12.27,
	"⾢": 12.27,
	"⾣": 12.27,
	"⾤": 12.27,
	"⾥": 12.27,
	"⾦": 12.27,
	"⾧": 12.27,
	"⾨": 12.27,
	"⾩": 12.27,
	"⾪": 12.27,
	"⾫": 12.27,
	"⾬": 12.27,
	"⾭": 12.27,
	"⾮": 12.27,
	"⾯": 12.27,
	"⾰": 12.27,
	"⾱": 12.27,
	"⾲": 12.27,
	"⾳": 12.27,
	"⾴": 12.27,
	"⾵": 12.27,
	"⾶": 12.27,
	"⾷": 12.27,
	"⾸": 12.27,
	"⾹": 12.27,
	"⾺": 12.27,
	"⾻": 12.27,
	"⾼": 12.27,
	"⾽": 12.27,
	"⾾": 12.27,
	"⾿": 12.27,
	"⿀": 12.27,
	"⿁": 12.27,
	"⿂": 12.27,
	"⿃": 12.27,
	"⿄": 12.27,
	"⿅": 12.27,
	"⿆": 12.27,
	"⿇": 12.27,
	"⿈": 12.27,
	"⿉": 12.27,
	"⿊": 12.27,
	"⿋": 12.27,
	"⿌": 12.27,
	"⿍": 12.27,
	"⿎": 12.27,
	"⿏": 12.27,
	"⿐": 12.27,
	"⿑": 12.27,
	"⿒": 12.27,
	"⿓": 12.27,
	"⿔": 12.27,
	"⿕": 12.27,
	"⿰": 12.27,
	"⿱": 12.27,
	"⿲": 12.27,
	"⿳": 12.27,
	"⿴": 12.27,
	"⿵": 12.27,
	"⿶": 12.27,
	"⿷": 12.27,
	"⿸": 12.27,
	"⿹": 12.27,
	"⿺": 12.27,
	"⿻": 12.27,
	"、": 12.27,
	"。": 12.27,
	"〃": 6.33,
	"〄": 11.09,
	"々": 12.27,
	"〆": 12.27,
	"〇": 12.27,
	"〈": 12.27,
	"〉": 12.27,
	"《": 12.27,
	"》": 12.27,
	"「": 12.27,
	"」": 12.27,
	"『": 12.27,
	"』": 12.27,
	"【": 12.27,
	"】": 12.27,
	"〒": 12.27,
	"〓": 12.27,
	"〔": 12.27,
	"〕": 12.27,
	"〖": 12.27,
	"〗": 12.27,
	"〘": 11.09,
	"〙": 11.09,
	"〚": 12,
	"〛": 12,
	"〜": 12.27,
	"〝": 12.27,
	"〞": 12.27,
	"〟": 11.09,
	"〠": 11.09,
	"〡": 12.27,
	"〢": 12.27,
	"〣": 12.27,
	"〤": 12.27,
	"〥": 12.27,
	"〦": 12.27,
	"〧": 12.27,
	"〨": 12.27,
	"〩": 12.27,
	"〪": 12,
	"〫": 12,
	"〬": 12,
	"〭": 12,
	"〮": 19.2,
	"〯": 19.2,
	"〰": 11.09,
	"〱": 12,
	"〲": 12,
	"〳": 11.09,
	"〴": 11.09,
	"〵": 11.09,
	"〶": 11.09,
	"〷": 12,
	"〸": 12.27,
	"〹": 12.27,
	"〺": 12.27,
	"〾": 12.27,
	"〿": 5.55,
	"ぁ": 12.27,
	"あ": 12.27,
	"ぃ": 12.27,
	"い": 12.27,
	"ぅ": 12.27,
	"う": 12.27,
	"ぇ": 12.27,
	"え": 12.27,
	"ぉ": 12.27,
	"お": 12.27,
	"か": 12.27,
	"が": 12.27,
	"き": 12.27,
	"ぎ": 12.27,
	"く": 12.27,
	"ぐ": 12.27,
	"け": 12.27,
	"げ": 12.27,
	"こ": 12.27,
	"ご": 12.27,
	"さ": 12.27,
	"ざ": 12.27,
	"し": 12.27,
	"じ": 12.27,
	"す": 12.27,
	"ず": 12.27,
	"せ": 12.27,
	"ぜ": 12.27,
	"そ": 12.27,
	"ぞ": 12.27,
	"た": 12.27,
	"だ": 12.27,
	"ち": 12.27,
	"ぢ": 12.27,
	"っ": 12.27,
	"つ": 12.27,
	"づ": 12.27,
	"て": 12.27,
	"で": 12.27,
	"と": 12.27,
	"ど": 12.27,
	"な": 12.27,
	"に": 12.27,
	"ぬ": 12.27,
	"ね": 12.27,
	"の": 12.27,
	"は": 12.27,
	"ば": 12.27,
	"ぱ": 12.27,
	"ひ": 12.27,
	"び": 12.27,
	"ぴ": 12.27,
	"ふ": 12.27,
	"ぶ": 12.27,
	"ぷ": 12.27,
	"へ": 12.27,
	"べ": 12.27,
	"ぺ": 12.27,
	"ほ": 12.27,
	"ぼ": 12.27,
	"ぽ": 12.27,
	"ま": 12.27,
	"み": 12.27,
	"む": 12.27,
	"め": 12.27,
	"も": 12.27,
	"ゃ": 12.27,
	"や": 12.27,
	"ゅ": 12.27,
	"ゆ": 12.27,
	"ょ": 12.27,
	"よ": 12.27,
	"ら": 12.27,
	"り": 12.27,
	"る": 12.27,
	"れ": 12.27,
	"ろ": 12.27,
	"ゎ": 12.27,
	"わ": 12.27,
	"ゐ": 12.27,
	"ゑ": 12.27,
	"を": 12.27,
	"ん": 12.27,
	"ゔ": 11.09,
	"゙": 12.27,
	"゚": 12.27,
	"゛": 12.27,
	"゜": 12.27,
	"ゝ": 12.27,
	"ゞ": 12.27,
	"ァ": 12.27,
	"ア": 12.27,
	"ィ": 12.27,
	"イ": 12.27,
	"ゥ": 12.27,
	"ウ": 12.27,
	"ェ": 12.27,
	"エ": 12.27,
	"ォ": 12.27,
	"オ": 12.27,
	"カ": 12.27,
	"ガ": 12.27,
	"キ": 12.27,
	"ギ": 12.27,
	"ク": 12.27,
	"グ": 12.27,
	"ケ": 12.27,
	"ゲ": 12.27,
	"コ": 12.27,
	"ゴ": 12.27,
	"サ": 12.27,
	"ザ": 12.27,
	"シ": 12.27,
	"ジ": 12.27,
	"ス": 12.27,
	"ズ": 12.27,
	"セ": 12.27,
	"ゼ": 12.27,
	"ソ": 12.27,
	"ゾ": 12.27,
	"タ": 12.27,
	"ダ": 12.27,
	"チ": 12.27,
	"ヂ": 12.27,
	"ッ": 12.27,
	"ツ": 12.27,
	"ヅ": 12.27,
	"テ": 12.27,
	"デ": 12.27,
	"ト": 12.27,
	"ド": 12.27,
	"ナ": 12.27,
	"ニ": 12.27,
	"ヌ": 12.27,
	"ネ": 12.27,
	"ノ": 12.27,
	"ハ": 12.27,
	"バ": 12.27,
	"パ": 12.27,
	"ヒ": 12.27,
	"ビ": 12.27,
	"ピ": 12.27,
	"フ": 12.27,
	"ブ": 12.27,
	"プ": 12.27,
	"ヘ": 12.27,
	"ベ": 12.27,
	"ペ": 12.27,
	"ホ": 12.27,
	"ボ": 12.27,
	"ポ": 12.27,
	"マ": 12.27,
	"ミ": 12.27,
	"ム": 12.27,
	"メ": 12.27,
	"モ": 12.27,
	"ャ": 12.27,
	"ヤ": 12.27,
	"ュ": 12.27,
	"ユ": 12.27,
	"ョ": 12.27,
	"ヨ": 12.27,
	"ラ": 12.27,
	"リ": 12.27,
	"ル": 12.27,
	"レ": 12.27,
	"ロ": 12.27,
	"ヮ": 12.27,
	"ワ": 12.27,
	"ヰ": 12.27,
	"ヱ": 12.27,
	"ヲ": 12.27,
	"ン": 12.27,
	"ヴ": 12.27,
	"ヵ": 12.27,
	"ヶ": 12.27,
	"ヷ": 11.09,
	"ヸ": 11.09,
	"ヹ": 11.09,
	"ヺ": 11.09,
	"・": 12.27,
	"ー": 12.27,
	"ヽ": 12.27,
	"ヾ": 12.27,
	"ㄅ": 12.27,
	"ㄆ": 12.27,
	"ㄇ": 12.27,
	"ㄈ": 12.27,
	"ㄉ": 12.27,
	"ㄊ": 12.27,
	"ㄋ": 12.27,
	"ㄌ": 12.27,
	"ㄍ": 12.27,
	"ㄎ": 12.27,
	"ㄏ": 12.27,
	"ㄐ": 12.27,
	"ㄑ": 12.27,
	"ㄒ": 12.27,
	"ㄓ": 12.27,
	"ㄔ": 12.27,
	"ㄕ": 12.27,
	"ㄖ": 12.27,
	"ㄗ": 12.27,
	"ㄘ": 12.27,
	"ㄙ": 12.27,
	"ㄚ": 12.27,
	"ㄛ": 12.27,
	"ㄜ": 12.27,
	"ㄝ": 12.27,
	"ㄞ": 12.27,
	"ㄟ": 12.27,
	"ㄠ": 12.27,
	"ㄡ": 12.27,
	"ㄢ": 12.27,
	"ㄣ": 12.27,
	"ㄤ": 12.27,
	"ㄥ": 12.27,
	"ㄦ": 12.27,
	"ㄧ": 12.27,
	"ㄨ": 12.27,
	"ㄩ": 12.27,
	"ㄪ": 11.09,
	"ㄫ": 11.09,
	"ㄬ": 11.09,
	"ㄱ": 10.39,
	"ㄲ": 10.39,
	"ㄳ": 10.39,
	"ㄴ": 10.39,
	"ㄵ": 10.39,
	"ㄶ": 10.39,
	"ㄷ": 10.39,
	"ㄸ": 10.39,
	"ㄹ": 10.39,
	"ㄺ": 10.39,
	"ㄻ": 10.39,
	"ㄼ": 10.39,
	"ㄽ": 10.39,
	"ㄾ": 10.39,
	"ㄿ": 10.39,
	"ㅀ": 10.39,
	"ㅁ": 10.39,
	"ㅂ": 10.39,
	"ㅃ": 10.39,
	"ㅄ": 10.39,
	"ㅅ": 10.39,
	"ㅆ": 10.39,
	"ㅇ": 10.39,
	"ㅈ": 10.39,
	"ㅉ": 10.39,
	"ㅊ": 10.39,
	"ㅋ": 10.39,
	"ㅌ": 10.39,
	"ㅍ": 10.39,
	"ㅎ": 10.39,
	"ㅏ": 10.39,
	"ㅐ": 10.39,
	"ㅑ": 10.39,
	"ㅒ": 10.39,
	"ㅓ": 10.39,
	"ㅔ": 10.39,
	"ㅕ": 10.39,
	"ㅖ": 10.39,
	"ㅗ": 10.39,
	"ㅘ": 10.39,
	"ㅙ": 10.39,
	"ㅚ": 10.39,
	"ㅛ": 10.39,
	"ㅜ": 10.39,
	"ㅝ": 10.39,
	"ㅞ": 10.39,
	"ㅟ": 10.39,
	"ㅠ": 10.39,
	"ㅡ": 10.39,
	"ㅢ": 10.39,
	"ㅣ": 10.39,
	"ㅤ": 0,
	"ㅥ": 10.39,
	"ㅦ": 10.39,
	"ㅧ": 10.39,
	"ㅨ": 10.39,
	"ㅩ": 10.39,
	"ㅪ": 10.39,
	"ㅫ": 10.39,
	"ㅬ": 10.39,
	"ㅭ": 10.39,
	"ㅮ": 10.39,
	"ㅯ": 10.39,
	"ㅰ": 10.39,
	"ㅱ": 10.39,
	"ㅲ": 10.39,
	"ㅳ": 10.39,
	"ㅴ": 10.39,
	"ㅵ": 10.39,
	"ㅶ": 10.39,
	"ㅷ": 10.39,
	"ㅸ": 10.39,
	"ㅹ": 10.39,
	"ㅺ": 10.39,
	"ㅻ": 10.39,
	"ㅼ": 10.39,
	"ㅽ": 10.39,
	"ㅾ": 10.39,
	"ㅿ": 10.39,
	"ㆀ": 10.39,
	"ㆁ": 10.39,
	"ㆂ": 10.39,
	"ㆃ": 10.39,
	"ㆄ": 10.39,
	"ㆅ": 10.39,
	"ㆆ": 10.39,
	"ㆇ": 10.39,
	"ㆈ": 10.39,
	"ㆉ": 10.39,
	"ㆊ": 10.39,
	"ㆋ": 10.39,
	"ㆌ": 10.39,
	"ㆍ": 10.39,
	"ㆎ": 10.39,
	"㆐": 11.09,
	"㆑": 11.09,
	"㆒": 11.09,
	"㆓": 11.09,
	"㆔": 11.09,
	"㆕": 11.09,
	"㆖": 11.09,
	"㆗": 11.09,
	"㆘": 11.09,
	"㆙": 11.09,
	"㆚": 11.09,
	"㆛": 11.09,
	"㆜": 11.09,
	"㆝": 11.09,
	"㆞": 11.09,
	"㆟": 11.09,
	"ㆠ": 11.09,
	"ㆡ": 11.09,
	"ㆢ": 11.09,
	"ㆣ": 11.09,
	"ㆤ": 11.09,
	"ㆥ": 11.09,
	"ㆦ": 11.09,
	"ㆧ": 11.09,
	"ㆨ": 11.09,
	"ㆩ": 11.09,
	"ㆪ": 11.09,
	"ㆫ": 11.09,
	"ㆬ": 11.09,
	"ㆭ": 11.09,
	"ㆮ": 11.09,
	"ㆯ": 11.09,
	"ㆰ": 11.09,
	"ㆱ": 11.09,
	"ㆲ": 11.09,
	"ㆳ": 11.09,
	"ㆴ": 11.09,
	"ㆵ": 11.09,
	"ㆶ": 11.09,
	"ㆷ": 11.09,
	"㈀": 10.39,
	"㈁": 10.39,
	"㈂": 10.39,
	"㈃": 10.39,
	"㈄": 10.39,
	"㈅": 10.39,
	"㈆": 10.39,
	"㈇": 10.39,
	"㈈": 10.39,
	"㈉": 10.39,
	"㈊": 10.39,
	"㈋": 10.39,
	"㈌": 10.39,
	"㈍": 10.39,
	"㈎": 10.39,
	"㈏": 10.39,
	"㈐": 10.39,
	"㈑": 10.39,
	"㈒": 10.39,
	"㈓": 10.39,
	"㈔": 10.39,
	"㈕": 10.39,
	"㈖": 10.39,
	"㈗": 10.39,
	"㈘": 10.39,
	"㈙": 10.39,
	"㈚": 10.39,
	"㈛": 10.39,
	"㈜": 10.22,
	"㈠": 12.27,
	"㈡": 12.27,
	"㈢": 12.27,
	"㈣": 12.27,
	"㈤": 12.27,
	"㈥": 12.27,
	"㈦": 12.27,
	"㈧": 12.27,
	"㈨": 12.27,
	"㈩": 12.27,
	"㈪": 12.27,
	"㈫": 12.27,
	"㈬": 12.27,
	"㈭": 12.27,
	"㈮": 12.27,
	"㈯": 12.27,
	"㈰": 12.27,
	"㈱": 12.27,
	"㈲": 12.27,
	"㈳": 12.27,
	"㈴": 12.27,
	"㈵": 12.27,
	"㈶": 12.27,
	"㈷": 12.27,
	"㈸": 12.27,
	"㈹": 12.27,
	"㈺": 12.27,
	"㈻": 12.27,
	"㈼": 12.27,
	"㈽": 12.27,
	"㈾": 12.27,
	"㈿": 12.27,
	"㉀": 12.27,
	"㉁": 12.27,
	"㉂": 12.27,
	"㉃": 12.27,
	"㉠": 10.39,
	"㉡": 10.39,
	"㉢": 10.39,
	"㉣": 10.39,
	"㉤": 10.39,
	"㉥": 10.39,
	"㉦": 10.39,
	"㉧": 10.39,
	"㉨": 10.39,
	"㉩": 10.39,
	"㉪": 10.39,
	"㉫": 10.39,
	"㉬": 10.39,
	"㉭": 10.39,
	"㉮": 10.39,
	"㉯": 10.39,
	"㉰": 10.39,
	"㉱": 10.39,
	"㉲": 10.39,
	"㉳": 10.39,
	"㉴": 10.39,
	"㉵": 10.39,
	"㉶": 10.39,
	"㉷": 10.39,
	"㉸": 10.39,
	"㉹": 10.39,
	"㉺": 10.39,
	"㉻": 10.39,
	"㉿": 10.16,
	"㊀": 12.27,
	"㊁": 12.27,
	"㊂": 12.27,
	"㊃": 12.27,
	"㊄": 12.27,
	"㊅": 12.27,
	"㊆": 12.27,
	"㊇": 12.27,
	"㊈": 12.27,
	"㊉": 12.27,
	"㊊": 12.27,
	"㊋": 12.27,
	"㊌": 12.27,
	"㊍": 12.27,
	"㊎": 12.27,
	"㊏": 12.27,
	"㊐": 12.27,
	"㊑": 12.27,
	"㊒": 12.27,
	"㊓": 12.27,
	"㊔": 12.27,
	"㊕": 12.27,
	"㊖": 12.27,
	"㊗": 11.09,
	"㊘": 12.27,
	"㊙": 11.09,
	"㊚": 12.27,
	"㊛": 12.27,
	"㊜": 12.27,
	"㊝": 12.27,
	"㊞": 12.27,
	"㊟": 12.27,
	"㊠": 12.27,
	"㊡": 12.27,
	"㊢": 12.27,
	"㊣": 12.27,
	"㊤": 12.27,
	"㊥": 12.27,
	"㊦": 12.27,
	"㊧": 12.27,
	"㊨": 12.27,
	"㊩": 12.27,
	"㊪": 12.27,
	"㊫": 12.27,
	"㊬": 12.27,
	"㊭": 12.27,
	"㊮": 12.27,
	"㊯": 12.27,
	"㊰": 12.27,
	"㋀": 12.27,
	"㋁": 12.27,
	"㋂": 12.27,
	"㋃": 12.27,
	"㋄": 12.27,
	"㋅": 12.27,
	"㋆": 12.27,
	"㋇": 12.27,
	"㋈": 12.27,
	"㋉": 12.27,
	"㋊": 12.27,
	"㋋": 12.27,
	"㋐": 11.09,
	"㋑": 11.09,
	"㋒": 11.09,
	"㋓": 11.09,
	"㋔": 11.09,
	"㋕": 11.09,
	"㋖": 11.09,
	"㋗": 11.09,
	"㋘": 11.09,
	"㋙": 11.09,
	"㋚": 11.09,
	"㋛": 11.09,
	"㋜": 11.09,
	"㋝": 11.09,
	"㋞": 11.09,
	"㋟": 11.09,
	"㋠": 11.09,
	"㋡": 11.09,
	"㋢": 11.09,
	"㋣": 11.09,
	"㋤": 11.09,
	"㋥": 11.09,
	"㋦": 11.09,
	"㋧": 11.09,
	"㋨": 11.09,
	"㋩": 11.09,
	"㋪": 11.09,
	"㋫": 11.09,
	"㋬": 11.09,
	"㋭": 11.09,
	"㋮": 11.09,
	"㋯": 11.09,
	"㋰": 11.09,
	"㋱": 11.09,
	"㋲": 11.09,
	"㋳": 11.09,
	"㋴": 11.09,
	"㋵": 11.09,
	"㋶": 11.09,
	"㋷": 11.09,
	"㋸": 11.09,
	"㋹": 11.09,
	"㋺": 11.09,
	"㋻": 11.09,
	"㋼": 11.09,
	"㋽": 11.09,
	"㋾": 11.09,
	"㌀": 11.09,
	"㌁": 11.09,
	"㌂": 11.09,
	"㌃": 11.09,
	"㌄": 11.09,
	"㌅": 11.09,
	"㌆": 11.09,
	"㌇": 11.09,
	"㌈": 11.09,
	"㌉": 11.09,
	"㌊": 11.09,
	"㌋": 11.09,
	"㌌": 11.09,
	"㌍": 11.09,
	"㌎": 11.09,
	"㌏": 11.09,
	"㌐": 11.09,
	"㌑": 11.09,
	"㌒": 11.09,
	"㌓": 11.09,
	"㌔": 11.09,
	"㌕": 11.09,
	"㌖": 11.09,
	"㌗": 11.09,
	"㌘": 11.09,
	"㌙": 11.09,
	"㌚": 11.09,
	"㌛": 11.09,
	"㌜": 11.09,
	"㌝": 11.09,
	"㌞": 11.09,
	"㌟": 11.09,
	"㌠": 11.09,
	"㌡": 11.09,
	"㌢": 11.09,
	"㌣": 11.09,
	"㌤": 11.09,
	"㌥": 11.09,
	"㌦": 11.09,
	"㌧": 11.09,
	"㌨": 11.09,
	"㌩": 11.09,
	"㌪": 11.09,
	"㌫": 11.09,
	"㌬": 12,
	"㌭": 11.09,
	"㌮": 11.09,
	"㌯": 11.09,
	"㌰": 11.09,
	"㌱": 11.09,
	"㌲": 11.09,
	"㌳": 11.09,
	"㌴": 11.09,
	"㌵": 11.09,
	"㌶": 11.09,
	"㌷": 11.09,
	"㌸": 11.09,
	"㌹": 11.09,
	"㌺": 11.09,
	"㌻": 11.09,
	"㌼": 11.09,
	"㌽": 11.09,
	"㌾": 11.09,
	"㌿": 11.09,
	"㍀": 11.09,
	"㍁": 11.09,
	"㍂": 11.09,
	"㍃": 11.09,
	"㍄": 11.09,
	"㍅": 11.09,
	"㍆": 11.09,
	"㍇": 11.09,
	"㍈": 11.09,
	"㍉": 11.09,
	"㍊": 11.09,
	"㍋": 11.09,
	"㍌": 11.09,
	"㍍": 11.09,
	"㍎": 11.09,
	"㍏": 11.09,
	"㍐": 11.09,
	"㍑": 11.09,
	"㍒": 11.09,
	"㍓": 11.09,
	"㍔": 11.09,
	"㍕": 11.09,
	"㍖": 11.09,
	"㍗": 11.09,
	"㍘": 12.27,
	"㍙": 12.27,
	"㍚": 12.27,
	"㍛": 12.27,
	"㍜": 12.27,
	"㍝": 12.27,
	"㍞": 12.27,
	"㍟": 12.27,
	"㍠": 12.27,
	"㍡": 12.27,
	"㍢": 12.27,
	"㍣": 12.27,
	"㍤": 12.27,
	"㍥": 12.27,
	"㍦": 12.27,
	"㍧": 12.27,
	"㍨": 12.27,
	"㍩": 12.27,
	"㍪": 12.27,
	"㍫": 12.27,
	"㍬": 12.27,
	"㍭": 12.27,
	"㍮": 12.27,
	"㍯": 12.27,
	"㍰": 12.27,
	"㍱": 11.09,
	"㍲": 12,
	"㍳": 12,
	"㍴": 12,
	"㍵": 12,
	"㍶": 12,
	"㍻": 11.09,
	"㍼": 11.09,
	"㍽": 11.09,
	"㍾": 11.09,
	"㍿": 11.09,
	"㎀": 10.39,
	"㎁": 10.39,
	"㎂": 10.39,
	"㎃": 10.39,
	"㎄": 10.39,
	"㎅": 11.09,
	"㎆": 11.09,
	"㎇": 11.09,
	"㎈": 11.09,
	"㎉": 11.09,
	"㎊": 10.39,
	"㎋": 10.39,
	"㎌": 10.39,
	"㎍": 11.09,
	"㎎": 12.27,
	"㎏": 12.27,
	"㎐": 11.09,
	"㎑": 10.39,
	"㎒": 10.39,
	"㎓": 10.39,
	"㎔": 10.39,
	"㎕": 10.39,
	"㎖": 11.09,
	"㎗": 11.09,
	"㎘": 11.09,
	"㎙": 10.39,
	"㎚": 10.39,
	"㎛": 11.09,
	"㎜": 12.27,
	"㎝": 12.27,
	"㎞": 12.27,
	"㎟": 12.27,
	"㎠": 12.27,
	"㎡": 12.27,
	"㎢": 12.27,
	"㎣": 12.27,
	"㎤": 12.27,
	"㎥": 12.27,
	"㎦": 12.27,
	"㎧": 10.39,
	"㎨": 10.39,
	"㎩": 10.39,
	"㎪": 10.39,
	"㎫": 10.39,
	"㎬": 10.39,
	"㎭": 10.39,
	"㎮": 10.39,
	"㎯": 10.39,
	"㎰": 11.09,
	"㎱": 11.09,
	"㎲": 11.09,
	"㎳": 11.09,
	"㎴": 10.39,
	"㎵": 10.39,
	"㎶": 10.39,
	"㎷": 10.39,
	"㎸": 10.39,
	"㎹": 10.39,
	"㎺": 10.39,
	"㎻": 10.39,
	"㎼": 10.39,
	"㎽": 10.39,
	"㎾": 10.39,
	"㎿": 10.39,
	"㏀": 10.39,
	"㏁": 10.39,
	"㏂": 12.27,
	"㏃": 10.39,
	"㏄": 12.27,
	"㏅": 10.39,
	"㏆": 10.39,
	"㏇": 10.16,
	"㏈": 11.09,
	"㏉": 10.39,
	"㏊": 10.39,
	"㏋": 11.09,
	"㏌": 11.09,
	"㏍": 11.09,
	"㏎": 12.27,
	"㏏": 10.39,
	"㏐": 10.39,
	"㏑": 12.27,
	"㏒": 12.27,
	"㏓": 10.39,
	"㏔": 11.09,
	"㏕": 12.27,
	"㏖": 10.39,
	"㏗": 11.09,
	"㏘": 12.27,
	"㏙": 12,
	"㏚": 11.09,
	"㏛": 10.39,
	"㏜": 10.39,
	"㏝": 10.39,
	"㏠": 12.27,
	"㏡": 12.27,
	"㏢": 12.27,
	"㏣": 12.27,
	"㏤": 12.27,
	"㏥": 12.27,
	"㏦": 12.27,
	"㏧": 12.27,
	"㏨": 12.27,
	"㏩": 12.27,
	"㏪": 12.27,
	"㏫": 12.27,
	"㏬": 12.27,
	"㏭": 12.27,
	"㏮": 12.27,
	"㏯": 12.27,
	"㏰": 12.27,
	"㏱": 12.27,
	"㏲": 12.27,
	"㏳": 12.27,
	"㏴": 12.27,
	"㏵": 12.27,
	"㏶": 12.27,
	"㏷": 12.27,
	"㏸": 12.27,
	"㏹": 12.27,
	"㏺": 12.27,
	"㏻": 12.27,
	"㏼": 12.27,
	"㏽": 12.27,
	"㏾": 12.27,
	"㐀": 12.27,
	"䶵": 12.27,
	"一": 12.27,
	"龥": 12.27,
	"ꀀ": 7.41,
	"ꀁ": 7.41,
	"ꀂ": 7.41,
	"ꀃ": 7.7,
	"ꀄ": 7.39,
	"ꀅ": 6.83,
	"ꀆ": 6.83,
	"ꀇ": 7.56,
	"ꀈ": 6.31,
	"ꀉ": 6.53,
	"ꀊ": 6.53,
	"ꀋ": 6.75,
	"ꀌ": 7.13,
	"ꀍ": 7.13,
	"ꀎ": 6.89,
	"ꀏ": 6.98,
	"ꀐ": 8.23,
	"ꀑ": 8.23,
	"ꀒ": 8.23,
	"ꀓ": 7.08,
	"ꀔ": 6.94,
	"ꀕ": 7.66,
	"ꀖ": 7.52,
	"ꀗ": 6.39,
	"ꀘ": 6.39,
	"ꀙ": 6.39,
	"ꀚ": 8.11,
	"ꀛ": 7.02,
	"ꀜ": 7.02,
	"ꀝ": 7.53,
	"ꀞ": 6.17,
	"ꀟ": 7.66,
	"ꀠ": 7.66,
	"ꀡ": 7.27,
	"ꀢ": 7,
	"ꀣ": 7,
	"ꀤ": 5.39,
	"ꀥ": 7.22,
	"ꀦ": 6.25,
	"ꀧ": 6.25,
	"ꀨ": 6.22,
	"ꀩ": 7.36,
	"ꀪ": 7.36,
	"ꀫ": 5.39,
	"ꀬ": 6.88,
	"ꀭ": 6.3,
	"ꀮ": 6.3,
	"ꀯ": 5.95,
	"ꀰ": 7.28,
	"ꀱ": 7.28,
	"ꀲ": 6.58,
	"ꀳ": 6.47,
	"ꀴ": 6.47,
	"ꀵ": 7.23,
	"ꀶ": 8.47,
	"ꀷ": 8.47,
	"ꀸ": 7.3,
	"ꀹ": 7.47,
	"ꀺ": 7.47,
	"ꀻ": 6.88,
	"ꀼ": 8.02,
	"ꀽ": 8.02,
	"ꀾ": 7.36,
	"ꀿ": 7.13,
	"ꁀ": 7.36,
	"ꁁ": 7.36,
	"ꁂ": 7.48,
	"ꁃ": 6.89,
	"ꁄ": 6.89,
	"ꁅ": 7.08,
	"ꁆ": 7.45,
	"ꁇ": 7.67,
	"ꁈ": 7.67,
	"ꁉ": 6.77,
	"ꁊ": 6.02,
	"ꁋ": 6.97,
	"ꁌ": 6.97,
	"ꁍ": 7.17,
	"ꁎ": 7.48,
	"ꁏ": 7.48,
	"ꁐ": 7.3,
	"ꁑ": 7.72,
	"ꁒ": 7.72,
	"ꁓ": 7.34,
	"ꁔ": 7.41,
	"ꁕ": 7.41,
	"ꁖ": 7.36,
	"ꁗ": 6.98,
	"ꁘ": 6.98,
	"ꁙ": 7.11,
	"ꁚ": 7.53,
	"ꁛ": 6.86,
	"ꁜ": 6.86,
	"ꁝ": 7.38,
	"ꁞ": 7.56,
	"ꁟ": 9.63,
	"ꁠ": 9.63,
	"ꁡ": 7.66,
	"ꁢ": 6.89,
	"ꁣ": 6.89,
	"ꁤ": 7.3,
	"ꁥ": 7.31,
	"ꁦ": 6.05,
	"ꁧ": 6.05,
	"ꁨ": 7.36,
	"ꁩ": 6.92,
	"ꁪ": 6.92,
	"ꁫ": 7.3,
	"ꁬ": 7.41,
	"ꁭ": 7.09,
	"ꁮ": 7.09,
	"ꁯ": 6.66,
	"ꁰ": 6.92,
	"ꁱ": 6.92,
	"ꁲ": 6.7,
	"ꁳ": 6.38,
	"ꁴ": 6.38,
	"ꁵ": 6.13,
	"ꁶ": 7.03,
	"ꁷ": 6.83,
	"ꁸ": 6.83,
	"ꁹ": 6.64,
	"ꁺ": 7.08,
	"ꁻ": 7.08,
	"ꁼ": 6.33,
	"ꁽ": 7.97,
	"ꁾ": 6.55,
	"ꁿ": 6.55,
	"ꂀ": 8.06,
	"ꂁ": 7.25,
	"ꂂ": 7.66,
	"ꂃ": 7.66,
	"ꂄ": 7.66,
	"ꂅ": 6.73,
	"ꂆ": 7.3,
	"ꂇ": 7.3,
	"ꂈ": 6.77,
	"ꂉ": 8.52,
	"ꂊ": 8.52,
	"ꂋ": 7.05,
	"ꂌ": 7.36,
	"ꂍ": 7.36,
	"ꂎ": 6.84,
	"ꂏ": 6.78,
	"ꂐ": 6.78,
	"ꂑ": 6.13,
	"ꂒ": 6.73,
	"ꂓ": 6.73,
	"ꂔ": 7.11,
	"ꂕ": 7.67,
	"ꂖ": 7.44,
	"ꂗ": 6.08,
	"ꂘ": 7.25,
	"ꂙ": 7.14,
	"ꂚ": 7.14,
	"ꂛ": 6.92,
	"ꂜ": 7.05,
	"ꂝ": 7.05,
	"ꂞ": 6.42,
	"ꂟ": 7.3,
	"ꂠ": 7.02,
	"ꂡ": 7.02,
	"ꂢ": 6.69,
	"ꂣ": 6.59,
	"ꂤ": 6.52,
	"ꂥ": 6.52,
	"ꂦ": 7.11,
	"ꂧ": 7.67,
	"ꂨ": 7.67,
	"ꂩ": 6.25,
	"ꂪ": 6.25,
	"ꂫ": 6.42,
	"ꂬ": 7.36,
	"ꂭ": 7.36,
	"ꂮ": 7.11,
	"ꂯ": 6.5,
	"ꂰ": 6.5,
	"ꂱ": 6.22,
	"ꂲ": 7.11,
	"ꂳ": 7.11,
	"ꂴ": 6.55,
	"ꂵ": 7.61,
	"ꂶ": 7.19,
	"ꂷ": 7.19,
	"ꂸ": 7.66,
	"ꂹ": 6.72,
	"ꂺ": 6.83,
	"ꂻ": 6.83,
	"ꂼ": 8.23,
	"ꂽ": 7.3,
	"ꂾ": 6.73,
	"ꂿ": 6.73,
	"ꃀ": 7,
	"ꃁ": 7.2,
	"ꃂ": 7.2,
	"ꃃ": 6.94,
	"ꃄ": 7.86,
	"ꃅ": 7.86,
	"ꃆ": 6.98,
	"ꃇ": 6.33,
	"ꃈ": 6.33,
	"ꃉ": 6.39,
	"ꃊ": 7.67,
	"ꃋ": 7.67,
	"ꃌ": 6.33,
	"ꃍ": 6.66,
	"ꃎ": 6.69,
	"ꃏ": 6.69,
	"ꃐ": 6.3,
	"ꃑ": 7.91,
	"ꃒ": 6.73,
	"ꃓ": 6.73,
	"ꃔ": 6.73,
	"ꃕ": 6.34,
	"ꃖ": 6.34,
	"ꃗ": 6.44,
	"ꃘ": 5.8,
	"ꃙ": 7.47,
	"ꃚ": 7.47,
	"ꃛ": 7.3,
	"ꃜ": 6.58,
	"ꃝ": 6.58,
	"ꃞ": 6.73,
	"ꃟ": 7.3,
	"ꃠ": 7.3,
	"ꃡ": 7.3,
	"ꃢ": 7.3,
	"ꃣ": 6.48,
	"ꃤ": 6.48,
	"ꃥ": 6.58,
	"ꃦ": 6.47,
	"ꃧ": 6.05,
	"ꃨ": 6.05,
	"ꃩ": 6.19,
	"ꃪ": 7.11,
	"ꃫ": 7.11,
	"ꃬ": 7.11,
	"ꃭ": 6.19,
	"ꃮ": 6.8,
	"ꃯ": 6.69,
	"ꃰ": 6.69,
	"ꃱ": 7.63,
	"ꃲ": 6.52,
	"ꃳ": 6.52,
	"ꃴ": 6.94,
	"ꃵ": 6.22,
	"ꃶ": 6.22,
	"ꃷ": 6.48,
	"ꃸ": 6.69,
	"ꃹ": 6.69,
	"ꃺ": 6.73,
	"ꃻ": 7.67,
	"ꃼ": 7.67,
	"ꃽ": 6.73,
	"ꃾ": 7.5,
	"ꃿ": 7.5,
	"ꄀ": 8.09,
	"ꄁ": 6.66,
	"ꄂ": 6.66,
	"ꄃ": 7.41,
	"ꄄ": 6.86,
	"ꄅ": 6.86,
	"ꄆ": 6.8,
	"ꄇ": 7.52,
	"ꄈ": 6.27,
	"ꄉ": 6.27,
	"ꄊ": 7.36,
	"ꄋ": 6.44,
	"ꄌ": 6.44,
	"ꄍ": 6.83,
	"ꄎ": 6.78,
	"ꄏ": 6.78,
	"ꄐ": 6.13,
	"ꄑ": 5.98,
	"ꄒ": 5.98,
	"ꄓ": 6.45,
	"ꄔ": 5.89,
	"ꄕ": 6.11,
	"ꄖ": 6.11,
	"ꄗ": 6.64,
	"ꄘ": 6.05,
	"ꄙ": 6.05,
	"ꄚ": 6.13,
	"ꄛ": 5.92,
	"ꄜ": 5.92,
	"ꄝ": 6.11,
	"ꄞ": 6.88,
	"ꄟ": 6.88,
	"ꄠ": 6.83,
	"ꄡ": 5.98,
	"ꄢ": 6.45,
	"ꄣ": 6.45,
	"ꄤ": 5.98,
	"ꄥ": 6.72,
	"ꄦ": 5.8,
	"ꄧ": 5.8,
	"ꄨ": 7.14,
	"ꄩ": 6.13,
	"ꄪ": 6.42,
	"ꄫ": 6.42,
	"ꄬ": 6.47,
	"ꄭ": 6.77,
	"ꄮ": 6.77,
	"ꄯ": 6.45,
	"ꄰ": 7.09,
	"ꄱ": 7.11,
	"ꄲ": 7.11,
	"ꄳ": 7.05,
	"ꄴ": 7.39,
	"ꄵ": 7.39,
	"ꄶ": 6.45,
	"ꄷ": 6.27,
	"ꄸ": 6.27,
	"ꄹ": 6.45,
	"ꄺ": 6.45,
	"ꄻ": 6.45,
	"ꄼ": 6.45,
	"ꄽ": 6.77,
	"ꄾ": 6.45,
	"ꄿ": 6.45,
	"ꅀ": 6.45,
	"ꅁ": 6.72,
	"ꅂ": 6.72,
	"ꅃ": 6.63,
	"ꅄ": 6.25,
	"ꅅ": 6.09,
	"ꅆ": 6.09,
	"ꅇ": 6.38,
	"ꅈ": 6.22,
	"ꅉ": 6.22,
	"ꅊ": 7.3,
	"ꅋ": 6.91,
	"ꅌ": 7.67,
	"ꅍ": 7.67,
	"ꅎ": 7.05,
	"ꅏ": 7.36,
	"ꅐ": 7.36,
	"ꅑ": 6.45,
	"ꅒ": 5.84,
	"ꅓ": 5.84,
	"ꅔ": 6.66,
	"ꅕ": 6.89,
	"ꅖ": 6.89,
	"ꅗ": 6.77,
	"ꅘ": 6.73,
	"ꅙ": 6.73,
	"ꅚ": 7.77,
	"ꅛ": 6.64,
	"ꅜ": 6.73,
	"ꅝ": 6.73,
	"ꅞ": 6.73,
	"ꅟ": 7.3,
	"ꅠ": 7.3,
	"ꅡ": 7.17,
	"ꅢ": 6.13,
	"ꅣ": 6.38,
	"ꅤ": 6.38,
	"ꅥ": 6.98,
	"ꅦ": 6.64,
	"ꅧ": 6.64,
	"ꅨ": 5.94,
	"ꅩ": 5.81,
	"ꅪ": 5.81,
	"ꅫ": 6.73,
	"ꅬ": 6.5,
	"ꅭ": 7.3,
	"ꅮ": 7.3,
	"ꅯ": 6.78,
	"ꅰ": 6.03,
	"ꅱ": 7.05,
	"ꅲ": 7.05,
	"ꅳ": 6.42,
	"ꅴ": 8,
	"ꅵ": 8,
	"ꅶ": 6.92,
	"ꅷ": 6.27,
	"ꅸ": 6.27,
	"ꅹ": 6.45,
	"ꅺ": 6.45,
	"ꅻ": 6.86,
	"ꅼ": 6.98,
	"ꅽ": 7.11,
	"ꅾ": 7.36,
	"ꅿ": 7.36,
	"ꆀ": 7.3,
	"ꆁ": 7.14,
	"ꆂ": 7.14,
	"ꆃ": 6.61,
	"ꆄ": 6.72,
	"ꆅ": 6.72,
	"ꆆ": 6.59,
	"ꆇ": 6.47,
	"ꆈ": 6.47,
	"ꆉ": 6.89,
	"ꆊ": 6.78,
	"ꆋ": 6.83,
	"ꆌ": 6.83,
	"ꆍ": 6.78,
	"ꆎ": 6.3,
	"ꆏ": 6.3,
	"ꆐ": 6.25,
	"ꆑ": 6.58,
	"ꆒ": 6.92,
	"ꆓ": 6.92,
	"ꆔ": 6.92,
	"ꆕ": 6.52,
	"ꆖ": 6.52,
	"ꆗ": 6.73,
	"ꆘ": 6.73,
	"ꆙ": 6.73,
	"ꆚ": 6.47,
	"ꆛ": 6.73,
	"ꆜ": 6.73,
	"ꆝ": 6.98,
	"ꆞ": 7.47,
	"ꆟ": 7.31,
	"ꆠ": 7.31,
	"ꆡ": 6.88,
	"ꆢ": 6.67,
	"ꆣ": 6.67,
	"ꆤ": 6.86,
	"ꆥ": 6.44,
	"ꆦ": 6.44,
	"ꆧ": 6.86,
	"ꆨ": 6.25,
	"ꆩ": 6.25,
	"ꆪ": 6.25,
	"ꆫ": 6.78,
	"ꆬ": 6,
	"ꆭ": 6,
	"ꆮ": 6.52,
	"ꆯ": 6.58,
	"ꆰ": 6.58,
	"ꆱ": 7.14,
	"ꆲ": 7.2,
	"ꆳ": 7.2,
	"ꆴ": 6.97,
	"ꆵ": 6.92,
	"ꆶ": 6.92,
	"ꆷ": 6.45,
	"ꆸ": 5.56,
	"ꆹ": 5.56,
	"ꆺ": 7.11,
	"ꆻ": 5.89,
	"ꆼ": 5.86,
	"ꆽ": 5.86,
	"ꆾ": 5.86,
	"ꆿ": 7.5,
	"ꇀ": 6.16,
	"ꇁ": 6.16,
	"ꇂ": 6.72,
	"ꇃ": 6.38,
	"ꇄ": 6.38,
	"ꇅ": 6.38,
	"ꇆ": 7.2,
	"ꇇ": 7.2,
	"ꇈ": 6.83,
	"ꇉ": 6.83,
	"ꇊ": 6.66,
	"ꇋ": 6.02,
	"ꇌ": 6.02,
	"ꇍ": 7.66,
	"ꇎ": 7.11,
	"ꇏ": 7.66,
	"ꇐ": 7.66,
	"ꇑ": 6.73,
	"ꇒ": 6.14,
	"ꇓ": 6.14,
	"ꇔ": 7.2,
	"ꇕ": 6.73,
	"ꇖ": 6.73,
	"ꇗ": 6.45,
	"ꇘ": 6,
	"ꇙ": 6,
	"ꇚ": 7.16,
	"ꇛ": 7,
	"ꇜ": 7,
	"ꇝ": 6.25,
	"ꇞ": 6.25,
	"ꇟ": 7.2,
	"ꇠ": 7.2,
	"ꇡ": 6.25,
	"ꇢ": 6.75,
	"ꇣ": 6.56,
	"ꇤ": 6.56,
	"ꇥ": 7.11,
	"ꇦ": 7.5,
	"ꇧ": 7.72,
	"ꇨ": 7.72,
	"ꇩ": 7.11,
	"ꇪ": 7.86,
	"ꇫ": 6.69,
	"ꇬ": 6.69,
	"ꇭ": 6.33,
	"ꇮ": 6.39,
	"ꇯ": 6.13,
	"ꇰ": 6.13,
	"ꇱ": 5.94,
	"ꇲ": 7.52,
	"ꇳ": 7.36,
	"ꇴ": 7.36,
	"ꇵ": 7.11,
	"ꇶ": 6.72,
	"ꇷ": 6.72,
	"ꇸ": 6.84,
	"ꇹ": 6.66,
	"ꇺ": 6.66,
	"ꇻ": 5.95,
	"ꇼ": 6.45,
	"ꇽ": 6.45,
	"ꇾ": 6.78,
	"ꇿ": 6.98,
	"ꈀ": 6.38,
	"ꈁ": 6.38,
	"ꈂ": 6.39,
	"ꈃ": 6.52,
	"ꈄ": 6.52,
	"ꈅ": 6.94,
	"ꈆ": 6.33,
	"ꈇ": 6.05,
	"ꈈ": 6.05,
	"ꈉ": 6.56,
	"ꈊ": 7.41,
	"ꈋ": 5.45,
	"ꈌ": 5.45,
	"ꈍ": 7.67,
	"ꈎ": 7.2,
	"ꈏ": 6.89,
	"ꈐ": 6.89,
	"ꈑ": 6.47,
	"ꈒ": 6.09,
	"ꈓ": 6.09,
	"ꈔ": 7.11,
	"ꈕ": 6.45,
	"ꈖ": 6.45,
	"ꈗ": 7.17,
	"ꈘ": 7.17,
	"ꈙ": 6.8,
	"ꈚ": 6.86,
	"ꈛ": 6.63,
	"ꈜ": 6.63,
	"ꈝ": 6.31,
	"ꈞ": 6.58,
	"ꈟ": 7.52,
	"ꈠ": 7.52,
	"ꈡ": 6.98,
	"ꈢ": 6.36,
	"ꈣ": 5.61,
	"ꈤ": 5.61,
	"ꈥ": 5.5,
	"ꈦ": 6.52,
	"ꈧ": 7.13,
	"ꈨ": 7.13,
	"ꈩ": 8.08,
	"ꈪ": 7.25,
	"ꈫ": 6.36,
	"ꈬ": 6.36,
	"ꈭ": 6.36,
	"ꈮ": 6.64,
	"ꈯ": 6.64,
	"ꈰ": 7.19,
	"ꈱ": 7.19,
	"ꈲ": 6.47,
	"ꈳ": 7.31,
	"ꈴ": 7.31,
	"ꈵ": 6.47,
	"ꈶ": 6.64,
	"ꈷ": 6.64,
	"ꈸ": 6.5,
	"ꈹ": 6.5,
	"ꈺ": 7.03,
	"ꈻ": 7.03,
	"ꈼ": 6.92,
	"ꈽ": 6.2,
	"ꈾ": 6.2,
	"ꈿ": 6.58,
	"ꉀ": 7.56,
	"ꉁ": 5.73,
	"ꉂ": 5.73,
	"ꉃ": 6.89,
	"ꉄ": 7.36,
	"ꉅ": 7.36,
	"ꉆ": 6.72,
	"ꉇ": 6.78,
	"ꉈ": 6.78,
	"ꉉ": 6.59,
	"ꉊ": 6.09,
	"ꉋ": 6.7,
	"ꉌ": 6.7,
	"ꉍ": 7.3,
	"ꉎ": 7.05,
	"ꉏ": 6.41,
	"ꉐ": 6.41,
	"ꉑ": 6.75,
	"ꉒ": 7.27,
	"ꉓ": 6.84,
	"ꉔ": 6.84,
	"ꉕ": 7.27,
	"ꉖ": 5.98,
	"ꉗ": 6.3,
	"ꉘ": 6.3,
	"ꉙ": 6.78,
	"ꉚ": 6.64,
	"ꉛ": 6.64,
	"ꉜ": 6.66,
	"ꉝ": 6.72,
	"ꉞ": 6.72,
	"ꉟ": 6.3,
	"ꉠ": 7.31,
	"ꉡ": 6.45,
	"ꉢ": 6.45,
	"ꉣ": 7.06,
	"ꉤ": 7.11,
	"ꉥ": 6.27,
	"ꉦ": 6.27,
	"ꉧ": 5.75,
	"ꉨ": 6.77,
	"ꉩ": 6.77,
	"ꉪ": 7.77,
	"ꉫ": 6.22,
	"ꉬ": 6.22,
	"ꉭ": 7.34,
	"ꉮ": 6.31,
	"ꉯ": 6.31,
	"ꉰ": 6.31,
	"ꉱ": 7.25,
	"ꉲ": 7.41,
	"ꉳ": 7.41,
	"ꉴ": 7.41,
	"ꉵ": 6.53,
	"ꉶ": 6.64,
	"ꉷ": 6.64,
	"ꉸ": 6.97,
	"ꉹ": 6.31,
	"ꉺ": 7.11,
	"ꉻ": 7.11,
	"ꉼ": 6.81,
	"ꉽ": 7.08,
	"ꉾ": 7.08,
	"ꉿ": 7.36,
	"ꊀ": 7.45,
	"ꊁ": 6.69,
	"ꊂ": 6.69,
	"ꊃ": 6.69,
	"ꊄ": 6.61,
	"ꊅ": 6.61,
	"ꊆ": 6.97,
	"ꊇ": 6.22,
	"ꊈ": 6.22,
	"ꊉ": 5.86,
	"ꊊ": 6.58,
	"ꊋ": 6.58,
	"ꊌ": 6.92,
	"ꊍ": 6.84,
	"ꊎ": 7.41,
	"ꊏ": 7.41,
	"ꊐ": 6.73,
	"ꊑ": 6.83,
	"ꊒ": 6.83,
	"ꊓ": 6.67,
	"ꊔ": 6.56,
	"ꊕ": 6.56,
	"ꊖ": 6.56,
	"ꊗ": 7.41,
	"ꊘ": 6.77,
	"ꊙ": 6.77,
	"ꊚ": 7.25,
	"ꊛ": 6.94,
	"ꊜ": 7.19,
	"ꊝ": 7.19,
	"ꊞ": 6.77,
	"ꊟ": 6.86,
	"ꊠ": 6.86,
	"ꊡ": 6.31,
	"ꊢ": 6.64,
	"ꊣ": 5.75,
	"ꊤ": 5.75,
	"ꊥ": 6.56,
	"ꊦ": 7.81,
	"ꊧ": 7.81,
	"ꊨ": 6.22,
	"ꊩ": 6.5,
	"ꊪ": 6.5,
	"ꊫ": 5.75,
	"ꊬ": 6.59,
	"ꊭ": 6.59,
	"ꊮ": 6.22,
	"ꊯ": 5.81,
	"ꊰ": 5.81,
	"ꊱ": 5.95,
	"ꊲ": 7.14,
	"ꊳ": 6.64,
	"ꊴ": 6.64,
	"ꊵ": 6.66,
	"ꊶ": 7.11,
	"ꊷ": 7.11,
	"ꊸ": 7.11,
	"ꊹ": 8.11,
	"ꊺ": 6.13,
	"ꊻ": 6.13,
	"ꊼ": 6.83,
	"ꊽ": 7.63,
	"ꊾ": 7.56,
	"ꊿ": 7.56,
	"ꋀ": 6.81,
	"ꋁ": 7.11,
	"ꋂ": 7.11,
	"ꋃ": 7.66,
	"ꋄ": 7.16,
	"ꋅ": 7.61,
	"ꋆ": 7.61,
	"ꋇ": 6.78,
	"ꋈ": 7.06,
	"ꋉ": 7.06,
	"ꋊ": 5.88,
	"ꋋ": 7,
	"ꋌ": 7,
	"ꋍ": 6.13,
	"ꋎ": 6.16,
	"ꋏ": 6.16,
	"ꋐ": 6.86,
	"ꋑ": 7.3,
	"ꋒ": 7.3,
	"ꋓ": 6.39,
	"ꋔ": 6.22,
	"ꋕ": 6.64,
	"ꋖ": 6.64,
	"ꋗ": 6.69,
	"ꋘ": 7.06,
	"ꋙ": 6.94,
	"ꋚ": 6.94,
	"ꋛ": 7.06,
	"ꋜ": 6.98,
	"ꋝ": 6.98,
	"ꋞ": 6.5,
	"ꋟ": 7,
	"ꋠ": 7,
	"ꋡ": 6.91,
	"ꋢ": 6.64,
	"ꋣ": 6.64,
	"ꋤ": 6.59,
	"ꋥ": 6.11,
	"ꋦ": 6.11,
	"ꋧ": 7.25,
	"ꋨ": 6.19,
	"ꋩ": 6.19,
	"ꋪ": 6.45,
	"ꋫ": 7.2,
	"ꋬ": 7.2,
	"ꋭ": 6.8,
	"ꋮ": 6.52,
	"ꋯ": 6.52,
	"ꋰ": 6.36,
	"ꋱ": 7.75,
	"ꋲ": 7.75,
	"ꋳ": 7.75,
	"ꋴ": 6.52,
	"ꋵ": 6.52,
	"ꋶ": 6.52,
	"ꋷ": 6.38,
	"ꋸ": 7.17,
	"ꋹ": 7.17,
	"ꋺ": 6.77,
	"ꋻ": 6.77,
	"ꋼ": 5.52,
	"ꋽ": 5.52,
	"ꋾ": 7.17,
	"ꋿ": 7.17,
	"ꌀ": 6.89,
	"ꌁ": 7.36,
	"ꌂ": 7.36,
	"ꌃ": 6.8,
	"ꌄ": 5.73,
	"ꌅ": 5.73,
	"ꌆ": 7.11,
	"ꌇ": 7.36,
	"ꌈ": 7.36,
	"ꌉ": 7.2,
	"ꌊ": 7.17,
	"ꌋ": 7.17,
	"ꌌ": 6.31,
	"ꌍ": 7.61,
	"ꌎ": 7.61,
	"ꌏ": 7.3,
	"ꌐ": 6.25,
	"ꌑ": 6.08,
	"ꌒ": 6.08,
	"ꌓ": 6.63,
	"ꌔ": 5.73,
	"ꌕ": 5.73,
	"ꌖ": 5.73,
	"ꌗ": 6.56,
	"ꌘ": 6.16,
	"ꌙ": 6.16,
	"ꌚ": 6.56,
	"ꌛ": 6.86,
	"ꌜ": 6.86,
	"ꌝ": 6.27,
	"ꌞ": 7.19,
	"ꌟ": 6.17,
	"ꌠ": 6.17,
	"ꌡ": 6.77,
	"ꌢ": 6.63,
	"ꌣ": 6.63,
	"ꌤ": 6.89,
	"ꌥ": 6.89,
	"ꌦ": 6.89,
	"ꌧ": 6.52,
	"ꌨ": 6.89,
	"ꌩ": 6.89,
	"ꌪ": 6,
	"ꌫ": 6.02,
	"ꌬ": 6.02,
	"ꌭ": 6.28,
	"ꌮ": 6.73,
	"ꌯ": 6.73,
	"ꌰ": 6.45,
	"ꌱ": 7.66,
	"ꌲ": 6.64,
	"ꌳ": 6.64,
	"ꌴ": 6.64,
	"ꌵ": 6.53,
	"ꌶ": 7.11,
	"ꌷ": 7.11,
	"ꌸ": 7.88,
	"ꌹ": 6.13,
	"ꌺ": 6.13,
	"ꌻ": 7.11,
	"ꌼ": 6.52,
	"ꌽ": 6.59,
	"ꌾ": 6.59,
	"ꌿ": 7.55,
	"ꍀ": 7.8,
	"ꍁ": 6.61,
	"ꍂ": 6.61,
	"ꍃ": 6.7,
	"ꍄ": 7.36,
	"ꍅ": 7.36,
	"ꍆ": 7,
	"ꍇ": 6.92,
	"ꍈ": 6.92,
	"ꍉ": 6.11,
	"ꍊ": 6.52,
	"ꍋ": 6.52,
	"ꍌ": 6.39,
	"ꍍ": 8.02,
	"ꍎ": 7.61,
	"ꍏ": 7.61,
	"ꍐ": 6.86,
	"ꍑ": 6.25,
	"ꍒ": 6.25,
	"ꍓ": 6.25,
	"ꍔ": 7.36,
	"ꍕ": 7.94,
	"ꍖ": 7.7,
	"ꍗ": 7.7,
	"ꍘ": 7.28,
	"ꍙ": 6.94,
	"ꍚ": 6.94,
	"ꍛ": 6.63,
	"ꍜ": 6.73,
	"ꍝ": 6.73,
	"ꍞ": 6.22,
	"ꍟ": 6.72,
	"ꍠ": 6.72,
	"ꍡ": 6.42,
	"ꍢ": 7.16,
	"ꍣ": 7.16,
	"ꍤ": 6.73,
	"ꍥ": 6.92,
	"ꍦ": 6.47,
	"ꍧ": 6.47,
	"ꍨ": 7.14,
	"ꍩ": 6.78,
	"ꍪ": 6.05,
	"ꍫ": 6.05,
	"ꍬ": 6.31,
	"ꍭ": 6.83,
	"ꍮ": 6.83,
	"ꍯ": 6.83,
	"ꍰ": 6.45,
	"ꍱ": 8.47,
	"ꍲ": 8.47,
	"ꍳ": 7,
	"ꍴ": 6.89,
	"ꍵ": 6.89,
	"ꍶ": 6.7,
	"ꍷ": 6.88,
	"ꍸ": 6.88,
	"ꍹ": 6.42,
	"ꍺ": 6.7,
	"ꍻ": 6.7,
	"ꍼ": 6.77,
	"ꍽ": 6.77,
	"ꍾ": 6.39,
	"ꍿ": 6.39,
	"ꎀ": 7.05,
	"ꎁ": 6.66,
	"ꎂ": 6.66,
	"ꎃ": 7,
	"ꎄ": 6.27,
	"ꎅ": 6.11,
	"ꎆ": 6.11,
	"ꎇ": 6.73,
	"ꎈ": 6.38,
	"ꎉ": 7,
	"ꎊ": 7,
	"ꎋ": 7.61,
	"ꎌ": 6.38,
	"ꎍ": 6.38,
	"ꎎ": 6.8,
	"ꎏ": 6.38,
	"ꎐ": 6.38,
	"ꎑ": 6.17,
	"ꎒ": 6.64,
	"ꎓ": 6.64,
	"ꎔ": 7.11,
	"ꎕ": 7.02,
	"ꎖ": 7.02,
	"ꎗ": 6.22,
	"ꎘ": 7,
	"ꎙ": 7,
	"ꎚ": 7,
	"ꎛ": 6.11,
	"ꎜ": 6.83,
	"ꎝ": 6.83,
	"ꎞ": 7.3,
	"ꎟ": 6.73,
	"ꎠ": 6.77,
	"ꎡ": 6.77,
	"ꎢ": 7.3,
	"ꎣ": 6.88,
	"ꎤ": 6.88,
	"ꎥ": 6.42,
	"ꎦ": 6.8,
	"ꎧ": 6.8,
	"ꎨ": 6.45,
	"ꎩ": 7.17,
	"ꎪ": 7.17,
	"ꎫ": 6.38,
	"ꎬ": 6.83,
	"ꎭ": 6.83,
	"ꎮ": 7.48,
	"ꎯ": 6.05,
	"ꎰ": 6.05,
	"ꎱ": 6,
	"ꎲ": 6.98,
	"ꎳ": 7.17,
	"ꎴ": 7.17,
	"ꎵ": 7.33,
	"ꎶ": 7.2,
	"ꎷ": 6.27,
	"ꎸ": 6.27,
	"ꎹ": 6.27,
	"ꎺ": 6.23,
	"ꎻ": 6.94,
	"ꎼ": 6.94,
	"ꎽ": 6.64,
	"ꎾ": 6.52,
	"ꎿ": 6.52,
	"ꏀ": 6.45,
	"ꏁ": 5.75,
	"ꏂ": 5.75,
	"ꏃ": 7.3,
	"ꏄ": 6.05,
	"ꏅ": 6.05,
	"ꏆ": 7.11,
	"ꏇ": 7.81,
	"ꏈ": 7.81,
	"ꏉ": 6.58,
	"ꏊ": 7.02,
	"ꏋ": 7.02,
	"ꏌ": 6.06,
	"ꏍ": 6.91,
	"ꏎ": 6.77,
	"ꏏ": 6.91,
	"ꏐ": 7.31,
	"ꏑ": 6.7,
	"ꏒ": 6.7,
	"ꏓ": 7.38,
	"ꏔ": 6.05,
	"ꏕ": 6.45,
	"ꏖ": 6.45,
	"ꏗ": 6.42,
	"ꏘ": 6.05,
	"ꏙ": 6.05,
	"ꏚ": 8.42,
	"ꏛ": 6.39,
	"ꏜ": 6.39,
	"ꏝ": 6.94,
	"ꏞ": 6.11,
	"ꏟ": 6.11,
	"ꏠ": 6.73,
	"ꏡ": 6.45,
	"ꏢ": 6.45,
	"ꏣ": 6.8,
	"ꏤ": 6.59,
	"ꏥ": 7.3,
	"ꏦ": 7.3,
	"ꏧ": 6.67,
	"ꏨ": 6.5,
	"ꏩ": 7.17,
	"ꏪ": 7.17,
	"ꏫ": 7.17,
	"ꏬ": 7.66,
	"ꏭ": 7.66,
	"ꏮ": 7.66,
	"ꏯ": 7.17,
	"ꏰ": 7.11,
	"ꏱ": 5.91,
	"ꏲ": 5.91,
	"ꏳ": 6.73,
	"ꏴ": 7.36,
	"ꏵ": 7.36,
	"ꏶ": 6.94,
	"ꏷ": 6.86,
	"ꏸ": 6.86,
	"ꏹ": 5.98,
	"ꏺ": 6.78,
	"ꏻ": 6.78,
	"ꏼ": 7.19,
	"ꏽ": 6.84,
	"ꏾ": 6.84,
	"ꏿ": 7.11,
	"ꐀ": 9.3,
	"ꐁ": 7.3,
	"ꐂ": 7.3,
	"ꐃ": 7.59,
	"ꐄ": 6.39,
	"ꐅ": 6.72,
	"ꐆ": 6.72,
	"ꐇ": 6.72,
	"ꐈ": 6.33,
	"ꐉ": 8.11,
	"ꐊ": 8.11,
	"ꐋ": 7.11,
	"ꐌ": 6.8,
	"ꐍ": 7.11,
	"ꐎ": 7.11,
	"ꐏ": 6.22,
	"ꐐ": 7.11,
	"ꐑ": 7.11,
	"ꐒ": 6.58,
	"ꐓ": 7.3,
	"ꐔ": 7.3,
	"ꐕ": 7.3,
	"ꐖ": 6.66,
	"ꐗ": 6.66,
	"ꐘ": 6.73,
	"ꐙ": 6.16,
	"ꐚ": 6.16,
	"ꐛ": 6.72,
	"ꐜ": 6.89,
	"ꐝ": 6.78,
	"ꐞ": 6.78,
	"ꐟ": 7.41,
	"ꐠ": 6.56,
	"ꐡ": 6.56,
	"ꐢ": 7.86,
	"ꐣ": 7.05,
	"ꐤ": 6.73,
	"ꐥ": 6.73,
	"ꐦ": 6.56,
	"ꐧ": 6.98,
	"ꐨ": 7.92,
	"ꐩ": 7.92,
	"ꐪ": 6.88,
	"ꐫ": 6.73,
	"ꐬ": 6.73,
	"ꐭ": 6.45,
	"ꐮ": 7.44,
	"ꐯ": 7.44,
	"ꐰ": 6.5,
	"ꐱ": 6.38,
	"ꐲ": 6.89,
	"ꐳ": 6.89,
	"ꐴ": 7.2,
	"ꐵ": 7.66,
	"ꐶ": 7.45,
	"ꐷ": 7.45,
	"ꐸ": 6.64,
	"ꐹ": 7.66,
	"ꐺ": 7.66,
	"ꐻ": 7.22,
	"ꐼ": 7.92,
	"ꐽ": 7.92,
	"ꐾ": 6.77,
	"ꐿ": 6.06,
	"ꑀ": 6.06,
	"ꑁ": 6,
	"ꑂ": 6.94,
	"ꑃ": 6.94,
	"ꑄ": 6.5,
	"ꑅ": 6.22,
	"ꑆ": 6.22,
	"ꑇ": 6.13,
	"ꑈ": 6.7,
	"ꑉ": 6.7,
	"ꑊ": 6.86,
	"ꑋ": 5.81,
	"ꑌ": 5.81,
	"ꑍ": 5.73,
	"ꑎ": 7.02,
	"ꑏ": 7.25,
	"ꑐ": 7.25,
	"ꑑ": 6,
	"ꑒ": 6.64,
	"ꑓ": 6.64,
	"ꑔ": 7.08,
	"ꑕ": 6.7,
	"ꑖ": 6.92,
	"ꑗ": 6.92,
	"ꑘ": 6.83,
	"ꑙ": 7.11,
	"ꑚ": 6.38,
	"ꑛ": 6.38,
	"ꑜ": 6.52,
	"ꑝ": 7.66,
	"ꑞ": 7.38,
	"ꑟ": 7.38,
	"ꑠ": 6.5,
	"ꑡ": 7.66,
	"ꑢ": 7.66,
	"ꑣ": 7.66,
	"ꑤ": 8.08,
	"ꑥ": 6.73,
	"ꑦ": 6.73,
	"ꑧ": 7.66,
	"ꑨ": 6.98,
	"ꑩ": 6.98,
	"ꑪ": 7.16,
	"ꑫ": 6.5,
	"ꑬ": 6.45,
	"ꑭ": 6.45,
	"ꑮ": 6.45,
	"ꑯ": 6.45,
	"ꑰ": 6.45,
	"ꑱ": 7.41,
	"ꑲ": 6.98,
	"ꑳ": 6.98,
	"ꑴ": 6.13,
	"ꑵ": 7.41,
	"ꑶ": 6.5,
	"ꑷ": 6.5,
	"ꑸ": 6.88,
	"ꑹ": 6.73,
	"ꑺ": 6.39,
	"ꑻ": 6.39,
	"ꑼ": 6.52,
	"ꑽ": 6.72,
	"ꑾ": 6.73,
	"ꑿ": 6.73,
	"ꒀ": 6.89,
	"ꒁ": 6.42,
	"ꒂ": 7.41,
	"ꒃ": 7.41,
	"ꒄ": 6.38,
	"ꒅ": 6.52,
	"ꒆ": 6.52,
	"ꒇ": 6.5,
	"ꒈ": 6.41,
	"ꒉ": 6.41,
	"ꒊ": 6.59,
	"ꒋ": 6.69,
	"ꒌ": 6.69,
	"꒐": 3.17,
	"꒑": 4.91,
	"꒒": 4.91,
	"꒓": 4.5,
	"꒔": 6.13,
	"꒕": 6.44,
	"꒖": 6.44,
	"꒗": 5.75,
	"꒘": 6,
	"꒙": 6.72,
	"꒚": 6.56,
	"꒛": 4.08,
	"꒜": 7,
	"꒝": 6.73,
	"꒞": 5.8,
	"꒟": 5.42,
	"꒠": 5.98,
	"꒡": 7.67,
	"꒤": 7.36,
	"꒥": 6.47,
	"꒦": 6.81,
	"꒧": 6.83,
	"꒨": 7.11,
	"꒩": 6,
	"꒪": 6.88,
	"꒫": 6.47,
	"꒬": 7.3,
	"꒭": 7.02,
	"꒮": 7.41,
	"꒯": 6.05,
	"꒰": 4.66,
	"꒱": 4.66,
	"꒲": 4.23,
	"꒳": 7.66,
	"꒵": 7.44,
	"꒶": 8.83,
	"꒷": 6.78,
	"꒸": 5.66,
	"꒹": 6.11,
	"꒺": 6.52,
	"꒻": 5.86,
	"꒼": 6.14,
	"꒽": 6.83,
	"꒾": 5.95,
	"꒿": 7.08,
	"꓀": 6.38,
	"꓂": 7.33,
	"꓃": 5.97,
	"꓄": 5.86,
	"꓆": 5.05,
	"가": 10.39,
	"힣": 10.39,
	"": 14.55,
	"": 8.36,
	"豈": 12.27,
	"更": 12.27,
	"車": 12.27,
	"賈": 12.27,
	"滑": 12.27,
	"串": 12.27,
	"句": 12.27,
	"龜": 12.27,
	"龜": 12.27,
	"契": 12.27,
	"金": 12.27,
	"喇": 12.27,
	"奈": 12.27,
	"懶": 12.27,
	"癩": 12.27,
	"羅": 12.27,
	"蘿": 12.27,
	"螺": 12.27,
	"裸": 12.27,
	"邏": 12.27,
	"樂": 12.27,
	"洛": 12.27,
	"烙": 12.27,
	"珞": 12.27,
	"落": 12.27,
	"酪": 12.27,
	"駱": 12.27,
	"亂": 12.27,
	"卵": 12.27,
	"欄": 12.27,
	"爛": 12.27,
	"蘭": 12.27,
	"鸞": 12.27,
	"嵐": 12.27,
	"濫": 12.27,
	"藍": 12.27,
	"襤": 12.27,
	"拉": 12.27,
	"臘": 12.27,
	"蠟": 12.27,
	"廊": 12.27,
	"朗": 12.27,
	"浪": 12.27,
	"狼": 12.27,
	"郎": 12.27,
	"來": 12.27,
	"冷": 12.27,
	"勞": 12.27,
	"擄": 12.27,
	"櫓": 12.27,
	"爐": 12.27,
	"盧": 12.27,
	"老": 12.27,
	"蘆": 12.27,
	"虜": 12.27,
	"路": 12.27,
	"露": 12.27,
	"魯": 12.27,
	"鷺": 12.27,
	"碌": 12.27,
	"祿": 12.27,
	"綠": 12.27,
	"菉": 12.27,
	"錄": 12.27,
	"鹿": 12.27,
	"論": 12.27,
	"壟": 12.27,
	"弄": 12.27,
	"籠": 12.27,
	"聾": 12.27,
	"牢": 12.27,
	"磊": 12.27,
	"賂": 12.27,
	"雷": 12.27,
	"壘": 12.27,
	"屢": 12.27,
	"樓": 12.27,
	"淚": 12.27,
	"漏": 12.27,
	"累": 12.27,
	"縷": 12.27,
	"陋": 12.27,
	"勒": 12.27,
	"肋": 12.27,
	"凜": 12.27,
	"凌": 12.27,
	"稜": 12.27,
	"綾": 12.27,
	"菱": 12.27,
	"陵": 12.27,
	"讀": 12.27,
	"拏": 12.27,
	"樂": 12.27,
	"諾": 12.27,
	"丹": 12.27,
	"寧": 12.27,
	"怒": 12.27,
	"率": 12.27,
	"異": 12.27,
	"北": 12.27,
	"磻": 12.27,
	"便": 12.27,
	"復": 12.27,
	"不": 12.27,
	"泌": 12.27,
	"數": 12.27,
	"索": 12.27,
	"參": 12.27,
	"塞": 12.27,
	"省": 12.27,
	"葉": 12.27,
	"說": 12.27,
	"殺": 12.27,
	"辰": 12.27,
	"沈": 12.27,
	"拾": 12.27,
	"若": 12.27,
	"掠": 12.27,
	"略": 12.27,
	"亮": 12.27,
	"兩": 12.27,
	"凉": 12.27,
	"梁": 12.27,
	"糧": 12.27,
	"良": 12.27,
	"諒": 12.27,
	"量": 12.27,
	"勵": 12.27,
	"呂": 12.27,
	"女": 12.27,
	"廬": 12.27,
	"旅": 12.27,
	"濾": 12.27,
	"礪": 12.27,
	"閭": 12.27,
	"驪": 12.27,
	"麗": 12.27,
	"黎": 12.27,
	"力": 12.27,
	"曆": 12.27,
	"歷": 12.27,
	"轢": 12.27,
	"年": 12.27,
	"憐": 12.27,
	"戀": 12.27,
	"撚": 12.27,
	"漣": 12.27,
	"煉": 12.27,
	"璉": 12.27,
	"秊": 12.27,
	"練": 12.27,
	"聯": 12.27,
	"輦": 12.27,
	"蓮": 12.27,
	"連": 12.27,
	"鍊": 12.27,
	"列": 12.27,
	"劣": 12.27,
	"咽": 12.27,
	"烈": 12.27,
	"裂": 12.27,
	"說": 12.27,
	"廉": 12.27,
	"念": 12.27,
	"捻": 12.27,
	"殮": 12.27,
	"簾": 12.27,
	"獵": 12.27,
	"令": 12.27,
	"囹": 12.27,
	"寧": 12.27,
	"嶺": 12.27,
	"怜": 12.27,
	"玲": 12.27,
	"瑩": 12.27,
	"羚": 12.27,
	"聆": 12.27,
	"鈴": 12.27,
	"零": 12.27,
	"靈": 12.27,
	"領": 12.27,
	"例": 12.27,
	"禮": 12.27,
	"醴": 12.27,
	"隸": 12.27,
	"惡": 12.27,
	"了": 12.27,
	"僚": 12.27,
	"寮": 12.27,
	"尿": 12.27,
	"料": 12.27,
	"樂": 12.27,
	"燎": 12.27,
	"療": 12.27,
	"蓼": 12.27,
	"遼": 12.27,
	"龍": 12.27,
	"暈": 12.27,
	"阮": 12.27,
	"劉": 12.27,
	"杻": 12.27,
	"柳": 12.27,
	"流": 12.27,
	"溜": 12.27,
	"琉": 12.27,
	"留": 12.27,
	"硫": 12.27,
	"紐": 12.27,
	"類": 12.27,
	"六": 12.27,
	"戮": 12.27,
	"陸": 12.27,
	"倫": 12.27,
	"崙": 12.27,
	"淪": 12.27,
	"輪": 12.27,
	"律": 12.27,
	"慄": 12.27,
	"栗": 12.27,
	"率": 12.27,
	"隆": 12.27,
	"利": 12.27,
	"吏": 12.27,
	"履": 12.27,
	"易": 12.27,
	"李": 12.27,
	"梨": 12.27,
	"泥": 12.27,
	"理": 12.27,
	"痢": 12.27,
	"罹": 12.27,
	"裏": 12.27,
	"裡": 12.27,
	"里": 12.27,
	"離": 12.27,
	"匿": 12.27,
	"溺": 12.27,
	"吝": 12.27,
	"燐": 12.27,
	"璘": 12.27,
	"藺": 12.27,
	"隣": 12.27,
	"鱗": 12.27,
	"麟": 12.27,
	"林": 12.27,
	"淋": 12.27,
	"臨": 12.27,
	"立": 12.27,
	"笠": 12.27,
	"粒": 12.27,
	"狀": 12.27,
	"炙": 12.27,
	"識": 12.27,
	"什": 12.27,
	"茶": 12.27,
	"刺": 12.27,
	"切": 12.27,
	"度": 12.27,
	"拓": 12.27,
	"糖": 12.27,
	"宅": 12.27,
	"洞": 12.27,
	"暴": 12.27,
	"輻": 12.27,
	"行": 12.27,
	"降": 12.27,
	"見": 12.27,
	"廓": 12.27,
	"兀": 12.27,
	"嗀": 12.27,
	"﨎": 12.27,
	"﨏": 12.27,
	"塚": 12.27,
	"﨑": 12.27,
	"晴": 12.27,
	"﨓": 12.27,
	"﨔": 12.27,
	"凞": 12.27,
	"猪": 12.27,
	"益": 12.27,
	"礼": 12.27,
	"神": 12.27,
	"祥": 12.27,
	"福": 12.27,
	"靖": 12.27,
	"精": 12.27,
	"羽": 12.27,
	"﨟": 12.27,
	"蘒": 12.27,
	"﨡": 12.27,
	"諸": 12.27,
	"﨣": 12.27,
	"﨤": 12.27,
	"逸": 12.27,
	"都": 12.27,
	"﨧": 12.27,
	"﨨": 12.27,
	"﨩": 12.27,
	"飯": 12.27,
	"飼": 12.27,
	"館": 12.27,
	"鶴": 12.27,
	"ﬀ": 6.94,
	"ﬁ": 7.31,
	"ﬂ": 7.39,
	"ﬃ": 9.59,
	"ﬄ": 9.59,
	"ﬅ": 6.39,
	"ﬆ": 9.11,
	"ﬓ": 14.34,
	"ﬔ": 14.63,
	"ﬕ": 14.59,
	"ﬖ": 14.25,
	"ﬗ": 18.33,
	"יִ": 3.38,
	"ﬞ": 0,
	"ײַ": 5.95,
	"ﬠ": 7.31,
	"ﬡ": 9.69,
	"ﬢ": 8.95,
	"ﬣ": 10.23,
	"ﬤ": 8.3,
	"ﬥ": 8.33,
	"ﬦ": 10.17,
	"ﬧ": 8.97,
	"ﬨ": 10.78,
	"﬩": 7.98,
	"שׁ": 9.48,
	"שׂ": 9.48,
	"שּׁ": 9.48,
	"שּׂ": 9.48,
	"אַ": 7.69,
	"אָ": 7.69,
	"אּ": 7.69,
	"בּ": 7.41,
	"גּ": 5.45,
	"דּ": 6.94,
	"הּ": 8.22,
	"וּ": 3.92,
	"זּ": 5.63,
	"טּ": 8.06,
	"יּ": 3.92,
	"ךּ": 6.95,
	"כּ": 6.3,
	"לּ": 6.33,
	"מּ": 8.22,
	"נּ": 4.83,
	"סּ": 7.84,
	"ףּ": 7.73,
	"פּ": 7.47,
	"צּ": 6.55,
	"קּ": 7.52,
	"רּ": 6.95,
	"שּ": 9.48,
	"תּ": 8.78,
	"וֹ": 3.38,
	"בֿ": 7.41,
	"כֿ": 6.3,
	"פֿ": 7.47,
	"ﭏ": 7.69,
	"ﭐ": 2.86,
	"ﭑ": 3.41,
	"ﭒ": 10.81,
	"ﭓ": 11.34,
	"ﭔ": 3.22,
	"ﭕ": 3.92,
	"ﭖ": 10.81,
	"ﭗ": 11.34,
	"ﭘ": 3.22,
	"ﭙ": 3.92,
	"ﭚ": 10.81,
	"ﭛ": 11.34,
	"ﭜ": 3.22,
	"ﭝ": 3.92,
	"ﭞ": 10.81,
	"ﭟ": 11.34,
	"ﭠ": 3.22,
	"ﭡ": 3.92,
	"ﭢ": 10.81,
	"ﭣ": 11.34,
	"ﭤ": 3.22,
	"ﭥ": 3.92,
	"ﭦ": 10.81,
	"ﭧ": 11.34,
	"ﭨ": 3.22,
	"ﭩ": 3.92,
	"ﭪ": 10.89,
	"ﭫ": 11.25,
	"ﭬ": 5.11,
	"ﭭ": 5.75,
	"ﭮ": 10.89,
	"ﭯ": 11.25,
	"ﭰ": 5.19,
	"ﭱ": 5.75,
	"ﭲ": 7.75,
	"ﭳ": 8.02,
	"ﭴ": 7.98,
	"ﭵ": 8.47,
	"ﭶ": 7.75,
	"ﭷ": 8.02,
	"ﭸ": 7.98,
	"ﭹ": 8.47,
	"ﭺ": 7.75,
	"ﭻ": 8.02,
	"ﭼ": 7.98,
	"ﭽ": 8.47,
	"ﭾ": 7.75,
	"ﭿ": 8.02,
	"ﮀ": 7.98,
	"ﮁ": 8.47,
	"ﮂ": 5.89,
	"ﮃ": 6.94,
	"ﮄ": 5.89,
	"ﮅ": 6.94,
	"ﮆ": 5.89,
	"ﮇ": 6.94,
	"ﮈ": 6.2,
	"ﮉ": 6.94,
	"ﮊ": 4.31,
	"ﮋ": 5.05,
	"ﮌ": 4.31,
	"ﮍ": 5.05,
	"ﮎ": 10.05,
	"ﮏ": 10.95,
	"ﮐ": 5.53,
	"ﮑ": 6.16,
	"ﮒ": 10.05,
	"ﮓ": 10.95,
	"ﮔ": 5.53,
	"ﮕ": 6.16,
	"ﮖ": 10.05,
	"ﮗ": 10.95,
	"ﮘ": 5.53,
	"ﮙ": 6.16,
	"ﮚ": 10.05,
	"ﮛ": 10.95,
	"ﮜ": 5.53,
	"ﮝ": 6.16,
	"ﮞ": 7.39,
	"ﮟ": 8.13,
	"ﮠ": 7.39,
	"ﮡ": 8.13,
	"ﮢ": 3.22,
	"ﮣ": 3.92,
	"ﮤ": 5.25,
	"ﮥ": 6.02,
	"ﮦ": 5.25,
	"ﮧ": 6.64,
	"ﮨ": 3.22,
	"ﮩ": 3.92,
	"ﮪ": 8.2,
	"ﮫ": 6.94,
	"ﮬ": 7.11,
	"ﮭ": 7.72,
	"ﮮ": 7.02,
	"ﮯ": 8,
	"ﮰ": 7.02,
	"ﮱ": 8,
	"ﯓ": 9.77,
	"ﯔ": 10.27,
	"ﯕ": 5.53,
	"ﯖ": 6.16,
	"ﯗ": 5.41,
	"ﯘ": 5.67,
	"ﯙ": 5.42,
	"ﯚ": 5.67,
	"ﯛ": 5.42,
	"ﯜ": 5.67,
	"ﯝ": 5.42,
	"ﯞ": 5.42,
	"ﯟ": 5.67,
	"ﯠ": 5.42,
	"ﯡ": 5.67,
	"ﯢ": 5.42,
	"ﯣ": 5.67,
	"ﯤ": 8.77,
	"ﯥ": 8.11,
	"ﯦ": 3.22,
	"ﯧ": 3.92,
	"ﯨ": 3.22,
	"ﯩ": 3.92,
	"ﯪ": 7.08,
	"ﯫ": 7.08,
	"ﯬ": 7.44,
	"ﯭ": 7.44,
	"ﯮ": 8.25,
	"ﯯ": 8.25,
	"ﯰ": 8.25,
	"ﯱ": 8.25,
	"ﯲ": 8.25,
	"ﯳ": 8.25,
	"ﯴ": 8.25,
	"ﯵ": 8.25,
	"ﯶ": 11.56,
	"ﯷ": 11.56,
	"ﯸ": 7.13,
	"ﯹ": 11.56,
	"ﯺ": 11.56,
	"ﯻ": 7.13,
	"ﯼ": 8.77,
	"ﯽ": 8.23,
	"ﯾ": 3.22,
	"ﯿ": 3.92,
	"ﰀ": 9.84,
	"ﰁ": 9.84,
	"ﰂ": 8.45,
	"ﰃ": 11.56,
	"ﰄ": 11.56,
	"ﰅ": 9.84,
	"ﰆ": 9.84,
	"ﰇ": 9.84,
	"ﰈ": 8.45,
	"ﰉ": 11.56,
	"ﰊ": 11.56,
	"ﰋ": 9.84,
	"ﰌ": 9.84,
	"ﰍ": 9.84,
	"ﰎ": 8.45,
	"ﰏ": 11.56,
	"ﰐ": 11.56,
	"ﰑ": 9.84,
	"ﰒ": 8.45,
	"ﰓ": 11.56,
	"ﰔ": 11.56,
	"ﰕ": 13.66,
	"ﰖ": 12.27,
	"ﰗ": 13.66,
	"ﰘ": 12.27,
	"ﰙ": 13.66,
	"ﰚ": 13.66,
	"ﰛ": 12.27,
	"ﰜ": 15.14,
	"ﰝ": 15.14,
	"ﰞ": 15.14,
	"ﰟ": 13.75,
	"ﰠ": 17.38,
	"ﰡ": 15.98,
	"ﰢ": 17.38,
	"ﰣ": 17.38,
	"ﰤ": 17.38,
	"ﰥ": 15.98,
	"ﰦ": 13.44,
	"ﰧ": 12.05,
	"ﰨ": 12.05,
	"ﰩ": 11.89,
	"ﰪ": 10.5,
	"ﰫ": 11.89,
	"ﰬ": 10.5,
	"ﰭ": 10.61,
	"ﰮ": 10.61,
	"ﰯ": 10.61,
	"ﰰ": 9.22,
	"ﰱ": 12.33,
	"ﰲ": 12.33,
	"ﰳ": 10.61,
	"ﰴ": 9.22,
	"ﰵ": 12.33,
	"ﰶ": 12.33,
	"ﰷ": 8.42,
	"ﰸ": 11.59,
	"ﰹ": 11.59,
	"ﰺ": 11.59,
	"ﰻ": 11.03,
	"ﰼ": 10.22,
	"ﰽ": 13.33,
	"ﰾ": 13.33,
	"ﰿ": 9.08,
	"ﱀ": 9.08,
	"ﱁ": 9.08,
	"ﱂ": 7.69,
	"ﱃ": 10.8,
	"ﱄ": 10.8,
	"ﱅ": 11.55,
	"ﱆ": 11.55,
	"ﱇ": 11.55,
	"ﱈ": 10.16,
	"ﱉ": 13.27,
	"ﱊ": 13.27,
	"ﱋ": 9.84,
	"ﱌ": 9.84,
	"ﱍ": 9.84,
	"ﱎ": 8.45,
	"ﱏ": 11.56,
	"ﱐ": 11.56,
	"ﱑ": 12.52,
	"ﱒ": 11.14,
	"ﱓ": 14.25,
	"ﱔ": 14.25,
	"ﱕ": 9.84,
	"ﱖ": 9.84,
	"ﱗ": 9.84,
	"ﱘ": 8.45,
	"ﱙ": 11.56,
	"ﱚ": 11.56,
	"ﱛ": 4.91,
	"ﱜ": 4.22,
	"ﱝ": 8.77,
	"ﱞ": 0,
	"ﱟ": 0,
	"ﱠ": 0,
	"ﱡ": 0,
	"ﱢ": 0,
	"ﱣ": 0,
	"ﱤ": 8.45,
	"ﱥ": 8.45,
	"ﱦ": 8.45,
	"ﱧ": 9.97,
	"ﱨ": 10.81,
	"ﱩ": 10.72,
	"ﱪ": 8.45,
	"ﱫ": 8.45,
	"ﱬ": 8.45,
	"ﱭ": 8.72,
	"ﱮ": 10.81,
	"ﱯ": 10.72,
	"ﱰ": 8.45,
	"ﱱ": 8.45,
	"ﱲ": 8.45,
	"ﱳ": 8.72,
	"ﱴ": 10.81,
	"ﱵ": 10.72,
	"ﱶ": 8.45,
	"ﱷ": 8.45,
	"ﱸ": 8.45,
	"ﱹ": 9.97,
	"ﱺ": 10.81,
	"ﱻ": 10.72,
	"ﱼ": 12.33,
	"ﱽ": 12.33,
	"ﱾ": 12.33,
	"ﱿ": 12.33,
	"ﲀ": 8.98,
	"ﲁ": 11.08,
	"ﲂ": 10.27,
	"ﲃ": 13.38,
	"ﲄ": 13.38,
	"ﲅ": 7.69,
	"ﲆ": 11.23,
	"ﲇ": 11.23,
	"ﲈ": 8.78,
	"ﲉ": 10.16,
	"ﲊ": 8.45,
	"ﲋ": 8.45,
	"ﲌ": 8.45,
	"ﲍ": 8.72,
	"ﲎ": 10.81,
	"ﲏ": 10.72,
	"ﲐ": 8.23,
	"ﲑ": 8.45,
	"ﲒ": 8.45,
	"ﲓ": 8.45,
	"ﲔ": 8.72,
	"ﲕ": 10.72,
	"ﲖ": 10.72,
	"ﲗ": 10.94,
	"ﲘ": 10.94,
	"ﲙ": 10.94,
	"ﲚ": 8.83,
	"ﲛ": 8.66,
	"ﲜ": 10.94,
	"ﲝ": 10.94,
	"ﲞ": 10.94,
	"ﲟ": 8.83,
	"ﲠ": 8.66,
	"ﲡ": 10.94,
	"ﲢ": 10.94,
	"ﲣ": 10.94,
	"ﲤ": 8.83,
	"ﲥ": 8.66,
	"ﲦ": 8.83,
	"ﲧ": 14.75,
	"ﲨ": 12.64,
	"ﲩ": 14.75,
	"ﲪ": 12.64,
	"ﲫ": 14.75,
	"ﲬ": 12.64,
	"ﲭ": 16.25,
	"ﲮ": 16.25,
	"ﲯ": 16.25,
	"ﲰ": 14.14,
	"ﲱ": 18.47,
	"ﲲ": 18.47,
	"ﲳ": 16.36,
	"ﲴ": 18.47,
	"ﲵ": 18.47,
	"ﲶ": 18.47,
	"ﲷ": 16.36,
	"ﲸ": 14.55,
	"ﲹ": 12.44,
	"ﲺ": 12.98,
	"ﲻ": 10.89,
	"ﲼ": 12.98,
	"ﲽ": 10.89,
	"ﲾ": 11.7,
	"ﲿ": 11.7,
	"ﳀ": 11.7,
	"ﳁ": 9.61,
	"ﳂ": 11.7,
	"ﳃ": 9.61,
	"ﳄ": 12.7,
	"ﳅ": 12.7,
	"ﳆ": 12.7,
	"ﳇ": 8.13,
	"ﳈ": 10.59,
	"ﳉ": 10.17,
	"ﳊ": 10.17,
	"ﳋ": 10.17,
	"ﳌ": 4.48,
	"ﳍ": 7.89,
	"ﳎ": 12.64,
	"ﳏ": 12.64,
	"ﳐ": 12.64,
	"ﳑ": 10.55,
	"ﳒ": 10.94,
	"ﳓ": 10.94,
	"ﳔ": 10.94,
	"ﳕ": 8.83,
	"ﳖ": 8.66,
	"ﳗ": 13.63,
	"ﳘ": 11.52,
	"ﳙ": 7.11,
	"ﳚ": 10.94,
	"ﳛ": 10.94,
	"ﳜ": 10.94,
	"ﳝ": 8.83,
	"ﳞ": 8.66,
	"ﳟ": 8.83,
	"ﳠ": 8.66,
	"ﳡ": 8.83,
	"ﳢ": 8.66,
	"ﳣ": 8.83,
	"ﳤ": 8.66,
	"ﳥ": 8.83,
	"ﳦ": 8.66,
	"ﳧ": 14.11,
	"ﳨ": 13.94,
	"ﳩ": 14.11,
	"ﳪ": 13.94,
	"ﳫ": 8.17,
	"ﳬ": 10.66,
	"ﳭ": 8.06,
	"ﳮ": 8.83,
	"ﳯ": 8.66,
	"ﳰ": 8.83,
	"ﳱ": 8.66,
	"ﳲ": 3.55,
	"ﳳ": 3.55,
	"ﳴ": 3.55,
	"ﳵ": 15.17,
	"ﳶ": 15.17,
	"ﳷ": 13.61,
	"ﳸ": 13.61,
	"ﳹ": 13.61,
	"ﳺ": 13.61,
	"ﳻ": 15.8,
	"ﳼ": 15.72,
	"ﳽ": 15.8,
	"ﳾ": 15.72,
	"ﳿ": 15.38,
	"ﴀ": 15.38,
	"ﴁ": 15.38,
	"ﴂ": 15.38,
	"ﴃ": 15.38,
	"ﴄ": 15.38,
	"ﴅ": 16.91,
	"ﴆ": 16.83,
	"ﴇ": 16.91,
	"ﴈ": 16.83,
	"ﴉ": 15.14,
	"ﴊ": 15.14,
	"ﴋ": 15.14,
	"ﴌ": 13.75,
	"ﴍ": 13.77,
	"ﴎ": 13.77,
	"ﴏ": 15.98,
	"ﴐ": 15.98,
	"ﴑ": 15.19,
	"ﴒ": 15.19,
	"ﴓ": 13.09,
	"ﴔ": 13.09,
	"ﴕ": 13.09,
	"ﴖ": 13.09,
	"ﴗ": 16.58,
	"ﴘ": 16.5,
	"ﴙ": 16.58,
	"ﴚ": 16.5,
	"ﴛ": 15.38,
	"ﴜ": 15.38,
	"ﴝ": 15.38,
	"ﴞ": 15.38,
	"ﴟ": 15.38,
	"ﴠ": 15.38,
	"ﴡ": 17.48,
	"ﴢ": 17.42,
	"ﴣ": 17.48,
	"ﴤ": 17.42,
	"ﴥ": 15.11,
	"ﴦ": 15.11,
	"ﴧ": 15.11,
	"ﴨ": 13.73,
	"ﴩ": 13.73,
	"ﴪ": 13.73,
	"ﴫ": 16.02,
	"ﴬ": 16.02,
	"ﴭ": 16.25,
	"ﴮ": 16.25,
	"ﴯ": 16.25,
	"ﴰ": 14.14,
	"ﴱ": 13.95,
	"ﴲ": 13.95,
	"ﴳ": 12.44,
	"ﴴ": 16.22,
	"ﴵ": 16.22,
	"ﴶ": 16.22,
	"ﴷ": 16.22,
	"ﴸ": 16.22,
	"ﴹ": 16.22,
	"ﴺ": 12.47,
	"ﴻ": 12.47,
	"ﴼ": 4.73,
	"ﴽ": 2.91,
	"﴾": 4.41,
	"﴿": 4.41,
	"ﵐ": 16.2,
	"ﵑ": 17.2,
	"ﵒ": 18.31,
	"ﵓ": 16.2,
	"ﵔ": 16.2,
	"ﵕ": 16.2,
	"ﵖ": 16.2,
	"ﵗ": 16.2,
	"ﵘ": 18.92,
	"ﵙ": 20.02,
	"ﵚ": 20.64,
	"ﵛ": 20.64,
	"ﵜ": 23.63,
	"ﵝ": 23.63,
	"ﵞ": 24.22,
	"ﵟ": 20.39,
	"ﵠ": 21.52,
	"ﵡ": 21.52,
	"ﵢ": 19,
	"ﵣ": 19.41,
	"ﵤ": 24.77,
	"ﵥ": 25.84,
	"ﵦ": 21.28,
	"ﵧ": 21.09,
	"ﵨ": 21.52,
	"ﵩ": 24.22,
	"ﵪ": 20.39,
	"ﵫ": 21.52,
	"ﵬ": 19,
	"ﵭ": 19.41,
	"ﵮ": 26.5,
	"ﵯ": 23.38,
	"ﵰ": 23.73,
	"ﵱ": 18.73,
	"ﵲ": 19.81,
	"ﵳ": 17.7,
	"ﵴ": 20.45,
	"ﵵ": 17.34,
	"ﵶ": 15.25,
	"ﵷ": 16.16,
	"ﵸ": 18.36,
	"ﵹ": 15.25,
	"ﵺ": 18.36,
	"ﵻ": 18.36,
	"ﵼ": 16.59,
	"ﵽ": 16.98,
	"ﵾ": 15.88,
	"ﵿ": 14.48,
	"ﶀ": 15.06,
	"ﶁ": 18.17,
	"ﶂ": 18.17,
	"ﶃ": 17.55,
	"ﶄ": 16.45,
	"ﶅ": 15.06,
	"ﶆ": 15.44,
	"ﶇ": 14.34,
	"ﶈ": 15.44,
	"ﶉ": 20.02,
	"ﶊ": 17.92,
	"ﶋ": 20.64,
	"ﶌ": 20.02,
	"ﶍ": 17.92,
	"ﶎ": 20.02,
	"ﶏ": 17.92,
	"ﶒ": 20.02,
	"ﶓ": 18.89,
	"ﶔ": 16.78,
	"ﶕ": 16.2,
	"ﶖ": 18.94,
	"ﶗ": 15.83,
	"ﶘ": 16.2,
	"ﶙ": 18.94,
	"ﶚ": 16.83,
	"ﶛ": 16.83,
	"ﶜ": 13.72,
	"ﶝ": 14.11,
	"ﶞ": 18.94,
	"ﶟ": 18.94,
	"ﶠ": 18.94,
	"ﶡ": 18.94,
	"ﶢ": 18.94,
	"ﶣ": 16.83,
	"ﶤ": 16.83,
	"ﶥ": 20.64,
	"ﶦ": 22.75,
	"ﶧ": 20.64,
	"ﶨ": 24.22,
	"ﶩ": 26.5,
	"ﶪ": 24.22,
	"ﶫ": 26.5,
	"ﶬ": 18.17,
	"ﶭ": 16.06,
	"ﶮ": 18.94,
	"ﶯ": 18.94,
	"ﶰ": 16.83,
	"ﶱ": 18.55,
	"ﶲ": 17.59,
	"ﶳ": 18.94,
	"ﶴ": 16.98,
	"ﶵ": 15.44,
	"ﶶ": 18.36,
	"ﶷ": 18.64,
	"ﶸ": 18.31,
	"ﶹ": 20.64,
	"ﶺ": 15.44,
	"ﶻ": 15.53,
	"ﶼ": 15.06,
	"ﶽ": 17.2,
	"ﶾ": 22.75,
	"ﶿ": 22.75,
	"ﷀ": 20.64,
	"ﷁ": 17.59,
	"ﷂ": 18.94,
	"ﷃ": 15.86,
	"ﷄ": 18.25,
	"ﷅ": 21.63,
	"ﷆ": 24.22,
	"ﷇ": 18.94,
	"ﷰ": 20.91,
	"ﷱ": 14.14,
	"ﷲ": 14.36,
	"ﷳ": 17.3,
	"ﷴ": 9.17,
	"ﷵ": 23.86,
	"ﷶ": 24.16,
	"ﷷ": 15.84,
	"ﷸ": 21.25,
	"ﷹ": 21.89,
	"ﷺ": 12.69,
	"ﷻ": 19.28,
	"︠": 12.27,
	"︡": 12.27,
	"︢": 12.27,
	"︣": 12.27,
	"︰": 12.27,
	"︱": 12.27,
	"︲": 12.27,
	"︳": 12.27,
	"︴": 12.27,
	"︵": 12.27,
	"︶": 12.27,
	"︷": 12.27,
	"︸": 12.27,
	"︹": 12.27,
	"︺": 12.27,
	"︻": 12.27,
	"︼": 12.27,
	"︽": 12.27,
	"︾": 12.27,
	"︿": 12.27,
	"﹀": 12.27,
	"﹁": 12.27,
	"﹂": 12.27,
	"﹃": 12.27,
	"﹄": 12.27,
	"﹉": 12.27,
	"﹊": 12.27,
	"﹋": 12.27,
	"﹌": 12.27,
	"﹍": 12.27,
	"﹎": 12.27,
	"﹏": 12.27,
	"﹐": 12.27,
	"﹑": 12.27,
	"﹒": 12.27,
	"﹔": 12.27,
	"﹕": 12.27,
	"﹖": 12.27,
	"﹗": 12.27,
	"﹘": 12.27,
	"﹙": 12.27,
	"﹚": 12.27,
	"﹛": 12.27,
	"﹜": 12.27,
	"﹝": 12.27,
	"﹞": 12.27,
	"﹟": 12.27,
	"﹠": 12.27,
	"﹡": 12.27,
	"﹢": 12.27,
	"﹣": 12.27,
	"﹤": 12.27,
	"﹥": 12.27,
	"﹦": 12.27,
	"﹨": 12.27,
	"﹩": 12.27,
	"﹪": 12.27,
	"﹫": 12.27,
	"ﹰ": 0,
	"ﹱ": 3.55,
	"ﹲ": 0,
	"ﹴ": 0,
	"ﹶ": 0,
	"ﹷ": 3.55,
	"ﹸ": 0,
	"ﹹ": 3.55,
	"ﹺ": 0,
	"ﹻ": 3.55,
	"ﹼ": 0,
	"ﹽ": 3.55,
	"ﹾ": 0,
	"ﹿ": 3.55,
	"ﺀ": 5.06,
	"ﺁ": 2.86,
	"ﺂ": 3.41,
	"ﺃ": 2.86,
	"ﺄ": 3.41,
	"ﺅ": 5.42,
	"ﺆ": 5.67,
	"ﺇ": 2.86,
	"ﺈ": 3.41,
	"ﺉ": 8.77,
	"ﺊ": 8.23,
	"ﺋ": 3.22,
	"ﺌ": 3.92,
	"ﺍ": 2.86,
	"ﺎ": 3.41,
	"ﺏ": 10.81,
	"ﺐ": 11.34,
	"ﺑ": 3.22,
	"ﺒ": 3.92,
	"ﺓ": 5.25,
	"ﺔ": 6.02,
	"ﺕ": 10.81,
	"ﺖ": 11.34,
	"ﺗ": 3.22,
	"ﺘ": 3.92,
	"ﺙ": 10.81,
	"ﺚ": 11.34,
	"ﺛ": 3.22,
	"ﺜ": 3.92,
	"ﺝ": 7.75,
	"ﺞ": 8.02,
	"ﺟ": 7.98,
	"ﺠ": 8.47,
	"ﺡ": 7.75,
	"ﺢ": 8.02,
	"ﺣ": 7.98,
	"ﺤ": 8.47,
	"ﺥ": 7.75,
	"ﺦ": 8.02,
	"ﺧ": 7.98,
	"ﺨ": 8.47,
	"ﺩ": 5.89,
	"ﺪ": 6.94,
	"ﺫ": 5.86,
	"ﺬ": 6.94,
	"ﺭ": 4.31,
	"ﺮ": 5.05,
	"ﺯ": 4.22,
	"ﺰ": 5.05,
	"ﺱ": 12.94,
	"ﺲ": 13.72,
	"ﺳ": 8.61,
	"ﺴ": 9.39,
	"ﺵ": 12.94,
	"ﺶ": 13.72,
	"ﺷ": 8.61,
	"ﺸ": 9.39,
	"ﺹ": 13.67,
	"ﺺ": 14.27,
	"ﺻ": 10.09,
	"ﺼ": 10.7,
	"ﺽ": 13.67,
	"ﺾ": 14.27,
	"ﺿ": 10.09,
	"ﻀ": 10.7,
	"ﻁ": 9.05,
	"ﻂ": 9.64,
	"ﻃ": 7.95,
	"ﻄ": 8.55,
	"ﻅ": 9.05,
	"ﻆ": 9.64,
	"ﻇ": 7.95,
	"ﻈ": 8.55,
	"ﻉ": 7.14,
	"ﻊ": 6.75,
	"ﻋ": 6.14,
	"ﻌ": 6.41,
	"ﻍ": 7.14,
	"ﻎ": 6.75,
	"ﻏ": 6.14,
	"ﻐ": 6.41,
	"ﻑ": 10.89,
	"ﻒ": 11.25,
	"ﻓ": 5.19,
	"ﻔ": 5.75,
	"ﻕ": 8.19,
	"ﻖ": 8.47,
	"ﻗ": 5.19,
	"ﻘ": 5.75,
	"ﻙ": 9.77,
	"ﻚ": 10.27,
	"ﻛ": 5.53,
	"ﻜ": 6.16,
	"ﻝ": 7.53,
	"ﻞ": 8.06,
	"ﻟ": 3.41,
	"ﻠ": 3.94,
	"ﻡ": 6.19,
	"ﻢ": 8.11,
	"ﻣ": 6.05,
	"ﻤ": 7.11,
	"ﻥ": 7.39,
	"ﻦ": 8.13,
	"ﻧ": 3.22,
	"ﻨ": 3.92,
	"ﻩ": 4.22,
	"ﻪ": 6.02,
	"ﻫ": 7.11,
	"ﻬ": 5.66,
	"ﻭ": 5.42,
	"ﻮ": 5.67,
	"ﻯ": 8.77,
	"ﻰ": 8.23,
	"ﻱ": 8.77,
	"ﻲ": 8.11,
	"ﻳ": 3.22,
	"ﻴ": 3.92,
	"ﻵ": 6.45,
	"ﻶ": 7.14,
	"ﻷ": 6.45,
	"ﻸ": 7.14,
	"ﻹ": 6.45,
	"ﻺ": 7.06,
	"ﻻ": 6.45,
	"ﻼ": 7.06,
	"！": 12.27,
	"＂": 12.27,
	"＃": 12.27,
	"＄": 12.27,
	"％": 12.27,
	"＆": 12.27,
	"＇": 12.27,
	"（": 12.27,
	"）": 12.27,
	"＊": 12.27,
	"＋": 12.27,
	"，": 12.27,
	"－": 12.27,
	"．": 12.27,
	"／": 12.27,
	"０": 12.27,
	"１": 12.27,
	"２": 12.27,
	"３": 12.27,
	"４": 12.27,
	"５": 12.27,
	"６": 12.27,
	"７": 12.27,
	"８": 12.27,
	"９": 12.27,
	"：": 12.27,
	"；": 12.27,
	"＜": 12.27,
	"＝": 12.27,
	"＞": 12.27,
	"？": 12.27,
	"＠": 12.27,
	"Ａ": 12.27,
	"Ｂ": 12.27,
	"Ｃ": 12.27,
	"Ｄ": 12.27,
	"Ｅ": 12.27,
	"Ｆ": 12.27,
	"Ｇ": 12.27,
	"Ｈ": 12.27,
	"Ｉ": 12.27,
	"Ｊ": 12.27,
	"Ｋ": 12.27,
	"Ｌ": 12.27,
	"Ｍ": 12.27,
	"Ｎ": 12.27,
	"Ｏ": 12.27,
	"Ｐ": 12.27,
	"Ｑ": 12.27,
	"Ｒ": 12.27,
	"Ｓ": 12.27,
	"Ｔ": 12.27,
	"Ｕ": 12.27,
	"Ｖ": 12.27,
	"Ｗ": 12.27,
	"Ｘ": 12.27,
	"Ｙ": 12.27,
	"Ｚ": 12.27,
	"［": 12.27,
	"＼": 12.27,
	"］": 12.27,
	"＾": 12.27,
	"＿": 12.27,
	"｀": 12.27,
	"ａ": 12.27,
	"ｂ": 12.27,
	"ｃ": 12.27,
	"ｄ": 12.27,
	"ｅ": 12.27,
	"ｆ": 12.27,
	"ｇ": 12.27,
	"ｈ": 12.27,
	"ｉ": 12.27,
	"ｊ": 12.27,
	"ｋ": 12.27,
	"ｌ": 12.27,
	"ｍ": 12.27,
	"ｎ": 12.27,
	"ｏ": 12.27,
	"ｐ": 12.27,
	"ｑ": 12.27,
	"ｒ": 12.27,
	"ｓ": 12.27,
	"ｔ": 12.27,
	"ｕ": 12.27,
	"ｖ": 12.27,
	"ｗ": 12.27,
	"ｘ": 12.27,
	"ｙ": 12.27,
	"ｚ": 12.27,
	"｛": 12.27,
	"｜": 12.27,
	"｝": 12.27,
	"～": 12.27,
	"｡": 6.27,
	"｢": 6.27,
	"｣": 6.27,
	"､": 6.27,
	"･": 6.27,
	"ｦ": 6.27,
	"ｧ": 6.27,
	"ｨ": 6.27,
	"ｩ": 6.27,
	"ｪ": 6.27,
	"ｫ": 6.27,
	"ｬ": 6.27,
	"ｭ": 6.27,
	"ｮ": 6.27,
	"ｯ": 6.27,
	"ｰ": 6.27,
	"ｱ": 6.27,
	"ｲ": 6.27,
	"ｳ": 6.27,
	"ｴ": 6.27,
	"ｵ": 6.27,
	"ｶ": 6.27,
	"ｷ": 6.27,
	"ｸ": 6.27,
	"ｹ": 6.27,
	"ｺ": 6.27,
	"ｻ": 6.27,
	"ｼ": 6.27,
	"ｽ": 6.27,
	"ｾ": 6.27,
	"ｿ": 6.27,
	"ﾀ": 6.27,
	"ﾁ": 6.27,
	"ﾂ": 6.27,
	"ﾃ": 6.27,
	"ﾄ": 6.27,
	"ﾅ": 6.27,
	"ﾆ": 6.27,
	"ﾇ": 6.27,
	"ﾈ": 6.27,
	"ﾉ": 6.27,
	"ﾊ": 6.27,
	"ﾋ": 6.27,
	"ﾌ": 6.27,
	"ﾍ": 6.27,
	"ﾎ": 6.27,
	"ﾏ": 6.27,
	"ﾐ": 6.27,
	"ﾑ": 6.27,
	"ﾒ": 6.27,
	"ﾓ": 6.27,
	"ﾔ": 6.27,
	"ﾕ": 6.27,
	"ﾖ": 6.27,
	"ﾗ": 6.27,
	"ﾘ": 6.27,
	"ﾙ": 6.27,
	"ﾚ": 6.27,
	"ﾛ": 6.27,
	"ﾜ": 6.27,
	"ﾝ": 6.27,
	"ﾞ": 6.27,
	"ﾟ": 6.27,
	"ﾠ": 0,
	"ﾡ": 5.7,
	"ﾢ": 6,
	"ﾣ": 6,
	"ﾤ": 5.7,
	"ﾥ": 6,
	"ﾦ": 6,
	"ﾧ": 5.7,
	"ﾨ": 6,
	"ﾩ": 6,
	"ﾪ": 6,
	"ﾫ": 6,
	"ﾬ": 6,
	"ﾭ": 6,
	"ﾮ": 6,
	"ﾯ": 6,
	"ﾰ": 6,
	"ﾱ": 6,
	"ﾲ": 6,
	"ﾳ": 6,
	"ﾴ": 6,
	"ﾵ": 6,
	"ﾶ": 6,
	"ﾷ": 6,
	"ﾸ": 6,
	"ﾹ": 6,
	"ﾺ": 6,
	"ﾻ": 6,
	"ﾼ": 6,
	"ﾽ": 6,
	"ﾾ": 6,
	"ￂ": 6,
	"ￃ": 6,
	"ￄ": 6,
	"ￅ": 6,
	"ￆ": 6,
	"ￇ": 6,
	"ￊ": 6,
	"ￋ": 6,
	"ￌ": 6,
	"ￍ": 6,
	"ￎ": 6,
	"ￏ": 6,
	"ￒ": 6,
	"ￓ": 6,
	"ￔ": 6,
	"ￕ": 6,
	"ￖ": 6,
	"ￗ": 6,
	"ￚ": 6,
	"ￛ": 6,
	"ￜ": 6,
	"￠": 12.27,
	"￡": 12.27,
	"￢": 12.27,
	"￣": 12.27,
	"￤": 12.27,
	"￥": 12.27,
	"￦": 12.27,
	"￨": 12.27,
	"￩": 6,
	"￪": 6,
	"￫": 6,
	"￬": 6,
	"￭": 6.27,
	"￮": 6,
	"￹": 0,
	"￺": 0,
	"￻": 0,
	"￼": 0
};

export { $, A, B, C, D, E, F, G, H, I, J, K, L, M, N, O, P, Q, R, S, T, U, V, W, X, Y, Z, _, a, b, c, d, characterWidths as default, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v, w, x, y, z };
